import { Validators, FormControl, FormBuilder, FormGroup, AbstractControl, ReactiveFormsModule, FormsModule } from '@angular/forms';
import { ClaimValues, ClaimsService } from '@mt-ng2/auth-module';
import { ComponentErrorHandler } from '@mt-ng2/component-error-handler';
import { ɵɵdefineInjectable, ɵɵinject, Injectable, Optional, Inject, EventEmitter, ChangeDetectorRef, ViewChild, Component, Injector, Output, Directive, ComponentFactoryResolver, ViewContainerRef, Input, ElementRef, HostListener, NgModule } from '@angular/core';
import { Subscription, forkJoin } from 'rxjs';
import { DynamicFormModuleConfigToken } from '@mt-ng2/dynamic-form-config';
import { formatPhone } from '@mt-ng2/format-functions';
import { DatePipe, CurrencyPipe, CommonModule } from '@angular/common';
import { NgbDate, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { DateParts } from '@mt-ng2/date-module';
import { MultiselectItem, MultiselectControlModule } from '@mt-ng2/multiselect-control';
import { pluralize } from '@mt-ng2/common-functions';
import { DomSanitizer } from '@angular/platform-browser';
import { TypeAheadModule } from '@mt-ng2/type-ahead-control';
import { MtColorPickerControlModule } from '@mt-ng2/color-picker-control';
import { WysiwygModule } from '@mt-ng2/wysiwyg-control';
import { TimepickerControlModule } from '@mt-ng2/timepicker-control';
import { NumericControlModule } from '@mt-ng2/numeric-control';

/**
 * Returns invalid for a control even if 0 is passed.
 * @param control
 */
import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@angular/forms';
import * as ɵngcc2 from '@angular/common';
import * as ɵngcc3 from '@mt-ng2/numeric-control';
import * as ɵngcc4 from '@mt-ng2/type-ahead-control';
import * as ɵngcc5 from '@ng-bootstrap/ng-bootstrap';
import * as ɵngcc6 from '@mt-ng2/timepicker-control';
import * as ɵngcc7 from 'ngx-color-picker';
import * as ɵngcc8 from '@mt-ng2/wysiwyg-control';
import * as ɵngcc9 from '@mt-ng2/multiselect-control';
import * as ɵngcc10 from '@mt-ng2/auth-module';
import * as ɵngcc11 from '@angular/platform-browser';

const _c0 = ["inputElement"];
function FormTextboxComponent_span_7_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span", 5);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵstyleProp("visibility", ctx_r1.isFocused && ctx_r1.hasMaxLength() ? null : "hidden");
    ɵngcc0.ɵɵclassProp("errortext", ctx_r1.hasError("maxlength"))("inside-box-maxlength", ctx_r1.config.insideBoxValidation);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ctx_r1.getMaxLengthText());
} }
function FormTextboxComponent_span_9_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span", 5);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵstyleProp("visibility", ctx_r2.isFocused && ctx_r2.hasMaxLength() ? null : "hidden");
    ɵngcc0.ɵɵclassProp("errortext", ctx_r2.hasError("maxlength"))("inside-box-maxlength", ctx_r2.config.insideBoxValidation);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ctx_r2.getMaxLengthText());
} }
function FormNumericComponent_span_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "span", 5);
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("innerHTML", ctx_r0.getNumericAddOn(), ɵngcc0.ɵɵsanitizeHtml);
} }
function FormNumericComponent_span_9_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "span", 5);
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("innerHTML", ctx_r1.getNumericAddOn(), ɵngcc0.ɵɵsanitizeHtml);
} }
function FormNumericComponent_span_12_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span", 6);
    ɵngcc0.ɵɵtext(1, "spacer");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    ɵngcc0.ɵɵstyleProp("visibility", "hidden");
} }
const _c1 = ["input"];
function FormPasswordComponent_i_7_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "i", 11);
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("title", ctx_r0.config.failedPatternMessage);
} }
function FormPasswordComponent_span_9_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span", 12);
    ɵngcc0.ɵɵtext(1, " *");
    ɵngcc0.ɵɵelementEnd();
} }
function FormPasswordComponent_span_11_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span", 13);
    ɵngcc0.ɵɵtext(1, "\n            ");
    ɵngcc0.ɵɵelementStart(2, "em");
    ɵngcc0.ɵɵtext(3, "optional");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtext(4, "\n        ");
    ɵngcc0.ɵɵelementEnd();
} }
function FormPasswordComponent_span_19_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span", 14);
    ɵngcc0.ɵɵtext(1, "spacer");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    ɵngcc0.ɵɵstyleProp("visibility", "hidden");
} }
function FormCheckBoxComponent_span_2_Template(rf, ctx) { if (rf & 1) {
    const _r4 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "span", 6);
    ɵngcc0.ɵɵtext(1, "\n        ");
    ɵngcc0.ɵɵelementStart(2, "span", 7);
    ɵngcc0.ɵɵlistener("click", function FormCheckBoxComponent_span_2_Template_span_click_2_listener() { ɵngcc0.ɵɵrestoreView(_r4); const ctx_r3 = ɵngcc0.ɵɵnextContext(); return ctx_r3.labelClicked(); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtext(3, "\n    ");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("ngClass", "col-sm-" + ctx_r0.config.labelCols);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("innerHTML", ctx_r0.config.labelHtml, ɵngcc0.ɵɵsanitizeHtml);
} }
function FormCheckBoxComponent_span_9_Template(rf, ctx) { if (rf & 1) {
    const _r6 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "span", 7);
    ɵngcc0.ɵɵlistener("click", function FormCheckBoxComponent_span_9_Template_span_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r6); const ctx_r5 = ɵngcc0.ɵɵnextContext(); return ctx_r5.labelClicked(); });
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("innerHTML", ctx_r2.config.labelHtml, ɵngcc0.ɵɵsanitizeHtml);
} }
function FormTypeAheadComponent_span_7_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span", 4);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵstyleProp("visibility", ctx_r0.isFocused && ctx_r0.hasMaxLength() ? null : "hidden");
    ɵngcc0.ɵɵclassProp("errortext", ctx_r0.hasError("maxlength"))("inside-box-maxlength", ctx_r0.config.insideBoxValidation);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ctx_r0.getMaxLengthText());
} }
function FormTypeAheadComponent_span_9_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span", 4);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵstyleProp("visibility", ctx_r1.isFocused && ctx_r1.hasMaxLength() ? null : "hidden");
    ɵngcc0.ɵɵclassProp("errortext", ctx_r1.hasError("maxlength"))("inside-box-maxlength", ctx_r1.config.insideBoxValidation);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ctx_r1.getMaxLengthText());
} }
const _c2 = ".inside-box-maxlength[_ngcontent-%COMP%] {\n                position: relative !important;\n                bottom: -13px;\n                top: -13px;\n                margin-bottom: -13px;\n                right: 3px;\n                font-size: 70%;\n            }";
function FormPhoneComponent_span_9_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span", 6);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵstyleProp("visibility", ctx_r1.isFocused && ctx_r1.hasMaxLength() ? null : "hidden");
    ɵngcc0.ɵɵclassProp("errortext", ctx_r1.hasError("maxlength"))("inside-box-maxlength", ctx_r1.config.insideBoxValidation);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ctx_r1.getMaxLengthText());
} }
function FormPhoneComponent_span_11_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span", 6);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵstyleProp("visibility", ctx_r2.isFocused && ctx_r2.hasMaxLength() ? null : "hidden");
    ɵngcc0.ɵɵclassProp("errortext", ctx_r2.hasError("maxlength"))("inside-box-maxlength", ctx_r2.config.insideBoxValidation);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ctx_r2.getMaxLengthText());
} }
function FormTextareaComponent_span_7_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span", 5);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵstyleProp("visibility", ctx_r1.isFocused && ctx_r1.hasMaxLength() ? null : "hidden");
    ɵngcc0.ɵɵclassProp("errortext", ctx_r1.hasError("maxlength"))("inside-box-maxlength", ctx_r1.config.insideBoxValidation);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ctx_r1.getMaxLengthText());
} }
function FormTextareaComponent_span_9_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span", 5);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵstyleProp("visibility", ctx_r2.isFocused && ctx_r2.hasMaxLength() ? null : "hidden");
    ɵngcc0.ɵɵclassProp("errortext", ctx_r2.hasError("maxlength"))("inside-box-maxlength", ctx_r2.config.insideBoxValidation);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ctx_r2.getMaxLengthText());
} }
const _c3 = ["datePicker"];
function FormDatePickerComponent_button_13_Template(rf, ctx) { if (rf & 1) {
    const _r7 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "button", 10);
    ɵngcc0.ɵɵlistener("click", function FormDatePickerComponent_button_13_Template_button_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r7); const ctx_r6 = ɵngcc0.ɵɵnextContext(); return ctx_r6.clear(); });
    ɵngcc0.ɵɵelement(1, "i", 11);
    ɵngcc0.ɵɵelementEnd();
} }
function FormDatePickerComponent_ng_template_25_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵtext(0, "\n    ");
    ɵngcc0.ɵɵelementStart(1, "div", 12);
    ɵngcc0.ɵɵtext(2, "\n        ");
    ɵngcc0.ɵɵelementStart(3, "span");
    ɵngcc0.ɵɵtext(4);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtext(5, "\n    ");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtext(6, "\n");
} if (rf & 2) {
    const date_r8 = ctx.date;
    const selected_r9 = ctx.selected;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵclassProp("selected-date", selected_r9);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate(date_r8.day);
} }
const _c4 = function () { return { standalone: true }; };
const _c5 = ["timePicker"];
function FormTimePickerComponent_button_13_Template(rf, ctx) { if (rf & 1) {
    const _r3 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "button", 7);
    ɵngcc0.ɵɵlistener("click", function FormTimePickerComponent_button_13_Template_button_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r3); const ctx_r2 = ɵngcc0.ɵɵnextContext(); return ctx_r2.clear(); });
    ɵngcc0.ɵɵelement(1, "i", 8);
    ɵngcc0.ɵɵelementEnd();
} }
function FormDatetimePickerComponent_dynamic_field_4_Template(rf, ctx) { if (rf & 1) {
    const _r3 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "dynamic-field", 3);
    ɵngcc0.ɵɵlistener("blur", function FormDatetimePickerComponent_dynamic_field_4_Template_dynamic_field_blur_0_listener() { ɵngcc0.ɵɵrestoreView(_r3); const ctx_r2 = ɵngcc0.ɵɵnextContext(); return ctx_r2.onBlur(); })("focus", function FormDatetimePickerComponent_dynamic_field_4_Template_dynamic_field_focus_0_listener() { ɵngcc0.ɵɵrestoreView(_r3); const ctx_r4 = ɵngcc0.ɵɵnextContext(); return ctx_r4.onFocus(); })("valueChanges", function FormDatetimePickerComponent_dynamic_field_4_Template_dynamic_field_valueChanges_0_listener() { ɵngcc0.ɵɵrestoreView(_r3); const ctx_r5 = ɵngcc0.ɵɵnextContext(); return ctx_r5.overrideValueChanged(); });
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("form", ctx_r0.wrapperForm)("field", ctx_r0.dateField);
} }
function FormDatetimePickerComponent_dynamic_field_6_Template(rf, ctx) { if (rf & 1) {
    const _r7 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "dynamic-field", 3);
    ɵngcc0.ɵɵlistener("blur", function FormDatetimePickerComponent_dynamic_field_6_Template_dynamic_field_blur_0_listener() { ɵngcc0.ɵɵrestoreView(_r7); const ctx_r6 = ɵngcc0.ɵɵnextContext(); return ctx_r6.onBlur(); })("focus", function FormDatetimePickerComponent_dynamic_field_6_Template_dynamic_field_focus_0_listener() { ɵngcc0.ɵɵrestoreView(_r7); const ctx_r8 = ɵngcc0.ɵɵnextContext(); return ctx_r8.onFocus(); })("valueChanges", function FormDatetimePickerComponent_dynamic_field_6_Template_dynamic_field_valueChanges_0_listener() { ɵngcc0.ɵɵrestoreView(_r7); const ctx_r9 = ɵngcc0.ɵɵnextContext(); return ctx_r9.overrideValueChanged(); });
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("form", ctx_r1.wrapperForm)("field", ctx_r1.timeField);
} }
function FormColorPickerComponent_span_7_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span", 5);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵstyleProp("visibility", ctx_r1.isFocused && ctx_r1.hasMaxLength() ? null : "hidden");
    ɵngcc0.ɵɵclassProp("errortext", ctx_r1.hasError("maxlength"))("inside-box-maxlength", ctx_r1.config.insideBoxValidation);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ctx_r1.getMaxLengthText());
} }
function FormColorPickerComponent_span_9_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span", 5);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵstyleProp("visibility", ctx_r2.isFocused && ctx_r2.hasMaxLength() ? null : "hidden");
    ɵngcc0.ɵɵclassProp("errortext", ctx_r2.hasError("maxlength"))("inside-box-maxlength", ctx_r2.config.insideBoxValidation);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ctx_r2.getMaxLengthText());
} }
function FormTagsComponent_span_10_Template(rf, ctx) { if (rf & 1) {
    const _r7 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "span", 6);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementStart(2, "i", 7);
    ɵngcc0.ɵɵlistener("click", function FormTagsComponent_span_10_Template_i_click_2_listener() { ɵngcc0.ɵɵrestoreView(_r7); const i_r5 = ctx.index; const ctx_r6 = ɵngcc0.ɵɵnextContext(); return ctx_r6.removeTag(i_r5); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtext(3, "\n        ");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const tag_r4 = ctx.$implicit;
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵclassProp("disabled", ctx_r1.control.disabled);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1("\n            ", tag_r4, "\n            ");
} }
function FormTagsComponent_span_14_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span", 8);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵstyleProp("visibility", ctx_r2.isFocused && ctx_r2.hasMaxLength() ? null : "hidden");
    ɵngcc0.ɵɵclassProp("errortext", ctx_r2.hasError("maxlength"))("inside-box-maxlength", ctx_r2.config.insideBoxValidation);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ctx_r2.getMaxLengthText());
} }
function FormTagsComponent_span_16_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span", 8);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵstyleProp("visibility", ctx_r3.isFocused && ctx_r3.hasMaxLength() ? null : "hidden");
    ɵngcc0.ɵɵclassProp("errortext", ctx_r3.hasError("maxlength"))("inside-box-maxlength", ctx_r3.config.insideBoxValidation);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ctx_r3.getMaxLengthText());
} }
function FormWYSIWYGComponent_span_7_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span", 5);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵstyleProp("visibility", ctx_r1.isFocused && ctx_r1.hasMaxLength() ? null : "hidden");
    ɵngcc0.ɵɵclassProp("errortext", ctx_r1.hasError("maxlength"))("inside-box-maxlength", ctx_r1.config.insideBoxValidation);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ctx_r1.getMaxLengthText());
} }
function FormWYSIWYGComponent_span_9_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span", 5);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵstyleProp("visibility", ctx_r2.isFocused && ctx_r2.hasMaxLength() ? null : "hidden");
    ɵngcc0.ɵɵclassProp("errortext", ctx_r2.hasError("maxlength"))("inside-box-maxlength", ctx_r2.config.insideBoxValidation);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ctx_r2.getMaxLengthText());
} }
function FormDropdownComponent_option_5_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "option", 4);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const option_r2 = ctx.$implicit;
    ɵngcc0.ɵɵproperty("ngValue", option_r2.Id);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1("\n            ", option_r2.Name, "\n        ");
} }
function FormMultiSelectDropdownComponent_em_12_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "em");
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵclassProp("errortext", ctx_r1.hasError());
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ctx_r1.getNoItemsErrorMessage());
} }
function FormOldStyleMultiSelectDropdownComponent_option_5_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "option", 4);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const option_r2 = ctx.$implicit;
    ɵngcc0.ɵɵproperty("ngValue", option_r2.Id);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1("\n            ", option_r2.Name, "\n        ");
} }
function FormRadioButtonListComponent_label_5_Template(rf, ctx) { if (rf & 1) {
    const _r5 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "label", 5);
    ɵngcc0.ɵɵtext(1, "\n            ");
    ɵngcc0.ɵɵelementStart(2, "input", 6);
    ɵngcc0.ɵɵlistener("blur", function FormRadioButtonListComponent_label_5_Template_input_blur_2_listener() { ɵngcc0.ɵɵrestoreView(_r5); const ctx_r4 = ɵngcc0.ɵɵnextContext(); return ctx_r4.onBlur(); })("focus", function FormRadioButtonListComponent_label_5_Template_input_focus_2_listener() { ɵngcc0.ɵɵrestoreView(_r5); const ctx_r6 = ɵngcc0.ɵɵnextContext(); return ctx_r6.onFocus(); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtext(3);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const option_r3 = ctx.$implicit;
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵclassProp("disabled", ctx_r1.isDisabled);
    ɵngcc0.ɵɵattribute("disabled", ctx_r1.isDisabled ? "disabled" : null);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("value", option_r3.Id);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1("\n            ", option_r3.Name, "\n        ");
} }
function FormRadioButtonListComponent_em_8_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "em");
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵclassProp("errortext", ctx_r2.hasError());
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ctx_r2.getNoItemsErrorMessage());
} }
function FormOldStyleRadioButtonListComponent_div_4_Template(rf, ctx) { if (rf & 1) {
    const _r5 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵtext(1, "\n            ");
    ɵngcc0.ɵɵelementStart(2, "input", 4, 5);
    ɵngcc0.ɵɵlistener("blur", function FormOldStyleRadioButtonListComponent_div_4_Template_input_blur_2_listener() { ɵngcc0.ɵɵrestoreView(_r5); const ctx_r4 = ɵngcc0.ɵɵnextContext(); return ctx_r4.onBlur(); })("focus", function FormOldStyleRadioButtonListComponent_div_4_Template_input_focus_2_listener() { ɵngcc0.ɵɵrestoreView(_r5); const ctx_r6 = ɵngcc0.ɵɵnextContext(); return ctx_r6.onFocus(); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtext(4, "\n            ");
    ɵngcc0.ɵɵelementStart(5, "span", 6);
    ɵngcc0.ɵɵlistener("click", function FormOldStyleRadioButtonListComponent_div_4_Template_span_click_5_listener() { ɵngcc0.ɵɵrestoreView(_r5); const option_r2 = ctx.$implicit; const ctx_r7 = ɵngcc0.ɵɵnextContext(); return ctx_r7.labelClicked(option_r2); });
    ɵngcc0.ɵɵtext(6);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtext(7, "\n        ");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const option_r2 = ctx.$implicit;
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("formControlName", ctx_r0.config.name)("value", option_r2.Id);
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵtextInterpolate1(" ", option_r2.Name, "");
} }
function FormOldStyleRadioButtonListComponent_span_6_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span", 7);
    ɵngcc0.ɵɵtext(1, "spacer");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    ɵngcc0.ɵɵstyleProp("visibility", "hidden");
} }
function DynamicFieldComponent_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r2 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 1);
    ɵngcc0.ɵɵlistener("blur", function DynamicFieldComponent_div_1_Template_div_blur_0_listener() { ɵngcc0.ɵɵrestoreView(_r2); const ctx_r1 = ɵngcc0.ɵɵnextContext(); return ctx_r1.blur.emit(); })("focus", function DynamicFieldComponent_div_1_Template_div_focus_0_listener() { ɵngcc0.ɵɵrestoreView(_r2); const ctx_r3 = ɵngcc0.ɵɵnextContext(); return ctx_r3.focus.emit(); })("valueChanges", function DynamicFieldComponent_div_1_Template_div_valueChanges_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r2); const ctx_r4 = ɵngcc0.ɵɵnextContext(); return ctx_r4.valueChanges.emit($event); });
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("config", ctx_r0.field)("group", ctx_r0.form);
} }
function DynamicFormComponent_ng_container_2_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0, 3);
} if (rf & 2) {
    const field_r1 = ɵngcc0.ɵɵnextContext().$implicit;
    const ctx_r2 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("config", field_r1)("group", ctx_r2.form);
} }
function DynamicFormComponent_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtext(1, "\n        ");
    ɵngcc0.ɵɵtemplate(2, DynamicFormComponent_ng_container_2_ng_container_2_Template, 1, 2, "ng-container", 2);
    ɵngcc0.ɵɵtext(3, "\n        ");
    ɵngcc0.ɵɵprojection(4, 0, ["[formGroup]", "group"]);
    ɵngcc0.ɵɵtext(5, "\n    ");
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const field_r1 = ctx.$implicit;
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", field_r1.shouldCreateControl(ctx_r0.claimsService));
} }
const _c6 = ["*"];
function DynamicViewComponent_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtext(1, "\n    ");
    ɵngcc0.ɵɵelementStart(2, "div", 1);
    ɵngcc0.ɵɵtext(3, "\n        ");
    ɵngcc0.ɵɵelementStart(4, "b");
    ɵngcc0.ɵɵtext(5);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtext(6, "\n        ");
    ɵngcc0.ɵɵelement(7, "span", 2);
    ɵngcc0.ɵɵtext(8, "\n    ");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtext(9, "\n    ");
    ɵngcc0.ɵɵprojection(10, 0, ["[formGroup]", "group"]);
    ɵngcc0.ɵɵtext(11, "\n");
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const field_r1 = ctx.$implicit;
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(5);
    ɵngcc0.ɵɵtextInterpolate1("", field_r1.label, ":");
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("innerHtml", ctx_r0.getValue(field_r1), ɵngcc0.ɵɵsanitizeHtml);
} }
function FormLabelComponent_span_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span", 4);
    ɵngcc0.ɵɵtext(1, " *");
    ɵngcc0.ɵɵelementEnd();
} }
function FormLabelComponent_span_6_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span", 5);
    ɵngcc0.ɵɵtext(1, "\n        ");
    ɵngcc0.ɵɵelementStart(2, "em");
    ɵngcc0.ɵɵtext(3, "optional");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtext(4, "\n    ");
    ɵngcc0.ɵɵelementEnd();
} }
const _c7 = ".space-for-validation[_ngcontent-%COMP%] {\n                margin-bottom: 15px;\n            }";
function FormValidationMessageComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "div", 1);
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵstyleProp("position", "absolute");
    ɵngcc0.ɵɵclassProp("inside-box-validation", ctx_r0.insideBoxValidation);
    ɵngcc0.ɵɵproperty("innerHtml", ctx_r0.errorMessage, ɵngcc0.ɵɵsanitizeHtml);
} }
function MtAddressComponent_div_1_dynamic_field_2_Template(rf, ctx) { if (rf & 1) {
    const _r10 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "dynamic-field", 6);
    ɵngcc0.ɵɵlistener("valueChanges", function MtAddressComponent_div_1_dynamic_field_2_Template_dynamic_field_valueChanges_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r10); const ctx_r9 = ɵngcc0.ɵɵnextContext(2); return ctx_r9.onCountryChange($event); });
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("field", ctx_r1.fields.Country)("form", ctx_r1.parentForm)("overrideForm", true)("removeControlOnDestroy", false);
} }
function MtAddressComponent_div_1_dynamic_field_8_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "dynamic-field", 3);
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("field", ctx_r2.fields.City)("form", ctx_r2.parentForm)("overrideForm", true);
} }
function MtAddressComponent_div_1_dynamic_field_10_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "dynamic-field", 3);
} if (rf & 2) {
    const ctx_r3 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("field", ctx_r3.fields.InternationalCity)("form", ctx_r3.parentForm)("overrideForm", true);
} }
function MtAddressComponent_div_1_dynamic_field_12_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "dynamic-field", 3);
} if (rf & 2) {
    const ctx_r4 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("field", ctx_r4.fields.State)("form", ctx_r4.parentForm)("overrideForm", true);
} }
function MtAddressComponent_div_1_dynamic_field_14_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "dynamic-field", 3);
} if (rf & 2) {
    const ctx_r5 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("field", ctx_r5.fields.Province)("form", ctx_r5.parentForm)("overrideForm", true);
} }
function MtAddressComponent_div_1_dynamic_field_16_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "dynamic-field", 3);
} if (rf & 2) {
    const ctx_r6 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("field", ctx_r6.fields.Zip)("form", ctx_r6.parentForm)("overrideForm", true);
} }
function MtAddressComponent_div_1_dynamic_field_18_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "dynamic-field", 3);
} if (rf & 2) {
    const ctx_r7 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("field", ctx_r7.fields.InternationalZip)("form", ctx_r7.parentForm)("overrideForm", true);
} }
function MtAddressComponent_div_1_div_20_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵtext(1, "\n                ");
    ɵngcc0.ɵɵelement(2, "input", 7);
    ɵngcc0.ɵɵtext(3, "\n                ");
    ɵngcc0.ɵɵelementStart(4, "label");
    ɵngcc0.ɵɵtext(5, "Primary Address");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtext(6, "\n            ");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    ɵngcc0.ɵɵstyleProp("margin-bottom", 15, "px");
} }
function MtAddressComponent_div_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 1);
    ɵngcc0.ɵɵtext(1, "\n            ");
    ɵngcc0.ɵɵtemplate(2, MtAddressComponent_div_1_dynamic_field_2_Template, 1, 4, "dynamic-field", 2);
    ɵngcc0.ɵɵtext(3, "\n            ");
    ɵngcc0.ɵɵelement(4, "dynamic-field", 3);
    ɵngcc0.ɵɵtext(5, "\n            ");
    ɵngcc0.ɵɵelement(6, "dynamic-field", 3);
    ɵngcc0.ɵɵtext(7, "\n            ");
    ɵngcc0.ɵɵtemplate(8, MtAddressComponent_div_1_dynamic_field_8_Template, 1, 3, "dynamic-field", 4);
    ɵngcc0.ɵɵtext(9, "\n            ");
    ɵngcc0.ɵɵtemplate(10, MtAddressComponent_div_1_dynamic_field_10_Template, 1, 3, "dynamic-field", 4);
    ɵngcc0.ɵɵtext(11, "\n            ");
    ɵngcc0.ɵɵtemplate(12, MtAddressComponent_div_1_dynamic_field_12_Template, 1, 3, "dynamic-field", 4);
    ɵngcc0.ɵɵtext(13, "\n            ");
    ɵngcc0.ɵɵtemplate(14, MtAddressComponent_div_1_dynamic_field_14_Template, 1, 3, "dynamic-field", 4);
    ɵngcc0.ɵɵtext(15, "\n            ");
    ɵngcc0.ɵɵtemplate(16, MtAddressComponent_div_1_dynamic_field_16_Template, 1, 3, "dynamic-field", 4);
    ɵngcc0.ɵɵtext(17, "\n            ");
    ɵngcc0.ɵɵtemplate(18, MtAddressComponent_div_1_dynamic_field_18_Template, 1, 3, "dynamic-field", 4);
    ɵngcc0.ɵɵtext(19, "\n            ");
    ɵngcc0.ɵɵtemplate(20, MtAddressComponent_div_1_div_20_Template, 7, 2, "div", 5);
    ɵngcc0.ɵɵtext(21, "\n        ");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("formGroup", ctx_r0.parentForm);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.allowInternationalAddresses);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("field", ctx_r0.fields.Address1)("form", ctx_r0.parentForm)("overrideForm", true);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("field", ctx_r0.fields.Address2)("form", ctx_r0.parentForm)("overrideForm", true);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", !ctx_r0.addressIsInternational);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.addressIsInternational);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", !ctx_r0.addressIsInternational);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.addressIsInternational);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", !ctx_r0.addressIsInternational);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.addressIsInternational);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.showIsPrimary);
} }
function noZeroRequiredValidator(control) {
    let value = control.value;
    if (value && typeof value === 'string') {
        value = value.trim();
    }
    if (!value || value === '0') {
        return {
            noZeroRequired: {
                message: 'required not met: failed for either null, blank string, or zero (number or string)',
            },
        };
    }
    return null;
}

class DatepickerDateOptionItem {
    constructor(date) {
        Object.assign(this, this.getDatePickerOptions(date));
    }
    /**
     * This method takes in a date object and formats it into the format
     * ngbootstrap expects it to be {year: xxxx, month: xx, day: xx}
     * @param date
     */
    getDatePickerOptions(date) {
        return { year: date.getFullYear(), month: date.getMonth() + 1, day: date.getDate() };
    }
}

var InputTypes;
(function (InputTypes) {
    InputTypes[InputTypes["Textbox"] = 1] = "Textbox";
    InputTypes[InputTypes["Textarea"] = 2] = "Textarea";
    InputTypes[InputTypes["Datepicker"] = 3] = "Datepicker";
    InputTypes[InputTypes["Phone"] = 4] = "Phone";
    InputTypes[InputTypes["Timepicker"] = 5] = "Timepicker";
    InputTypes[InputTypes["DateTimepicker"] = 6] = "DateTimepicker";
    InputTypes[InputTypes["Colorpicker"] = 7] = "Colorpicker";
    InputTypes[InputTypes["DateInput"] = 8] = "DateInput";
    InputTypes[InputTypes["DateTimeInput"] = 9] = "DateTimeInput";
    InputTypes[InputTypes["Tags"] = 10] = "Tags";
    InputTypes[InputTypes["WYSIWYG"] = 11] = "WYSIWYG";
})(InputTypes || (InputTypes = {}));
var SelectInputTypes;
(function (SelectInputTypes) {
    SelectInputTypes[SelectInputTypes["Dropdown"] = 1] = "Dropdown";
    SelectInputTypes[SelectInputTypes["MultiselectDropdown"] = 2] = "MultiselectDropdown";
    SelectInputTypes[SelectInputTypes["RadioButtonList"] = 3] = "RadioButtonList";
    SelectInputTypes[SelectInputTypes["OldStyleRadioButtonList"] = 4] = "OldStyleRadioButtonList";
    SelectInputTypes[SelectInputTypes["OldStyleMultiselectDropdown"] = 5] = "OldStyleMultiselectDropdown";
    SelectInputTypes[SelectInputTypes["TypeAhead"] = 6] = "TypeAhead";
})(SelectInputTypes || (SelectInputTypes = {}));
function getControlFromFormGroup(group, config) {
    let control = group.get([config.formGroup, config.name]);
    if (!control) {
        control = group.get(config.name);
    }
    return control;
}
function getGroupFromConfig(parentGroup, config) {
    let group = config.formGroup ? parentGroup.get([config.formGroup]) : parentGroup;
    return group;
}

class LabelPosition {
    constructor(labelPosition) {
        this.position = labelPosition.position;
        this.colsForLabel = labelPosition.colsForLabel || 3;
    }
}
var LabelPositions;
(function (LabelPositions) {
    LabelPositions[LabelPositions["Top"] = 0] = "Top";
    LabelPositions[LabelPositions["Left"] = 1] = "Left";
    LabelPositions[LabelPositions["Hidden"] = 2] = "Hidden";
})(LabelPositions || (LabelPositions = {}));

var DynamicFieldTypes;
(function (DynamicFieldTypes) {
    DynamicFieldTypes[DynamicFieldTypes["Input"] = 1] = "Input";
    DynamicFieldTypes[DynamicFieldTypes["Numeric"] = 2] = "Numeric";
    DynamicFieldTypes[DynamicFieldTypes["Checkbox"] = 3] = "Checkbox";
    DynamicFieldTypes[DynamicFieldTypes["Password"] = 4] = "Password";
    DynamicFieldTypes[DynamicFieldTypes["Select"] = 5] = "Select";
    DynamicFieldTypes[DynamicFieldTypes["MtAddress"] = 6] = "MtAddress";
})(DynamicFieldTypes || (DynamicFieldTypes = {}));

/**
 * This class constructs the form control object
 * @property label
 * @property value
 * @property name
 * @property type
 * @property options
 * @property validation
 * @property validators
 * @property placeholder
 * @property disabled: when set to number or number array, will be used to check them as claim type ids, and if those claims are not present, control will be disabled
 * @property insideBoxValidation
 * @property labelHtml
 * @property labelPosition
 * @property {CustomFormControlComponentBase} component component to use for this field
 */
class DynamicField {
    constructor(constructorObject) {
        this.constructClass(constructorObject);
    }
    get labelAtTop() {
        return this.labelPosition.position === LabelPositions.Top;
    }
    get labelLeft() {
        return this.labelPosition.position === LabelPositions.Left;
    }
    get labelHidden() {
        return this.labelPosition.position === LabelPositions.Hidden;
    }
    get labelCols() {
        return this.labelPosition.colsForLabel || 0;
    }
    get controlCols() {
        return 12 - this.labelCols;
    }
    constructClass(constructorObject) {
        var _a;
        // set some defaults to the contructorObject
        if (typeof constructorObject.validators === 'undefined') {
            constructorObject.validators = {};
        }
        if (typeof constructorObject.disabled === 'undefined') {
            constructorObject.disabled = false;
        }
        if (typeof constructorObject.insideBoxValidation === 'undefined') {
            constructorObject.insideBoxValidation = false;
        }
        if (typeof constructorObject.labelHtml === 'undefined') {
            constructorObject.labelHtml = `<label>${constructorObject.label}</label>`;
        }
        if (typeof constructorObject.autoFocus === 'undefined') {
            constructorObject.autoFocus = false;
        }
        if (typeof constructorObject.failedPatternMessage === 'undefined') {
            constructorObject.failedPatternMessage = '';
        }
        if (typeof constructorObject.doNotCreateControl === 'undefined') {
            constructorObject.doNotCreateControl = false;
        }
        if (typeof constructorObject.type.datepickerOptions === 'undefined') {
            constructorObject.type.datepickerOptions = {};
        }
        if (typeof constructorObject.autoCompleteEnabled === 'undefined') {
            constructorObject.autoCompleteEnabled = true;
        }
        const defaultValidators = {
            showOptional: false,
            showRequired: true,
        };
        constructorObject.validators = Object.assign({}, defaultValidators, constructorObject.validators);
        if (typeof constructorObject.type.inputType === 'undefined' || constructorObject.type.inputType === null) {
            if (constructorObject.type.fieldType === DynamicFieldTypes.Input) {
                const maxLengthOverTextboxDefault = ((_a = constructorObject.validators) === null || _a === void 0 ? void 0 : _a.maxlength) > 100 ? true : false;
                constructorObject.type.inputType = maxLengthOverTextboxDefault ? InputTypes.Textarea : InputTypes.Textbox;
            }
        }
        // assign contructorObject values to the class
        this.formGroup = constructorObject.formGroup;
        this.label = constructorObject.label;
        this.value = constructorObject.value;
        this.name = constructorObject.name;
        this.type = constructorObject.type;
        this.options = constructorObject.options;
        this.validation = constructorObject.validation;
        this.validators = constructorObject.validators;
        this.placeholder = constructorObject.placeholder;
        this.disabled = constructorObject.disabled;
        this.insideBoxValidation = constructorObject.insideBoxValidation;
        this.labelHtml = constructorObject.labelHtml;
        this.autoFocus = constructorObject.autoFocus;
        this.autoCompleteEnabled = constructorObject.autoCompleteEnabled;
        this.failedPatternMessage = constructorObject.failedPatternMessage;
        this.doNotCreateControl = constructorObject.doNotCreateControl;
        this.labelPosition = constructorObject.labelPosition || new LabelPosition({ position: LabelPositions.Top });
        this.component = constructorObject.component;
        this.errorMessageHandler = constructorObject.errorMessageHandler;
    }
    setMinLength(value) {
        this.validators.minlength = value;
        if (!this.validation) {
            this.validation = [];
        }
        const index = this.validation.indexOf(Validators.minLength);
        if (index > -1) {
            this.validation.splice(index, 1);
        }
        if (value) {
            this.validation.push(Validators.minLength(value));
        }
    }
    setMaxLength(value) {
        this.validators.maxlength = value;
        if (!this.validation) {
            this.validation = [];
        }
        const index = this.validation.indexOf(Validators.maxLength);
        if (index > -1) {
            this.validation.splice(index, 1);
        }
        if (value) {
            this.validation.push(Validators.maxLength(value));
        }
    }
    setRequired(value) {
        this.validators.required = value;
        if (!this.validation) {
            this.validation = [];
        }
        const requiredValidator = this.getRequiredValidator();
        const index = this.validation.indexOf(requiredValidator);
        if (value) {
            if (index === -1) {
                this.validation.push(requiredValidator);
            }
        }
        else {
            if (index > -1) {
                this.validation.splice(index, 1);
            }
        }
    }
    getRequiredValidator() {
        if (this.type.fieldType === DynamicFieldTypes.Select) {
            if (this.type.doNotAllowZero === false) {
                return Validators.required;
            }
            return noZeroRequiredValidator;
        }
        return Validators.required;
    }
    setPattern(pattern) {
        this.validators.pattern = pattern;
        this.validation.push(Validators.pattern(pattern));
    }
    shouldCreateControl(claimsService) {
        this.doNotCreateControl = this.claimCheck(this.doNotCreateControl, claimsService);
        return !this.doNotCreateControl;
    }
    createControl(fb, claimsService) {
        this.disabled = this.claimCheck(this.disabled, claimsService);
        return fb.control({ value: this.value, disabled: this.disabled }, this.validation);
    }
    setOptionsForDateOfBirth() {
        let dateForDob = new Date();
        this.type.datepickerOptions.maxDate = new DatepickerDateOptionItem(dateForDob);
        dateForDob.setFullYear(dateForDob.getFullYear() - 110);
        this.type.datepickerOptions.minDate = new DatepickerDateOptionItem(dateForDob);
    }
    claimCheck(claimsToCheck, claimsService) {
        const hasClaimsBasedValues = typeof claimsToCheck === 'number' || Array.isArray(claimsToCheck) ? true : false;
        if (!hasClaimsBasedValues) {
            return claimsToCheck;
        }
        // get the claimTypeIds from the propety
        const claimTypeIds = Array.isArray(claimsToCheck) ? claimsToCheck : [claimsToCheck];
        // get answers for each hasClaim check
        const hasClaimAnswers = [];
        claimTypeIds.forEach((claimTypeId) => {
            hasClaimAnswers.push(claimsService.hasClaim(claimTypeId, [ClaimValues.FullAccess]));
        });
        // if any of the hasClaimAnswers are not true, then returns false
        return hasClaimAnswers.some((answer) => !answer);
    }
}
class DynamicFieldType {
    constructor(constructorObject) {
        Object.assign(this, constructorObject);
    }
}

function instanceOfIDynamicLabel(object) {
    if (typeof object !== 'object') {
        return false;
    }
    return 'label' in object && 'value' in object && 'type' in object;
}
/**
 * This class contructs the label object
 */
class DynamicLabel {
    constructor(label, value, type) {
        this.errorHandler = new ComponentErrorHandler('DynamicLabel', '@mt-ng2/dynamic-form');
        // check for deprecated constructor params and warn if used
        // *********************************************************************
        // * TODO CCC 9-4-2018: have commented out the deprecated params check,
        // * since it will cause lots of warnings for several pacakges and pages.
        // * once we have retrofitted the other packages, breck, and yo-breck,
        // * we can turn this check back on.
        // *********************************************************************
        // this.deprecatedConstructorParamsCheck(label);
        // build the constructorObject from either the IDynamicLabel first param
        // or the older depreacted params
        const constructorObject = instanceOfIDynamicLabel(label)
            ? label
            : {
                label: label,
                type: type,
                value: value,
                valueHtml: null,
            };
        // construct the class from the constructorObject
        this.constructClass(constructorObject);
    }
    deprecatedConstructorParamsCheck(label) {
        if (typeof label === 'string') {
            this.errorHandler.addWarning('non-interface constructor parameter deprecated September-2018 with release 1.3.0 - use IDynamicLabel as your first parameter instead');
        }
    }
    constructClass(constructorObject) {
        // assign contructorObject values to the class
        Object.assign(this, constructorObject);
    }
}

/**
 * This class exposes functions that when given a configuration
 * will render our dynamic forms
 */
class DynamicConfig {
    constructor() {
        this.DynamicFields = [];
        this.DynamicLabels = [];
        this.errorHandler = new ComponentErrorHandler('DynamicConfig', '@mt-ng2/dynamic-form');
    }
    setControls(fields, controlsFactory) {
        fields.forEach((field) => {
            if (this.propertyExistsInControlsFactory(controlsFactory, 'Form', field)) {
                this.DynamicFields.push(controlsFactory.Form[field]);
            }
            if (this.propertyExistsInControlsFactory(controlsFactory, 'View', field)) {
                this.DynamicLabels.push(controlsFactory.View[field]);
            }
        });
    }
    getFormObject(additionalConfigs) {
        if ((additionalConfigs === null || additionalConfigs === void 0 ? void 0 : additionalConfigs.length) > 0) {
            additionalConfigs.forEach((config) => {
                config.getForCreate().formObject.forEach((formObject) => {
                    // if the object is undefinded then it was probably passed a configuration control
                    // that it couldn't render.
                    // EG: if (id === 0) render SendRestEmail
                    // configuration has 'SendRestEmail' but id > 0
                    // In this scenario I'm just trying to help them understand what could be wrong.
                    // I could just ignore this, but it might have unintended consequences.
                    if (!formObject) {
                        throw 'Form Object is not defined.  Is your custom configuration correct?';
                    }
                    // push the form object
                    this.DynamicFields.push(formObject);
                    let displayValue;
                    // We want to display the name in the lable for selects not the value
                    if (formObject.type.fieldType === DynamicFieldTypes.Select) {
                        // just incase
                        if (formObject.type.inputType === SelectInputTypes.MultiselectDropdown) {
                            if (formObject.value && formObject.value.length > 0) {
                                const selectValues = formObject.options
                                    .filter((opt) => {
                                    formObject.value.some((v) => v === opt.Id);
                                })
                                    .map((opt) => opt.Name);
                                displayValue = selectValues ? selectValues.join(', ') : '';
                            }
                            else {
                                displayValue = '';
                            }
                        }
                        else {
                            const selectValue = formObject.options.find((opt) => opt.Id === formObject.value);
                            displayValue = selectValue ? selectValue.Name : '';
                        }
                    }
                    else {
                        displayValue = formObject.value;
                    }
                    // push the label object
                    this.DynamicLabels.push(new DynamicLabel({
                        label: formObject.label,
                        type: formObject.type,
                        value: displayValue,
                    }));
                });
            });
        }
        return this.DynamicFields;
    }
    assignFormValues(object, formValue) {
        for (let prop in formValue) {
            if (object.hasOwnProperty(prop)) {
                object[prop] = formValue[prop];
            }
        }
    }
    propertyExistsInControlsFactory(factory, groupAccessor, property) {
        if (factory[groupAccessor][property] !== undefined) {
            return true;
        }
        else {
            this.errorHandler.addWarning(`could not find "${property}" in controlsFactory.${groupAccessor} for fromGroup "${factory.formGroup}"`);
            return false;
        }
    }
}
class DynamicControls {
    setShowOptional(value) {
        if (this.Form) {
            for (const key in this.Form) {
                if (this.Form.hasOwnProperty(key)) {
                    let control = this.Form[key];
                    control.validators.showOptional = value;
                    control.validators.showRequired = !value;
                }
            }
        }
    }
}

function isString(value) {
    return typeof value === 'string' || value instanceof String;
}

class DynamicFormModuleConfig {
    constructor(config) {
        // we must have a config passed in, since we require the common service
        if (!config) {
            throw new Error('DynamicForm requires a config to be passed in, but none was found.  Please provide a config using the DynamicFormModuleConfigToken. Check the ReadMe of this package for detailed instructions.');
        }
        // we may have received just the CommonService as that is how it use to be passed in
        // if so, construct a proper config for it
        // either way, assign the final value to the moduleConfig
        if (config && !config.commonService) {
            this.commonService = config;
        }
        else {
            Object.assign(this, config);
        }
    }
}
DynamicFormModuleConfig.ɵfac = function DynamicFormModuleConfig_Factory(t) { return new (t || DynamicFormModuleConfig)(ɵngcc0.ɵɵinject(DynamicFormModuleConfigToken, 8)); };
DynamicFormModuleConfig.ɵprov = ɵɵdefineInjectable({ factory: function DynamicFormModuleConfig_Factory() { return new DynamicFormModuleConfig(ɵɵinject(DynamicFormModuleConfigToken, 8)); }, token: DynamicFormModuleConfig, providedIn: "root" });
DynamicFormModuleConfig.ctorParameters = () => [
    { type: undefined, decorators: [{ type: Optional }, { type: Inject, args: [DynamicFormModuleConfigToken,] }] }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DynamicFormModuleConfig, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: undefined, decorators: [{
                type: Optional
            }, {
                type: Inject,
                args: [DynamicFormModuleConfigToken]
            }] }]; }, null); })();

class CustomFormValidation {
    static getErrorMessageFromKey(key, errors, config, customErrorMessageHandler) {
        // if custom error message handler returns a message, then return that as the answer
        let message = customErrorMessageHandler === null || customErrorMessageHandler === void 0 ? void 0 : customErrorMessageHandler(key, errors, config);
        if (message) {
            return message;
        }
        // else if we have a message being returned by the validator itself, then return that as the answer
        if (isString(errors === null || errors === void 0 ? void 0 : errors[key])) {
            return errors[key];
        }
        // else use our defaults to create a message
        switch (key) {
            case 'required':
            case 'noZeroRequired':
                // if the required symbol (*) is showing, no need to create a message for required error
                if (this.showRequired(config)) {
                    return '';
                }
                return `${config.label} is required`;
            case 'minlength':
                return `${config.label} must be at least ${config.validators.minlength} characters`;
            case 'email':
                return `Invalid email address. Valid email can contain only letters, numbers and '@'`;
            case 'pattern':
                return config.failedPatternMessage;
            default:
                return '';
        }
    }
    static showRequired(config) {
        var _a, _b;
        return ((_a = config === null || config === void 0 ? void 0 : config.validators) === null || _a === void 0 ? void 0 : _a.required) && ((_b = config === null || config === void 0 ? void 0 : config.validators) === null || _b === void 0 ? void 0 : _b.showRequired);
    }
}

class CustomFormControlComponentBase {
    constructor(changeDetectorRefOrInjector) {
        /**
         * @property {CustomFormControlComponentBase} this so can be passed around
         */
        this.thisControl = this;
        /**
         * @property {EventEmitter<any>} event that emits on blur, used by dynamic field directive to allow (blur) event binding
         */
        this.blur = new EventEmitter();
        /**
         * @property {EventEmitter<any>} event that emits on focus, used by dynamic field directive to allow (focus) event binding
         */
        this.focus = new EventEmitter();
        /**
         * @property {EventEmitter<any>} event that emits on valueChanges, used by dynamic field directive to allow (valueChanges) event binding
         */
        this.valueChanges = new EventEmitter();
        /**
         * @property {Subscription} subscription object used to collect subscriptions for easy unsubscribing later
         */
        this.subscriptions = new Subscription();
        this._isFocused = false;
        this._isDisabled = false;
        /**
         * mark as touched should happen on blur, but our old dynamic forms did it on focus
         * so we allow for both depending on the configuration
         */
        this.markAsTouchedOnFocus = false;
        if (changeDetectorRefOrInjector.detectChanges) {
            this.changeDetectorRef = changeDetectorRefOrInjector;
        }
        else {
            this.changeDetectorRef = changeDetectorRefOrInjector.get(ChangeDetectorRef);
            const moduleConfig = changeDetectorRefOrInjector.get(DynamicFormModuleConfig);
            this.markAsTouchedOnFocus = moduleConfig.markAsTouchedOnFocus ? true : false;
            this.moduleErrorMessageHandler = moduleConfig.errorMessageHandler;
        }
    }
    /**
     * @readonly
     * @property {boolean} allows view to read if the control is currently focused
     */
    get isFocused() {
        return this._isFocused;
    }
    /**
     * @readonly
     * @property {boolean} allows view to read if the control is currently disabled
     */
    get isDisabled() {
        return this._isDisabled;
    }
    /**
     * @description handles setup work such as subscribing to mt control events and setting initial values
     */
    ngOnInit() {
        this.subscriptions.add(this.getControl().mtExternalFocusEvent.subscribe(() => {
            this.focusMe();
        }));
        this.subscriptions.add(this.getControl().mtSetRequiredEvent.subscribe((required) => {
            this.setRequired(required);
        }));
        this.subscriptions.add(this.getControl().statusChanges.subscribe((status) => {
            this._isDisabled = status === 'DISABLED';
        }));
        this._autoFocus = this.config.autoFocus;
        this._autoCompleteEnabled = this.config.autoCompleteEnabled;
        this._isDisabled = this.getControl().status === 'DISABLED';
    }
    /**
     * @description handles teardown work such as unsubscribing
     */
    ngOnDestroy() {
        this.subscriptions.unsubscribe();
    }
    /**
     * @description handles a few items that must be done after view init such as subscribing to valueChanges and handling autoFocus
     */
    ngAfterViewInit() {
        this.subscriptions.add(this.getControl().valueChanges.subscribe((value) => {
            this.valueChanges.emit(value);
        }));
        if (this._autoFocus) {
            this._autoFocus = false;
            setTimeout(() => {
                this.focusMe();
                this.changeDetectorRef.detectChanges();
            });
        }
    }
    /**
     * @description attempts to set focus to the inputElement.  This is called whenever the mtFocus() event is fired
     */
    focusMe() {
        var _a, _b, _c;
        (_c = (_b = (_a = this.inputElement) === null || _a === void 0 ? void 0 : _a.nativeElement) === null || _b === void 0 ? void 0 : _b.focus) === null || _c === void 0 ? void 0 : _c.call(_b);
    }
    /**
     * @description event that handles an onBlur event from the inputElement.  Must be wired up manually using the input's event like this (blur)="onBlur()"
     */
    onBlur() {
        if (this.getControl().enabled) {
            this._isFocused = false;
            if (!this.markAsTouchedOnFocus) {
                this.getControl().markAsTouched();
            }
            this.blur.emit(true);
        }
    }
    /**
     * @description event that handles an onFocus event from the inputElement.  Must be wired up manually using the input's event like this (focus)="onFocus()"
     */
    onFocus() {
        if (this.getControl().enabled) {
            this._isFocused = true;
            if (this.markAsTouchedOnFocus) {
                this.getControl().markAsTouched();
            }
            this.focus.emit();
        }
    }
    /**
     * @description gets the instance of the AbstractControl from the form
     * @returns {AbstractControl}
     */
    getControl() {
        return this.getControlFromFormGroup(this.parentGroup, this.config);
    }
    getControlFromFormGroup(group, config) {
        let control = group.get([config.formGroup, config.name]);
        if (!control) {
            control = group.get(config.name);
        }
        return control;
    }
    /**
     * @description gets the instance of the FromGroup this control is attached to
     * @returns {FormGroup}
     */
    getGroup() {
        return this.getGroupFromConfig(this.parentGroup, this.config);
    }
    getGroupFromConfig(parentGroup, config) {
        let group = config.formGroup ? parentGroup.get([config.formGroup]) : parentGroup;
        return group;
    }
    /**
     * @description attempts to set the required validator.  This is called whenever the mtSetRequired() event is fired
     */
    setRequired(required) {
        this.config.setRequired(required);
        this.getControl().setValidators(this.config.validation.map((v) => v));
        this.getControl().updateValueAndValidity({
            emitEvent: false,
            onlySelf: true,
        });
    }
    /**
     * @description gets the maxLength from the validators object.  If not set, then returns ''
     * @returns {string}
     */
    getMaxLength() {
        var _a, _b, _c, _d;
        return (_d = (_c = (_b = (_a = this.config) === null || _a === void 0 ? void 0 : _a.validators) === null || _b === void 0 ? void 0 : _b.maxlength) === null || _c === void 0 ? void 0 : _c.toString()) !== null && _d !== void 0 ? _d : '';
    }
    /**
     * @description gets the maxLengthValue from the validators object.  If not set, then returns 0
     * @returns {number}
     */
    getMaxLengthValue() {
        var _a, _b, _c;
        return (_c = (_b = (_a = this.config) === null || _a === void 0 ? void 0 : _a.validators) === null || _b === void 0 ? void 0 : _b.maxlength) !== null && _c !== void 0 ? _c : 0;
    }
    getMaxLengthText() {
        var _a, _b;
        const control = this.getControl();
        return `${(_b = (_a = control === null || control === void 0 ? void 0 : control.value) === null || _a === void 0 ? void 0 : _a.length) !== null && _b !== void 0 ? _b : 0}/${this.config.validators.maxlength}`;
    }
    /**
     * @description determines if maxLength value is set
     * @returns {boolean}
     */
    hasMaxLength() {
        var _a, _b;
        return ((_b = (_a = this.config) === null || _a === void 0 ? void 0 : _a.validators) === null || _b === void 0 ? void 0 : _b.maxlength) ? true : false;
    }
    /**
     * @description is the formcontrol required, used to determine if should show required '*' in label
     * @returns {boolean}
     */
    showRequired() {
        var _a, _b, _c, _d;
        return ((_b = (_a = this.config) === null || _a === void 0 ? void 0 : _a.validators) === null || _b === void 0 ? void 0 : _b.required) && ((_d = (_c = this.config) === null || _c === void 0 ? void 0 : _c.validators) === null || _d === void 0 ? void 0 : _d.showRequired);
    }
    /**
     * @description is the formcontrol not required, used to determine if should show 'optional' in label
     * @returns {boolean}
     */
    showOptional() {
        var _a, _b, _c, _d;
        return !((_b = (_a = this.config) === null || _a === void 0 ? void 0 : _a.validators) === null || _b === void 0 ? void 0 : _b.required) && ((_d = (_c = this.config) === null || _c === void 0 ? void 0 : _c.validators) === null || _d === void 0 ? void 0 : _d.showOptional);
    }
    /**
     * @description is the formcontrol having an error (specific or generic) and has been touched
     * @param {string} error optional value that scopes the hasError check to a specific error if set
     * @returns {boolean}
     */
    hasError(error) {
        const control = this.getControl();
        if (error) {
            return control.hasError(error) && (error === 'maxlength' || control.touched);
        }
        else {
            return control.errors && (control.touched || control.errors.maxlength);
        }
    }
    get errorMessage() {
        const control = this.getControl();
        const errors = control === null || control === void 0 ? void 0 : control.errors;
        if (!(errors && (control === null || control === void 0 ? void 0 : control.touched))) {
            return '';
        }
        const message = Object.keys(errors)
            .map((key) => this.getErrorMessageFromKey(key, errors))
            .filter((message) => message)
            .join(', ');
        return message;
    }
    getErrorMessageFromKey(key, errors) {
        var _a;
        // check config then module for custom error message handler
        const customErrorMessageHandler = (_a = this.config.errorMessageHandler) !== null && _a !== void 0 ? _a : this.moduleErrorMessageHandler;
        return CustomFormValidation.getErrorMessageFromKey(key, errors, this.config, customErrorMessageHandler);
    }
}
CustomFormControlComponentBase.ɵfac = function CustomFormControlComponentBase_Factory(t) { ɵngcc0.ɵɵinvalidFactory(); };
CustomFormControlComponentBase.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: CustomFormControlComponentBase, viewQuery: function CustomFormControlComponentBase_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(_c0, true);
    } if (rf & 2) {
        var _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.inputElement = _t.first);
    } } });
CustomFormControlComponentBase.propDecorators = {
    inputElement: [{ type: ViewChild, args: ['inputElement', { static: false },] }]
};


class FormTextboxComponent extends CustomFormControlComponentBase {
    constructor(injector) {
        super(injector);
    }
}
FormTextboxComponent.ɵfac = function FormTextboxComponent_Factory(t) { return new (t || FormTextboxComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Injector)); };
FormTextboxComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: FormTextboxComponent, selectors: [["ng-component"]], features: [ɵngcc0.ɵɵInheritDefinitionFeature], decls: 15, vars: 10, consts: [[3, "parentControl", "formGroup"], ["type", "text", 1, "form-control", 3, "formControlName", "maxlength", "focus", "blur"], ["inputElement", ""], ["class", "small pull-right", 3, "visibility", "errortext", "inside-box-maxlength", 4, "ngIf"], [3, "errorMessage", "insideBoxValidation"], [1, "small", "pull-right"]], template: function FormTextboxComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "dynamic-form-input-wrapper", 0);
        ɵngcc0.ɵɵtext(1, "\n    ");
        ɵngcc0.ɵɵtext(2, "\n    ");
        ɵngcc0.ɵɵelementStart(3, "input", 1, 2);
        ɵngcc0.ɵɵlistener("focus", function FormTextboxComponent_Template_input_focus_3_listener() { return ctx.onFocus(); })("blur", function FormTextboxComponent_Template_input_blur_3_listener() { return ctx.onBlur(); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtext(5, "\n    ");
        ɵngcc0.ɵɵtext(6, "\n    ");
        ɵngcc0.ɵɵtemplate(7, FormTextboxComponent_span_7_Template, 2, 7, "span", 3);
        ɵngcc0.ɵɵtext(8, "\n    ");
        ɵngcc0.ɵɵtemplate(9, FormTextboxComponent_span_9_Template, 2, 7, "span", 3);
        ɵngcc0.ɵɵtext(10, "\n    ");
        ɵngcc0.ɵɵtext(11, "\n    ");
        ɵngcc0.ɵɵelement(12, "dynamic-form-validation-message", 4);
        ɵngcc0.ɵɵtext(13, "\n");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtext(14, "\n");
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("parentControl", ctx.thisControl)("formGroup", ctx.getGroup());
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("formControlName", ctx.config.name)("maxlength", ctx.getMaxLength());
        ɵngcc0.ɵɵattribute("placeholder", ctx.config.placeholder)("autocomplete", !ctx.config.autoCompleteEnabled ? "new-password" : null);
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.config.labelLeft && ctx.hasMaxLength());
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", ctx.config.labelLeft);
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("errorMessage", ctx.errorMessage)("insideBoxValidation", ctx.config.insideBoxValidation);
    } }, directives: function () { return [FormInputWrapperComponent, ɵngcc1.NgControlStatusGroup, ɵngcc1.FormGroupDirective, ɵngcc1.DefaultValueAccessor, ɵngcc1.NgControlStatus, ɵngcc1.FormControlName, ɵngcc1.MaxLengthValidator, ɵngcc2.NgIf, FormValidationMessageComponent]; }, styles: [_c2] });
FormTextboxComponent.ctorParameters = () => [
    { type: Injector }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(FormTextboxComponent, [{
        type: Component,
        args: [{
                template: "<dynamic-form-input-wrapper [parentControl]=\"thisControl\" [formGroup]=\"getGroup()\">\n    <!-- input element -->\n    <input\n        #inputElement\n        type=\"text\"\n        (focus)=\"onFocus()\"\n        (blur)=\"onBlur()\"\n        [attr.placeholder]=\"config.placeholder\"\n        [formControlName]=\"config.name\"\n        class=\"form-control\"\n        [maxlength]=\"getMaxLength()\"\n        [attr.autocomplete]=\"!config.autoCompleteEnabled ? 'new-password' : null\"\n    />\n    <!-- maxlength elements -->\n    <span\n        *ngIf=\"!config.labelLeft && hasMaxLength()\"\n        [style.visibility]=\"isFocused && hasMaxLength() ? null : 'hidden'\"\n        class=\"small pull-right\"\n        [class.errortext]=\"hasError('maxlength')\"\n        [class.inside-box-maxlength]=\"config.insideBoxValidation\"\n        >{{ getMaxLengthText() }}</span\n    >\n    <span\n        *ngIf=\"config.labelLeft\"\n        [style.visibility]=\"isFocused && hasMaxLength() ? null : 'hidden'\"\n        class=\"small pull-right\"\n        [class.errortext]=\"hasError('maxlength')\"\n        [class.inside-box-maxlength]=\"config.insideBoxValidation\"\n        >{{ getMaxLengthText() }}</span\n    >\n    <!-- validation elements -->\n    <dynamic-form-validation-message\n        [errorMessage]=\"errorMessage\"\n        [insideBoxValidation]=\"config.insideBoxValidation\"\n    ></dynamic-form-validation-message>\n</dynamic-form-input-wrapper>\n",
                styles: [`
            .inside-box-maxlength {
                position: relative !important;
                bottom: -13px;
                top: -13px;
                margin-bottom: -13px;
                right: 3px;
                font-size: 70%;
            }
        `]
            }]
    }], function () { return [{ type: ɵngcc0.Injector }]; }, null); })();

var NumericInputTypes;
(function (NumericInputTypes) {
    NumericInputTypes[NumericInputTypes["Integer"] = 1] = "Integer";
    NumericInputTypes[NumericInputTypes["Float"] = 2] = "Float";
    NumericInputTypes[NumericInputTypes["Currency"] = 3] = "Currency";
    NumericInputTypes[NumericInputTypes["Percentage"] = 4] = "Percentage";
})(NumericInputTypes || (NumericInputTypes = {}));
class FormNumericComponent extends CustomFormControlComponentBase {
    constructor(injector) {
        super(injector);
    }
    get isCurrency() {
        return this.config.type.inputType === NumericInputTypes.Currency;
    }
    get isPercentage() {
        return this.config.type.inputType === NumericInputTypes.Percentage;
    }
    get numericControlType() {
        return this.config.type.inputType;
    }
    focusMe() {
        this.numericControlApi.focus();
    }
    hasAddOn() {
        return this.getNumericAddOn() ? true : false;
    }
    getNumericAddOn() {
        var _a;
        let defaultAddOn = '';
        if (this.isPercentage) {
            defaultAddOn = '%';
        }
        if (this.isCurrency) {
            defaultAddOn = '$';
        }
        const addOnFromConfig = (_a = this.config.type.numericAddOn) === null || _a === void 0 ? void 0 : _a.html;
        return addOnFromConfig === undefined ? defaultAddOn : addOnFromConfig;
    }
    getNumericFunctionsSafe() {
        return this.config.type.numericFunctions || {};
    }
    getNumericAddOnPosition() {
        var _a, _b;
        let defaultAddOnPosition = 'left';
        if (this.isPercentage) {
            defaultAddOnPosition = 'right';
        }
        if (this.isCurrency) {
            defaultAddOnPosition = 'left';
        }
        const addOnPositionFromConfig = (_b = (_a = this.config.type.numericAddOn) === null || _a === void 0 ? void 0 : _a.position) !== null && _b !== void 0 ? _b : undefined;
        return addOnPositionFromConfig === undefined ? defaultAddOnPosition : addOnPositionFromConfig;
    }
    isNumericAddOnRight() {
        return this.getNumericAddOnPosition() !== 'left';
    }
    getMinMaxErrorMessage() {
        var _a, _b, _c, _d;
        let min = ((_a = this.config.validators) === null || _a === void 0 ? void 0 : _a.min) || ((_b = this.config.validators) === null || _b === void 0 ? void 0 : _b.min) === 0 ? this.config.validators.min : null;
        let max = ((_c = this.config.validators) === null || _c === void 0 ? void 0 : _c.max) || ((_d = this.config.validators) === null || _d === void 0 ? void 0 : _d.max) === 0 ? this.config.validators.max : null;
        if (this.isPercentage) {
            min = min ? min * 100 : min;
            max = max ? max * 100 : max;
        }
        if (min !== null && max !== null) {
            return `must be ${min} thru ${max}`;
        }
        if (min !== null) {
            return `minimum is ${min}`;
        }
        return `maximum is ${max}`;
    }
    getErrorMessageFromKey(key, errors) {
        let message = super.getErrorMessageFromKey(key, errors);
        if (message) {
            return message;
        }
        switch (key) {
            case 'min':
            case 'max':
                return this.getMinMaxErrorMessage();
            default:
                return '';
        }
    }
}
FormNumericComponent.ɵfac = function FormNumericComponent_Factory(t) { return new (t || FormNumericComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Injector)); };
FormNumericComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: FormNumericComponent, selectors: [["app-form-numeric"]], features: [ɵngcc0.ɵɵInheritDefinitionFeature], decls: 17, vars: 17, consts: [[3, "parentControl", "formGroup"], ["class", "input-group-addon", 3, "innerHTML", 4, "ngIf"], [3, "placeholder", "formControlName", "type", "scale", "doNotAllowZero", "numberFormatDisplayFunction", "convertFromDisplayToFormFunction", "convertFromFormToDisplayFunction", "blur", "focus", "ready"], ["class", "small pull-right", 3, "visibility", 4, "ngIf"], [3, "errorMessage", "insideBoxValidation"], [1, "input-group-addon", 3, "innerHTML"], [1, "small", "pull-right"]], template: function FormNumericComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "dynamic-form-input-wrapper", 0);
        ɵngcc0.ɵɵtext(1, "\n    ");
        ɵngcc0.ɵɵelementStart(2, "div");
        ɵngcc0.ɵɵtext(3, "\n        ");
        ɵngcc0.ɵɵtemplate(4, FormNumericComponent_span_4_Template, 1, 1, "span", 1);
        ɵngcc0.ɵɵtext(5, "\n        ");
        ɵngcc0.ɵɵelementStart(6, "mt-numeric", 2);
        ɵngcc0.ɵɵlistener("blur", function FormNumericComponent_Template_mt_numeric_blur_6_listener() { return ctx.onBlur(); })("focus", function FormNumericComponent_Template_mt_numeric_focus_6_listener() { return ctx.onFocus(); })("ready", function FormNumericComponent_Template_mt_numeric_ready_6_listener($event) { return ctx.numericControlApi = $event; });
        ɵngcc0.ɵɵtext(7, "\n        ");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtext(8, "\n        ");
        ɵngcc0.ɵɵtemplate(9, FormNumericComponent_span_9_Template, 1, 1, "span", 1);
        ɵngcc0.ɵɵtext(10, "\n    ");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtext(11, "\n    ");
        ɵngcc0.ɵɵtemplate(12, FormNumericComponent_span_12_Template, 2, 2, "span", 3);
        ɵngcc0.ɵɵtext(13, "\n    ");
        ɵngcc0.ɵɵelement(14, "dynamic-form-validation-message", 4);
        ɵngcc0.ɵɵtext(15, "\n");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtext(16, "\n");
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("parentControl", ctx.thisControl)("formGroup", ctx.getGroup());
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵclassProp("input-group", ctx.hasAddOn());
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", ctx.hasAddOn() && !ctx.isNumericAddOnRight());
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("placeholder", ctx.config.placeholder)("formControlName", ctx.config.name)("type", ctx.numericControlType)("scale", ctx.config.type.scale)("doNotAllowZero", ctx.config.type.doNotAllowZero)("numberFormatDisplayFunction", ctx.getNumericFunctionsSafe().numberFormatDisplay)("convertFromDisplayToFormFunction", ctx.getNumericFunctionsSafe().convertFromDisplayToForm)("convertFromFormToDisplayFunction", ctx.getNumericFunctionsSafe().convertFromFormToDisplay);
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("ngIf", ctx.hasAddOn() && ctx.isNumericAddOnRight());
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("ngIf", ctx.config.labelLeft && !ctx.config.insideBoxValidation);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("errorMessage", ctx.errorMessage)("insideBoxValidation", ctx.config.insideBoxValidation);
    } }, directives: function () { return [FormInputWrapperComponent, ɵngcc1.NgControlStatusGroup, ɵngcc1.FormGroupDirective, ɵngcc2.NgIf, ɵngcc3.NumericComponent, ɵngcc1.NgControlStatus, ɵngcc1.FormControlName, FormValidationMessageComponent]; }, styles: [".space-for-validation[_ngcontent-%COMP%] {\n                min-height: 35px;\n                margin-bottom: 15px;\n            }"] });
FormNumericComponent.ctorParameters = () => [
    { type: Injector }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(FormNumericComponent, [{
        type: Component,
        args: [{
                selector: 'app-form-numeric',
                template: "<dynamic-form-input-wrapper [parentControl]=\"thisControl\" [formGroup]=\"getGroup()\">\n    <div [class.input-group]=\"hasAddOn()\">\n        <span *ngIf=\"hasAddOn() && !isNumericAddOnRight()\" class=\"input-group-addon\" [innerHTML]=\"getNumericAddOn()\"></span>\n        <mt-numeric\n            (blur)=\"onBlur()\"\n            (focus)=\"onFocus()\"\n            (ready)=\"numericControlApi = $event\"\n            [placeholder]=\"config.placeholder\"\n            [formControlName]=\"config.name\"\n            [type]=\"numericControlType\"\n            [scale]=\"config.type.scale\"\n            [doNotAllowZero]=\"config.type.doNotAllowZero\"\n            [numberFormatDisplayFunction]=\"getNumericFunctionsSafe().numberFormatDisplay\"\n            [convertFromDisplayToFormFunction]=\"getNumericFunctionsSafe().convertFromDisplayToForm\"\n            [convertFromFormToDisplayFunction]=\"getNumericFunctionsSafe().convertFromFormToDisplay\"\n        >\n        </mt-numeric>\n        <span *ngIf=\"hasAddOn() && isNumericAddOnRight()\" class=\"input-group-addon\" [innerHTML]=\"getNumericAddOn()\"></span>\n    </div>\n    <span *ngIf=\"config.labelLeft && !config.insideBoxValidation\" [style.visibility]=\"'hidden'\" class=\"small pull-right\">spacer</span>\n    <dynamic-form-validation-message\n        [errorMessage]=\"errorMessage\"\n        [insideBoxValidation]=\"config.insideBoxValidation\"\n    ></dynamic-form-validation-message>\n</dynamic-form-input-wrapper>\n",
                styles: [`
            .space-for-validation {
                min-height: 35px;
                margin-bottom: 15px;
            }
        `]
            }]
    }], function () { return [{ type: ɵngcc0.Injector }]; }, null); })();

class FormElementsBase {
    constructor(changeDetectorRefOrInjector) {
        if (changeDetectorRefOrInjector.get) {
            const moduleConfig = changeDetectorRefOrInjector.get(DynamicFormModuleConfig);
            this.moduleErrorMessageHandler = moduleConfig.errorMessageHandler;
        }
    }
    getControl() {
        return this.getControlFromFormGroup(this.parentGroup, this.config);
    }
    getControlFromFormGroup(group, config) {
        let control = group.get([config.formGroup, config.name]);
        if (!control) {
            control = group.get(config.name);
        }
        return control;
    }
    getGroup() {
        return this.getGroupFromConfig(this.parentGroup, this.config);
    }
    getGroupFromConfig(parentGroup, config) {
        let group = config.formGroup ? parentGroup.get([config.formGroup]) : parentGroup;
        return group;
    }
    setRequired(required) {
        this.config.setRequired(required);
        this.getControl().setValidators(this.config.validation.map((v) => v));
        this.getControl().updateValueAndValidity({ onlySelf: true, emitEvent: false });
    }
    getMaxLength() {
        var _a, _b, _c, _d;
        return (_d = (_c = (_b = (_a = this.config) === null || _a === void 0 ? void 0 : _a.validators) === null || _b === void 0 ? void 0 : _b.maxlength) === null || _c === void 0 ? void 0 : _c.toString()) !== null && _d !== void 0 ? _d : '';
    }
    getMaxLengthValue() {
        var _a, _b, _c;
        return (_c = (_b = (_a = this.config) === null || _a === void 0 ? void 0 : _a.validators) === null || _b === void 0 ? void 0 : _b.maxlength) !== null && _c !== void 0 ? _c : 0;
    }
    getMaxLengthText() {
        const control = this.getControl();
        return `${control.value && control.value.length ? control.value.length : 0}/${this.config.validators.maxlength}`;
    }
    hasMaxLength() {
        var _a, _b;
        return ((_b = (_a = this.config) === null || _a === void 0 ? void 0 : _a.validators) === null || _b === void 0 ? void 0 : _b.maxlength) ? true : false;
    }
    showRequired() {
        var _a, _b, _c, _d;
        return ((_b = (_a = this.config) === null || _a === void 0 ? void 0 : _a.validators) === null || _b === void 0 ? void 0 : _b.required) && ((_d = (_c = this.config) === null || _c === void 0 ? void 0 : _c.validators) === null || _d === void 0 ? void 0 : _d.showRequired);
    }
    showOptional() {
        var _a, _b, _c, _d;
        return !((_b = (_a = this.config) === null || _a === void 0 ? void 0 : _a.validators) === null || _b === void 0 ? void 0 : _b.required) && ((_d = (_c = this.config) === null || _c === void 0 ? void 0 : _c.validators) === null || _d === void 0 ? void 0 : _d.showOptional);
    }
    hasError(error) {
        const control = this.getControl();
        if (error) {
            return control.hasError(error) && (error === 'maxlength' || control.touched);
        }
        else {
            return control.errors && (control.touched || control.errors.maxlength);
        }
    }
    get errorMessage() {
        const control = this.getControl();
        const errors = control === null || control === void 0 ? void 0 : control.errors;
        if (!(errors && (control === null || control === void 0 ? void 0 : control.touched))) {
            return '';
        }
        const message = Object.keys(errors)
            .map((key) => this.getErrorMessageFromKey(key, errors))
            .filter((message) => message)
            .join(', ');
        return message;
    }
    getErrorMessageFromKey(key, errors) {
        var _a;
        const customErrorMessageHandler = (_a = this.config.errorMessageHandler) !== null && _a !== void 0 ? _a : this.moduleErrorMessageHandler;
        return CustomFormValidation.getErrorMessageFromKey(key, errors, this.config, customErrorMessageHandler);
    }
}

class FormPasswordComponent extends FormElementsBase {
    constructor(changeDetectorRefOrInjector) {
        super(changeDetectorRefOrInjector);
        this.isFocused = false;
        this.blur = new EventEmitter();
        this.focus = new EventEmitter();
        this.valueChanges = new EventEmitter();
        this.subscriptions = new Subscription();
        if (changeDetectorRefOrInjector.detectChanges) {
            this.changeDetectorRef = changeDetectorRefOrInjector;
        }
        else {
            this.changeDetectorRef = changeDetectorRefOrInjector.get(ChangeDetectorRef);
        }
    }
    ngOnInit() {
        this.subscriptions.add(this.getControl().mtExternalFocusEvent.subscribe(() => {
            this.focusMe();
        }));
        this.subscriptions.add(this.getControl().mtSetRequiredEvent.subscribe((required) => {
            this.setRequired(required);
        }));
        this.autoFocus = this.config.autoFocus;
    }
    ngAfterViewInit() {
        this.subscriptions.add(this.getControl().valueChanges.subscribe((value) => {
            this.valueChanges.emit(value);
        }));
        if (this.autoFocus) {
            this.autoFocus = false;
            setTimeout(() => {
                this.focusMe();
                this.changeDetectorRef.detectChanges();
            });
        }
    }
    ngOnDestroy() {
        this.subscriptions.unsubscribe();
    }
    focusMe() {
        this.inputElement.nativeElement.focus();
    }
    hasRegexError() {
        const control = this.getControl();
        if (control.errors && control.touched && control.errors.pattern) {
            control.setErrors({ pattern: true });
            return true;
        }
        return false;
    }
    onBlur() {
        this.isFocused = false;
        this.blur.emit();
    }
    onFocus() {
        this.isFocused = true;
        this.focus.emit();
    }
}
FormPasswordComponent.ɵfac = function FormPasswordComponent_Factory(t) { return new (t || FormPasswordComponent)(ɵngcc0.ɵɵdirectiveInject(Injector)); };
FormPasswordComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: FormPasswordComponent, selectors: [["app-form-password"]], viewQuery: function FormPasswordComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(_c1, true);
    } if (rf & 2) {
        var _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.inputElement = _t.first);
    } }, outputs: { blur: "blur", focus: "focus", valueChanges: "valueChanges" }, features: [ɵngcc0.ɵɵInheritDefinitionFeature], decls: 25, vars: 24, consts: [[1, "dynamic-field", "form-input", 3, "formGroup"], [1, "control-label", 3, "hidden", "ngClass"], [1, "dynamic-field-label", 3, "innerHTML"], ["class", "fa fa-info-circle", "aria-hidden", "true", "data-toggle", "tooltip", "data-html", "true", "data-placement", "right", 3, "title", 4, "ngIf"], ["class", "errortext", 4, "ngIf"], ["class", "small text-muted", 4, "ngIf"], [3, "ngClass"], ["type", "password", 1, "form-control", 3, "formControlName", "focus", "blur"], ["input", ""], ["class", "small pull-right", 3, "visibility", 4, "ngIf"], [3, "errorMessage", "insideBoxValidation"], ["aria-hidden", "true", "data-toggle", "tooltip", "data-html", "true", "data-placement", "right", 1, "fa", "fa-info-circle", 3, "title"], [1, "errortext"], [1, "small", "text-muted"], [1, "small", "pull-right"]], template: function FormPasswordComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵtext(1, "\n    ");
        ɵngcc0.ɵɵelementStart(2, "span", 1);
        ɵngcc0.ɵɵtext(3, "\n        ");
        ɵngcc0.ɵɵelementStart(4, "span", 2);
        ɵngcc0.ɵɵtext(5, " ");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtext(6, "\n        ");
        ɵngcc0.ɵɵtemplate(7, FormPasswordComponent_i_7_Template, 1, 1, "i", 3);
        ɵngcc0.ɵɵtext(8, "\n        ");
        ɵngcc0.ɵɵtemplate(9, FormPasswordComponent_span_9_Template, 2, 0, "span", 4);
        ɵngcc0.ɵɵtext(10, "\n        ");
        ɵngcc0.ɵɵtemplate(11, FormPasswordComponent_span_11_Template, 5, 0, "span", 5);
        ɵngcc0.ɵɵtext(12, "\n    ");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtext(13, "\n    ");
        ɵngcc0.ɵɵelementStart(14, "span", 6);
        ɵngcc0.ɵɵtext(15, "\n        ");
        ɵngcc0.ɵɵelementStart(16, "input", 7, 8);
        ɵngcc0.ɵɵlistener("focus", function FormPasswordComponent_Template_input_focus_16_listener() { return ctx.onFocus(); })("blur", function FormPasswordComponent_Template_input_blur_16_listener() { return ctx.onBlur(); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtext(18, "\n        ");
        ɵngcc0.ɵɵtemplate(19, FormPasswordComponent_span_19_Template, 2, 2, "span", 9);
        ɵngcc0.ɵɵtext(20, "\n        ");
        ɵngcc0.ɵɵelement(21, "dynamic-form-validation-message", 10);
        ɵngcc0.ɵɵtext(22, "\n    ");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtext(23, "\n");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtext(24, "\n");
    } if (rf & 2) {
        ɵngcc0.ɵɵstyleProp("min-height", 35, "px")("margin-bottom", 15, "px");
        ɵngcc0.ɵɵclassProp("has-error", ctx.hasError())("form-horizontal", ctx.config.labelLeft)("form-group", ctx.config.labelLeft);
        ɵngcc0.ɵɵproperty("formGroup", ctx.getGroup());
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("hidden", ctx.config.labelHidden)("ngClass", ctx.config.labelLeft ? "col-sm-" + ctx.config.labelCols : null);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("innerHTML", ctx.config.labelHtml, ɵngcc0.ɵɵsanitizeHtml);
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("ngIf", ctx.config.failedPatternMessage);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", ctx.showRequired());
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", ctx.showOptional());
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("ngClass", ctx.config.labelLeft ? "col-sm-" + ctx.config.controlCols : null);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("formControlName", ctx.config.name);
        ɵngcc0.ɵɵattribute("placeholder", ctx.config.placeholder)("autocomplete", !ctx.config.autoCompleteEnabled ? "new-password" : null);
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("ngIf", ctx.config.labelLeft && !ctx.config.insideBoxValidation);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("errorMessage", ctx.errorMessage)("insideBoxValidation", ctx.config.insideBoxValidation);
    } }, directives: function () { return [ɵngcc1.NgControlStatusGroup, ɵngcc1.FormGroupDirective, ɵngcc2.NgClass, ɵngcc2.NgIf, ɵngcc1.DefaultValueAccessor, ɵngcc1.NgControlStatus, ɵngcc1.FormControlName, FormValidationMessageComponent]; }, encapsulation: 2 });
FormPasswordComponent.ctorParameters = () => [
    { type: undefined, decorators: [{ type: Inject, args: [Injector,] }] }
];
FormPasswordComponent.propDecorators = {
    blur: [{ type: Output }],
    focus: [{ type: Output }],
    valueChanges: [{ type: Output }],
    inputElement: [{ type: ViewChild, args: ['input', { static: false },] }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(FormPasswordComponent, [{
        type: Component,
        args: [{
                selector: 'app-form-password',
                template: "<div\n    class=\"dynamic-field form-input\"\n    [class.has-error]=\"hasError()\"\n    [style.minHeight.px]=\"35\"\n    [style.marginBottom.px]=\"15\"\n    [class.form-horizontal]=\"config.labelLeft\"\n    [class.form-group]=\"config.labelLeft\"\n    [formGroup]=\"getGroup()\"\n>\n    <span class=\"control-label\" [hidden]=\"config.labelHidden\" [ngClass]=\"config.labelLeft ? 'col-sm-' + config.labelCols : null\">\n        <span class=\"dynamic-field-label\" [innerHTML]=\"config.labelHtml\"> </span>\n        <i\n            *ngIf=\"config.failedPatternMessage\"\n            class=\"fa fa-info-circle\"\n            aria-hidden=\"true\"\n            data-toggle=\"tooltip\"\n            data-html=\"true\"\n            data-placement=\"right\"\n            [title]=\"config.failedPatternMessage\"\n        ></i>\n        <span *ngIf=\"showRequired()\" class=\"errortext\"> *</span>\n        <span *ngIf=\"showOptional()\" class=\"small text-muted\">\n            <em>optional</em>\n        </span>\n    </span>\n    <span [ngClass]=\"config.labelLeft ? 'col-sm-' + config.controlCols : null\">\n        <input\n            #input\n            type=\"password\"\n            (focus)=\"onFocus()\"\n            (blur)=\"onBlur()\"\n            [attr.placeholder]=\"config.placeholder\"\n            [formControlName]=\"config.name\"\n            class=\"form-control\"\n            [attr.autocomplete]=\"!config.autoCompleteEnabled ? 'new-password' : null\"\n        />\n        <span *ngIf=\"config.labelLeft && !config.insideBoxValidation\" [style.visibility]=\"'hidden'\" class=\"small pull-right\">spacer</span>\n        <dynamic-form-validation-message\n            [errorMessage]=\"errorMessage\"\n            [insideBoxValidation]=\"config.insideBoxValidation\"\n        ></dynamic-form-validation-message>\n    </span>\n</div>\n"
            }]
    }], function () { return [{ type: undefined, decorators: [{
                type: Inject,
                args: [Injector]
            }] }]; }, { blur: [{
            type: Output
        }], focus: [{
            type: Output
        }], valueChanges: [{
            type: Output
        }], inputElement: [{
            type: ViewChild,
            args: ['input', { static: false }]
        }] }); })();

class FormCheckBoxComponent extends FormElementsBase {
    constructor(injector) {
        super(injector);
        this.isFocused = false;
        this.subscriptions = new Subscription();
        this.blur = new EventEmitter();
        this.focus = new EventEmitter();
        this.valueChanges = new EventEmitter();
    }
    ngOnInit() {
        this.subscriptions.add(this.getControl().mtExternalFocusEvent.subscribe(() => {
            this.focusMe();
        }));
        this.subscriptions.add(this.getControl().mtSetRequiredEvent.subscribe((required) => {
            this.setRequired(required);
        }));
    }
    ngAfterViewInit() {
        this.subscriptions.add(this.getControl().valueChanges.subscribe((value) => {
            this.valueChanges.emit(value);
        }));
    }
    ngOnDestroy() {
        this.subscriptions.unsubscribe();
    }
    focusMe() {
        this.inputElement.nativeElement.focus();
    }
    onBlur() {
        this.isFocused = false;
        this.blur.emit();
    }
    onFocus() {
        this.isFocused = true;
        this.focus.emit();
    }
    labelClicked() {
        let control = this.getControl();
        if (control.enabled) {
            control.patchValue(control.value === true ? false : true);
            control.markAsDirty();
            control.markAsTouched();
        }
    }
}
FormCheckBoxComponent.ɵfac = function FormCheckBoxComponent_Factory(t) { return new (t || FormCheckBoxComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Injector)); };
FormCheckBoxComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: FormCheckBoxComponent, selectors: [["app-form-checkbox"]], viewQuery: function FormCheckBoxComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(_c1, true);
    } if (rf & 2) {
        var _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.inputElement = _t.first);
    } }, outputs: { blur: "blur", focus: "focus", valueChanges: "valueChanges" }, features: [ɵngcc0.ɵɵInheritDefinitionFeature], decls: 13, vars: 13, consts: [[1, "dynamic-field", "form-check", 3, "formGroup"], ["class", "control-label", 3, "ngClass", 4, "ngIf"], [3, "ngClass"], ["type", "checkbox", 1, "form-check-input", 3, "id", "formControlName", "focus", "blur"], ["input", ""], ["class", "form-check-label", 3, "innerHTML", "click", 4, "ngIf"], [1, "control-label", 3, "ngClass"], [1, "form-check-label", 3, "innerHTML", "click"]], template: function FormCheckBoxComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵtext(1, "\n    ");
        ɵngcc0.ɵɵtemplate(2, FormCheckBoxComponent_span_2_Template, 4, 2, "span", 1);
        ɵngcc0.ɵɵtext(3, "\n    ");
        ɵngcc0.ɵɵelementStart(4, "span", 2);
        ɵngcc0.ɵɵtext(5, "\n        ");
        ɵngcc0.ɵɵelementStart(6, "input", 3, 4);
        ɵngcc0.ɵɵlistener("focus", function FormCheckBoxComponent_Template_input_focus_6_listener() { return ctx.onFocus(); })("blur", function FormCheckBoxComponent_Template_input_blur_6_listener() { return ctx.onBlur(); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtext(8, "\n        ");
        ɵngcc0.ɵɵtemplate(9, FormCheckBoxComponent_span_9_Template, 1, 1, "span", 5);
        ɵngcc0.ɵɵtext(10, "\n    ");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtext(11, "\n");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtext(12, "\n");
    } if (rf & 2) {
        ɵngcc0.ɵɵclassProp("form-horizontal", ctx.config.labelLeft)("form-group", ctx.config.labelLeft);
        ɵngcc0.ɵɵproperty("formGroup", ctx.getGroup());
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", ctx.config.labelLeft);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngClass", ctx.config.labelLeft ? "col-sm-" + ctx.config.controlCols : null);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵstyleProp("margin-top", ctx.config.labelLeft ? 10 : null, "px");
        ɵngcc0.ɵɵproperty("id", ctx.config.name)("formControlName", ctx.config.name);
        ɵngcc0.ɵɵattribute("placeholder", ctx.config.placeholder);
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.config.labelLeft);
    } }, directives: [ɵngcc1.NgControlStatusGroup, ɵngcc1.FormGroupDirective, ɵngcc2.NgIf, ɵngcc2.NgClass, ɵngcc1.CheckboxControlValueAccessor, ɵngcc1.NgControlStatus, ɵngcc1.FormControlName], styles: [".form-horizontal[_ngcontent-%COMP%] {\n                min-height: 20px;\n                margin-top: -3px;\n            }"] });
FormCheckBoxComponent.ctorParameters = () => [
    { type: Injector }
];
FormCheckBoxComponent.propDecorators = {
    blur: [{ type: Output }],
    focus: [{ type: Output }],
    valueChanges: [{ type: Output }],
    inputElement: [{ type: ViewChild, args: ['input', { static: false },] }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(FormCheckBoxComponent, [{
        type: Component,
        args: [{
                selector: 'app-form-checkbox',
                template: "<div class=\"dynamic-field form-check\" [class.form-horizontal]=\"config.labelLeft\" [class.form-group]=\"config.labelLeft\" [formGroup]=\"getGroup()\">\n    <span *ngIf=\"config.labelLeft\" class=\"control-label\" [ngClass]=\"'col-sm-' + config.labelCols\">\n        <span class=\"form-check-label\" (click)=\"labelClicked()\" [innerHTML]=\"config.labelHtml\"></span>\n    </span>\n    <span [ngClass]=\"config.labelLeft ? 'col-sm-' + config.controlCols : null\">\n        <input\n            #input\n            type=\"checkbox\"\n            (focus)=\"onFocus()\"\n            [id]=\"config.name\"\n            (blur)=\"onBlur()\"\n            [attr.placeholder]=\"config.placeholder\"\n            [formControlName]=\"config.name\"\n            class=\"form-check-input\"\n            [style.marginTop.px]=\"config.labelLeft ? 10 : null\"\n        />\n        <span *ngIf=\"!config.labelLeft\" class=\"form-check-label\" (click)=\"labelClicked()\" [innerHTML]=\"config.labelHtml\"></span>\n    </span>\n</div>\n",
                styles: [`
            .form-horizontal {
                min-height: 20px;
                margin-top: -3px;
            }
        `]
            }]
    }], function () { return [{ type: ɵngcc0.Injector }]; }, { blur: [{
            type: Output
        }], focus: [{
            type: Output
        }], valueChanges: [{
            type: Output
        }], inputElement: [{
            type: ViewChild,
            args: ['input', { static: false }]
        }] }); })();

class FormMtAddressComponent {
    constructor() {
        this.isFocused = false;
    }
    getControl() {
        return getControlFromFormGroup(this.parentGroup, this.config);
    }
    getGroup() {
        return getGroupFromConfig(this.parentGroup, this.config);
    }
    hasError() {
        const control = this.getControl();
        return control.errors && (control.touched || control.errors.maxlength);
    }
}
FormMtAddressComponent.ɵfac = function FormMtAddressComponent_Factory(t) { return new (t || FormMtAddressComponent)(); };
FormMtAddressComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: FormMtAddressComponent, selectors: [["app-form-mt-address"]], decls: 2, vars: 3, consts: [[3, "addressContainer", "parentForm", "allowInternationalAddresses"]], template: function FormMtAddressComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelement(0, "mt-address", 0);
        ɵngcc0.ɵɵtext(1, "\n");
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("addressContainer", ctx.config.value)("parentForm", ctx.getGroup())("allowInternationalAddresses", ctx.config.type.allowInternationalAddresses);
    } }, directives: function () { return [MtAddressComponent]; }, encapsulation: 2 });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(FormMtAddressComponent, [{
        type: Component,
        args: [{
                selector: 'app-form-mt-address',
                template: "<mt-address\n    [addressContainer]=\"config.value\"\n    [parentForm]=\"getGroup()\"\n    [allowInternationalAddresses]=\"config.type.allowInternationalAddresses\"\n></mt-address>\n"
            }]
    }], function () { return []; }, null); })();

class FormTypeAheadComponent extends CustomFormControlComponentBase {
    constructor(injector) {
        super(injector);
        this.subscriptions = new Subscription();
    }
    ngOnInit() {
        var _a, _b, _c, _d, _e, _f, _g;
        super.ngOnInit();
        this.items = (_b = (_a = this.config) === null || _a === void 0 ? void 0 : _a.options) !== null && _b !== void 0 ? _b : [];
        this.placeholder = (_d = (_c = this.config) === null || _c === void 0 ? void 0 : _c.placeholder) !== null && _d !== void 0 ? _d : '';
        if ((_g = (_f = (_e = this.config) === null || _e === void 0 ? void 0 : _e.type) === null || _f === void 0 ? void 0 : _f.typeAheadOptions) === null || _g === void 0 ? void 0 : _g.matchingStrategy) {
            this.matchingStrategy = this.config.type.typeAheadOptions.matchingStrategy;
        }
    }
    ngAfterViewInit() {
        this.subscriptions.add(this.getControl().valueChanges.subscribe((value) => {
            if (!value) {
                this.typeAheadApi.clearValue();
            }
        }));
        super.ngAfterViewInit();
    }
    ngOnDestroy() {
        this.subscriptions.unsubscribe();
    }
    selectionChanged(event) {
        if (event === null || event === void 0 ? void 0 : event.selection) {
            this.getControl().setValue(event.selection.Id);
        }
        else {
            let control = this.getControl();
            if (control.value) {
                this.getControl().setValue(null);
            }
        }
    }
    typeAheadControlReady(event) {
        let selectedOption = this.config.options.find((option) => {
            return option.Id === this.config.value;
        });
        event.setValue(selectedOption);
        this.getControl().setValue(this.config.value);
        this.typeAheadApi = event;
    }
    focusMe() {
        this.typeAheadApi.focus();
    }
}
FormTypeAheadComponent.ɵfac = function FormTypeAheadComponent_Factory(t) { return new (t || FormTypeAheadComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Injector)); };
FormTypeAheadComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: FormTypeAheadComponent, selectors: [["ng-component"]], features: [ɵngcc0.ɵɵInheritDefinitionFeature], decls: 15, vars: 11, consts: [[3, "parentControl", "formGroup"], [3, "matchingStrategy", "items", "disabled", "placeholder", "selectedItem", "selectionChanged", "ready"], ["class", "small pull-right", 3, "visibility", "errortext", "inside-box-maxlength", 4, "ngIf"], [3, "errorMessage", "insideBoxValidation"], [1, "small", "pull-right"]], template: function FormTypeAheadComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "dynamic-form-input-wrapper", 0);
        ɵngcc0.ɵɵtext(1, "\n    ");
        ɵngcc0.ɵɵtext(2, "\n    ");
        ɵngcc0.ɵɵelementStart(3, "mt-type-ahead", 1);
        ɵngcc0.ɵɵlistener("selectionChanged", function FormTypeAheadComponent_Template_mt_type_ahead_selectionChanged_3_listener($event) { return ctx.selectionChanged($event); })("ready", function FormTypeAheadComponent_Template_mt_type_ahead_ready_3_listener($event) { return ctx.typeAheadControlReady($event); });
        ɵngcc0.ɵɵtext(4, "\n    ");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtext(5, "\n    ");
        ɵngcc0.ɵɵtext(6, "\n    ");
        ɵngcc0.ɵɵtemplate(7, FormTypeAheadComponent_span_7_Template, 2, 7, "span", 2);
        ɵngcc0.ɵɵtext(8, "\n    ");
        ɵngcc0.ɵɵtemplate(9, FormTypeAheadComponent_span_9_Template, 2, 7, "span", 2);
        ɵngcc0.ɵɵtext(10, "\n    ");
        ɵngcc0.ɵɵtext(11, "\n    ");
        ɵngcc0.ɵɵelement(12, "dynamic-form-validation-message", 3);
        ɵngcc0.ɵɵtext(13, "\n");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtext(14, "\n");
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("parentControl", ctx.thisControl)("formGroup", ctx.getGroup());
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("matchingStrategy", ctx.matchingStrategy)("items", ctx.items)("disabled", ctx.isDisabled)("placeholder", ctx.placeholder)("selectedItem", ctx.selectedItem);
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.config.labelLeft && ctx.hasMaxLength());
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", ctx.config.labelLeft);
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("errorMessage", ctx.errorMessage)("insideBoxValidation", ctx.config.insideBoxValidation);
    } }, directives: function () { return [FormInputWrapperComponent, ɵngcc1.NgControlStatusGroup, ɵngcc1.FormGroupDirective, ɵngcc4.TypeAheadComponent, ɵngcc2.NgIf, FormValidationMessageComponent]; }, styles: [_c2] });
FormTypeAheadComponent.ctorParameters = () => [
    { type: Injector }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(FormTypeAheadComponent, [{
        type: Component,
        args: [{
                template: "<dynamic-form-input-wrapper [parentControl]=\"thisControl\" [formGroup]=\"getGroup()\">\n    <!-- input element -->\n    <mt-type-ahead\n        [matchingStrategy]=\"matchingStrategy\"\n        [items]=\"items\"\n        [disabled]=\"isDisabled\"\n        [placeholder]=\"placeholder\"\n        (selectionChanged)=\"selectionChanged($event)\"\n        (ready)=\"typeAheadControlReady($event)\"\n        [selectedItem]=\"selectedItem\"\n    >\n    </mt-type-ahead>\n    <!-- maxlength elements -->\n    <span\n        *ngIf=\"!config.labelLeft && hasMaxLength()\"\n        [style.visibility]=\"isFocused && hasMaxLength() ? null : 'hidden'\"\n        class=\"small pull-right\"\n        [class.errortext]=\"hasError('maxlength')\"\n        [class.inside-box-maxlength]=\"config.insideBoxValidation\"\n        >{{ getMaxLengthText() }}</span\n    >\n    <span\n        *ngIf=\"config.labelLeft\"\n        [style.visibility]=\"isFocused && hasMaxLength() ? null : 'hidden'\"\n        class=\"small pull-right\"\n        [class.errortext]=\"hasError('maxlength')\"\n        [class.inside-box-maxlength]=\"config.insideBoxValidation\"\n        >{{ getMaxLengthText() }}</span\n    >\n    <!-- validation elements -->\n    <dynamic-form-validation-message\n        [errorMessage]=\"errorMessage\"\n        [insideBoxValidation]=\"config.insideBoxValidation\"\n    ></dynamic-form-validation-message>\n</dynamic-form-input-wrapper>\n",
                styles: [`
            .inside-box-maxlength {
                position: relative !important;
                bottom: -13px;
                top: -13px;
                margin-bottom: -13px;
                right: 3px;
                font-size: 70%;
            }
        `]
            }]
    }], function () { return [{ type: ɵngcc0.Injector }]; }, null); })();

class FormPhoneComponent extends CustomFormControlComponentBase {
    constructor(injector) {
        super(injector);
    }
    ngOnInit() {
        super.ngOnInit();
        this.subscribeToStatusChanges();
        this.subscribeToValueChanges();
    }
    ngAfterViewInit() {
        super.ngAfterViewInit();
        this.formatNativePhoneElement(this.config.value);
    }
    subscribeToStatusChanges() {
        this.subscriptions.add(this.getControl().statusChanges.subscribe((status) => {
            this.inputElement.nativeElement.disabled = status === 'DISABLED';
        }));
    }
    subscribeToValueChanges() {
        this.subscriptions.add(this.getControl().valueChanges.subscribe((value) => {
            this.formatNativePhoneElement(value);
        }));
    }
    formatNativePhoneElement(value) {
        this.inputElement.nativeElement.value = formatPhone(value);
    }
    onBlur() {
        if (this.getControl().enabled) {
            this.setPhoneValue();
            this._isFocused = false;
            this.blur.emit(true);
        }
    }
    setPhoneValue() {
        const control = this.getControl();
        const phoneControl = this.inputElement;
        let value = phoneControl.nativeElement.value;
        value = value.replace(/\D/g, '');
        if (control.value !== value) {
            control.setValue(value);
            control.markAsDirty();
        }
    }
}
FormPhoneComponent.ɵfac = function FormPhoneComponent_Factory(t) { return new (t || FormPhoneComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Injector)); };
FormPhoneComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: FormPhoneComponent, selectors: [["ng-component"]], features: [ɵngcc0.ɵɵInheritDefinitionFeature], decls: 17, vars: 10, consts: [[3, "parentControl", "formGroup"], ["type", "tel", 1, "hidden", 3, "formControlName", "value"], ["type", "tel", "phoneMask", "", 1, "form-control", 3, "focus", "blur", "keydown.enter"], ["inputElement", ""], ["class", "small pull-right", 3, "visibility", "errortext", "inside-box-maxlength", 4, "ngIf"], [3, "errorMessage", "insideBoxValidation"], [1, "small", "pull-right"]], template: function FormPhoneComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "dynamic-form-input-wrapper", 0);
        ɵngcc0.ɵɵtext(1, "\n    ");
        ɵngcc0.ɵɵtext(2, "\n    ");
        ɵngcc0.ɵɵelement(3, "input", 1);
        ɵngcc0.ɵɵtext(4, "\n    ");
        ɵngcc0.ɵɵelementStart(5, "input", 2, 3);
        ɵngcc0.ɵɵlistener("focus", function FormPhoneComponent_Template_input_focus_5_listener() { return ctx.onFocus(); })("blur", function FormPhoneComponent_Template_input_blur_5_listener() { return ctx.onBlur(); })("keydown.enter", function FormPhoneComponent_Template_input_keydown_enter_5_listener() { return ctx.setPhoneValue(); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtext(7, "\n    ");
        ɵngcc0.ɵɵtext(8, "\n    ");
        ɵngcc0.ɵɵtemplate(9, FormPhoneComponent_span_9_Template, 2, 7, "span", 4);
        ɵngcc0.ɵɵtext(10, "\n    ");
        ɵngcc0.ɵɵtemplate(11, FormPhoneComponent_span_11_Template, 2, 7, "span", 4);
        ɵngcc0.ɵɵtext(12, "\n    ");
        ɵngcc0.ɵɵtext(13, "\n    ");
        ɵngcc0.ɵɵelement(14, "dynamic-form-validation-message", 5);
        ɵngcc0.ɵɵtext(15, "\n");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtext(16, "\n");
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("parentControl", ctx.thisControl)("formGroup", ctx.getGroup());
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("formControlName", ctx.config.name)("value", ctx.config.value);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵattribute("placeholder", ctx.config.placeholder)("autocomplete", !ctx.config.autoCompleteEnabled ? "new-password" : null);
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.config.labelLeft && ctx.hasMaxLength());
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", ctx.config.labelLeft);
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("errorMessage", ctx.errorMessage)("insideBoxValidation", ctx.config.insideBoxValidation);
    } }, directives: function () { return [FormInputWrapperComponent, ɵngcc1.NgControlStatusGroup, ɵngcc1.FormGroupDirective, ɵngcc1.DefaultValueAccessor, ɵngcc1.NgControlStatus, ɵngcc1.FormControlName, PhoneMaskDirective, ɵngcc2.NgIf, FormValidationMessageComponent]; }, styles: [_c2] });
FormPhoneComponent.ctorParameters = () => [
    { type: Injector }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(FormPhoneComponent, [{
        type: Component,
        args: [{
                template: "<dynamic-form-input-wrapper [parentControl]=\"thisControl\" [formGroup]=\"getGroup()\">\n    <!-- input element -->\n    <input type=\"tel\" class=\"hidden\" [formControlName]=\"config.name\" [value]=\"config.value\" />\n    <input\n        #inputElement\n        type=\"tel\"\n        (focus)=\"onFocus()\"\n        (blur)=\"onBlur()\"\n        [attr.placeholder]=\"config.placeholder\"\n        class=\"form-control\"\n        phoneMask\n        (keydown.enter)=\"setPhoneValue()\"\n        [attr.autocomplete]=\"!config.autoCompleteEnabled ? 'new-password' : null\"\n    />\n    <!-- maxlength elements -->\n    <span\n        *ngIf=\"!config.labelLeft && hasMaxLength()\"\n        [style.visibility]=\"isFocused && hasMaxLength() ? null : 'hidden'\"\n        class=\"small pull-right\"\n        [class.errortext]=\"hasError('maxlength')\"\n        [class.inside-box-maxlength]=\"config.insideBoxValidation\"\n        >{{ getMaxLengthText() }}</span\n    >\n    <span\n        *ngIf=\"config.labelLeft\"\n        [style.visibility]=\"isFocused && hasMaxLength() ? null : 'hidden'\"\n        class=\"small pull-right\"\n        [class.errortext]=\"hasError('maxlength')\"\n        [class.inside-box-maxlength]=\"config.insideBoxValidation\"\n        >{{ getMaxLengthText() }}</span\n    >\n    <!-- validation elements -->\n    <dynamic-form-validation-message\n        [errorMessage]=\"errorMessage\"\n        [insideBoxValidation]=\"config.insideBoxValidation\"\n    ></dynamic-form-validation-message>\n</dynamic-form-input-wrapper>\n",
                styles: [`
            .inside-box-maxlength {
                position: relative !important;
                bottom: -13px;
                top: -13px;
                margin-bottom: -13px;
                right: 3px;
                font-size: 70%;
            }
        `]
            }]
    }], function () { return [{ type: ɵngcc0.Injector }]; }, null); })();

class FormTextareaComponent extends CustomFormControlComponentBase {
    constructor(injector) {
        super(injector);
    }
}
FormTextareaComponent.ɵfac = function FormTextareaComponent_Factory(t) { return new (t || FormTextareaComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Injector)); };
FormTextareaComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: FormTextareaComponent, selectors: [["ng-component"]], features: [ɵngcc0.ɵɵInheritDefinitionFeature], decls: 15, vars: 10, consts: [[3, "parentControl", "formGroup"], [1, "form-control", 3, "formControlName", "maxlength", "focus", "blur"], ["inputElement", ""], ["class", "small pull-right", 3, "visibility", "errortext", "inside-box-maxlength", 4, "ngIf"], [3, "errorMessage", "insideBoxValidation"], [1, "small", "pull-right"]], template: function FormTextareaComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "dynamic-form-input-wrapper", 0);
        ɵngcc0.ɵɵtext(1, "\n    ");
        ɵngcc0.ɵɵtext(2, "\n    ");
        ɵngcc0.ɵɵelementStart(3, "textarea", 1, 2);
        ɵngcc0.ɵɵlistener("focus", function FormTextareaComponent_Template_textarea_focus_3_listener() { return ctx.onFocus(); })("blur", function FormTextareaComponent_Template_textarea_blur_3_listener() { return ctx.onBlur(); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtext(5, "\n    ");
        ɵngcc0.ɵɵtext(6, "\n    ");
        ɵngcc0.ɵɵtemplate(7, FormTextareaComponent_span_7_Template, 2, 7, "span", 3);
        ɵngcc0.ɵɵtext(8, "\n    ");
        ɵngcc0.ɵɵtemplate(9, FormTextareaComponent_span_9_Template, 2, 7, "span", 3);
        ɵngcc0.ɵɵtext(10, "\n    ");
        ɵngcc0.ɵɵtext(11, "\n    ");
        ɵngcc0.ɵɵelement(12, "dynamic-form-validation-message", 4);
        ɵngcc0.ɵɵtext(13, "\n");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtext(14, "\n");
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("parentControl", ctx.thisControl)("formGroup", ctx.getGroup());
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("formControlName", ctx.config.name)("maxlength", ctx.getMaxLength());
        ɵngcc0.ɵɵattribute("placeholder", ctx.config.placeholder)("autocomplete", !ctx.config.autoCompleteEnabled ? "new-password" : null);
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.config.labelLeft && ctx.hasMaxLength());
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", ctx.config.labelLeft);
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("errorMessage", ctx.errorMessage)("insideBoxValidation", ctx.config.insideBoxValidation);
    } }, directives: function () { return [FormInputWrapperComponent, ɵngcc1.NgControlStatusGroup, ɵngcc1.FormGroupDirective, ɵngcc1.DefaultValueAccessor, ɵngcc1.NgControlStatus, ɵngcc1.FormControlName, ɵngcc1.MaxLengthValidator, ɵngcc2.NgIf, FormValidationMessageComponent]; }, styles: [_c2] });
FormTextareaComponent.ctorParameters = () => [
    { type: Injector }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(FormTextareaComponent, [{
        type: Component,
        args: [{
                template: "<dynamic-form-input-wrapper [parentControl]=\"thisControl\" [formGroup]=\"getGroup()\">\n    <!-- input element -->\n    <textarea\n        #inputElement\n        (focus)=\"onFocus()\"\n        (blur)=\"onBlur()\"\n        [attr.placeholder]=\"config.placeholder\"\n        [formControlName]=\"config.name\"\n        class=\"form-control\"\n        [maxlength]=\"getMaxLength()\"\n        [attr.autocomplete]=\"!config.autoCompleteEnabled ? 'new-password' : null\"\n    ></textarea>\n    <!-- maxlength elements -->\n    <span\n        *ngIf=\"!config.labelLeft && hasMaxLength()\"\n        [style.visibility]=\"isFocused && hasMaxLength() ? null : 'hidden'\"\n        class=\"small pull-right\"\n        [class.errortext]=\"hasError('maxlength')\"\n        [class.inside-box-maxlength]=\"config.insideBoxValidation\"\n        >{{ getMaxLengthText() }}</span\n    >\n    <span\n        *ngIf=\"config.labelLeft\"\n        [style.visibility]=\"isFocused && hasMaxLength() ? null : 'hidden'\"\n        class=\"small pull-right\"\n        [class.errortext]=\"hasError('maxlength')\"\n        [class.inside-box-maxlength]=\"config.insideBoxValidation\"\n        >{{ getMaxLengthText() }}</span\n    >\n    <!-- validation elements -->\n    <dynamic-form-validation-message\n        [errorMessage]=\"errorMessage\"\n        [insideBoxValidation]=\"config.insideBoxValidation\"\n    ></dynamic-form-validation-message>\n</dynamic-form-input-wrapper>\n",
                styles: [`
            .inside-box-maxlength {
                position: relative !important;
                bottom: -13px;
                top: -13px;
                margin-bottom: -13px;
                right: 3px;
                font-size: 70%;
            }
        `]
            }]
    }], function () { return [{ type: ɵngcc0.Injector }]; }, null); })();

class FormDatePickerComponent extends CustomFormControlComponentBase {
    constructor(injector, datePipe, moduleConfig) {
        super(injector);
        this.datePipe = datePipe;
        this.moduleConfig = moduleConfig;
        this.showDatePicker = false;
        this.datepickerMinDate = null;
        this.datepickerMaxDate = null;
    }
    get showClearButton() {
        var _a, _b;
        let showClearButton = (_a = this.config.type.datepickerOptions) === null || _a === void 0 ? void 0 : _a.showClearButton;
        if (showClearButton === undefined) {
            return (_b = this.moduleConfig.datePickerShowClearButton) !== null && _b !== void 0 ? _b : false;
        }
        else {
            return showClearButton;
        }
    }
    ngOnInit() {
        super.ngOnInit();
        if (this.config.value && !(this.config.value instanceof Date)) {
            this.config.value = new Date(this.config.value.toString());
        }
        this.firstDayOfTheWeek = this.getFirstDayOfTheWeek();
        this.datepickerMinDate = this.getDatepickerMinDate();
        // I set this to null so I always have a future date to trigger the hack logic below
        // this is reset when the date is reset to it's config value.
        this.datepickerMaxDate = null;
    }
    ngAfterViewInit() {
        super.ngAfterViewInit();
        setTimeout(() => {
            var _a;
            this.getControl().patchValue(this.config.value);
            // HACK: This is a patch because the initial values of the ng bootstrap component don't get set properly with Ivy.
            // To fix this we set the date initially to something in the future then later back so it is displayed correctly.
            const tempDate = new Date((_a = this.config.value) !== null && _a !== void 0 ? _a : new Date()).mtDate.add(1, DateParts.years).add(1, DateParts.months).date;
            this.handleValueChange(tempDate);
            this.selectedDateText = this.dateAsText();
            this.subscriptions.add(this.getControl().valueChanges.subscribe(this.handleValueChange.bind(this)));
            this.changeDetectorRef.detectChanges();
        });
        setTimeout(() => {
            var _a;
            this.datepickerMaxDate = this.getDatepickerMaxDate();
            this.handleValueChange((_a = this.config.value) !== null && _a !== void 0 ? _a : new Date());
        }, 100);
    }
    handleValueChange(value) {
        if (!value) {
            // value is null when we are clearing out the date, so default to reset calendar to today
            value = new Date();
        }
        if (typeof value === 'string') {
            value = new Date(value);
        }
        this.selectedDateText = this.dateAsText();
        this.changeDetectorRef.detectChanges();
        this.navigateCalendarAndSetSelectedDateOnChange(value);
    }
    toggleDatePicker() {
        if (this.getControl().enabled) {
            this.showDatePicker = !this.showDatePicker;
        }
    }
    dateSelected(date) {
        this.showDatePicker = false;
        this.getControl().patchValue(new Date(date.year, date.month - 1, date.day));
        this.getControl().markAsDirty();
    }
    getFirstDayOfTheWeek() {
        var _a, _b, _c;
        return (_c = (_b = (_a = this.config) === null || _a === void 0 ? void 0 : _a.type) === null || _b === void 0 ? void 0 : _b.datepickerOptions) === null || _c === void 0 ? void 0 : _c.firstDayOfTheWeek;
    }
    getDatepickerMinDate() {
        var _a, _b, _c, _d;
        return ((_d = (_c = (_b = (_a = this.config) === null || _a === void 0 ? void 0 : _a.type) === null || _b === void 0 ? void 0 : _b.datepickerOptions) === null || _c === void 0 ? void 0 : _c.minDate) === null || _d === void 0 ? void 0 : _d.day) ? this.config.type.datepickerOptions.minDate : null;
    }
    getDatepickerMaxDate() {
        var _a, _b, _c, _d;
        return ((_d = (_c = (_b = (_a = this.config) === null || _a === void 0 ? void 0 : _a.type) === null || _b === void 0 ? void 0 : _b.datepickerOptions) === null || _c === void 0 ? void 0 : _c.maxDate) === null || _d === void 0 ? void 0 : _d.day) ? this.config.type.datepickerOptions.maxDate : null;
    }
    navigateCalendarAndSetSelectedDateOnChange(dateValue) {
        let ngbDate = new NgbDate(dateValue.getFullYear(), dateValue.getMonth() + 1, dateValue.getDate());
        let datepicker = this.datePicker;
        this.model = ngbDate;
        datepicker.navigateTo({
            day: ngbDate.day,
            month: ngbDate.month,
            year: ngbDate.year,
        });
    }
    dateAsText() {
        var _a, _b;
        let control = this.getControl();
        let value = ((_a = control.value) === null || _a === void 0 ? void 0 : _a.value) ? new Date(control.value.value) : control.value;
        let placeHolder = (_b = this.config.placeholder) !== null && _b !== void 0 ? _b : 'Select a date...';
        return value && value instanceof Date ? this.datePipe.transform(value) : placeHolder;
    }
    clear() {
        this.getControl().reset();
    }
}
FormDatePickerComponent.ɵfac = function FormDatePickerComponent_Factory(t) { return new (t || FormDatePickerComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Injector), ɵngcc0.ɵɵdirectiveInject(ɵngcc2.DatePipe), ɵngcc0.ɵɵdirectiveInject(DynamicFormModuleConfig)); };
FormDatePickerComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: FormDatePickerComponent, selectors: [["ng-component"]], viewQuery: function FormDatePickerComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(_c3, true);
    } if (rf & 2) {
        var _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.datePicker = _t.first);
    } }, features: [ɵngcc0.ɵɵInheritDefinitionFeature], decls: 28, vars: 19, consts: [[3, "parentControl", "formGroup"], ["type", "date", 1, "hidden", 3, "formControlName", "value"], ["ngbButtonLabel", "", 1, "btn-primary-inverse", "selected-date-label", 3, "tabindex", "click", "focus", "blur"], ["input", ""], [1, "fa", "fa-fw", "fa-calendar"], ["type", "button", "class", "btn btn-transparent", 3, "click", 4, "ngIf"], [1, "date-picker-styles", 3, "ngModel", "ngModelOptions", "minDate", "maxDate", "dayTemplate", "firstDayOfWeek", "ngModelChange", "select"], ["datePicker", "", "datePicker", ""], [3, "errorMessage", "insideBoxValidation"], ["customDay", ""], ["type", "button", 1, "btn", "btn-transparent", 3, "click"], [1, "fa", "fa-times"], [1, "date-picker-day-view"]], template: function FormDatePickerComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "dynamic-form-input-wrapper", 0);
        ɵngcc0.ɵɵtext(1, "\n    ");
        ɵngcc0.ɵɵelement(2, "br");
        ɵngcc0.ɵɵtext(3, "\n    ");
        ɵngcc0.ɵɵtext(4, "\n    ");
        ɵngcc0.ɵɵelement(5, "input", 1);
        ɵngcc0.ɵɵtext(6, "\n    ");
        ɵngcc0.ɵɵelementStart(7, "label", 2, 3);
        ɵngcc0.ɵɵlistener("click", function FormDatePickerComponent_Template_label_click_7_listener() { return ctx.toggleDatePicker(); })("focus", function FormDatePickerComponent_Template_label_focus_7_listener() { return ctx.onFocus(); })("blur", function FormDatePickerComponent_Template_label_blur_7_listener() { return ctx.onBlur(); });
        ɵngcc0.ɵɵtext(9);
        ɵngcc0.ɵɵelement(10, "i", 4);
        ɵngcc0.ɵɵtext(11, "\n    ");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtext(12, "\n    ");
        ɵngcc0.ɵɵtemplate(13, FormDatePickerComponent_button_13_Template, 2, 0, "button", 5);
        ɵngcc0.ɵɵtext(14, "\n    ");
        ɵngcc0.ɵɵelement(15, "br");
        ɵngcc0.ɵɵtext(16, "\n    ");
        ɵngcc0.ɵɵelementStart(17, "ngb-datepicker", 6, 7);
        ɵngcc0.ɵɵlistener("ngModelChange", function FormDatePickerComponent_Template_ngb_datepicker_ngModelChange_17_listener($event) { return ctx.model = $event; })("select", function FormDatePickerComponent_Template_ngb_datepicker_select_17_listener($event) { return ctx.dateSelected($event); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtext(20, "\n    ");
        ɵngcc0.ɵɵtext(21, "\n    ");
        ɵngcc0.ɵɵelement(22, "dynamic-form-validation-message", 8);
        ɵngcc0.ɵɵtext(23, "\n");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtext(24, "\n");
        ɵngcc0.ɵɵtemplate(25, FormDatePickerComponent_ng_template_25_Template, 7, 3, "ng-template", null, 9, ɵngcc0.ɵɵtemplateRefExtractor);
        ɵngcc0.ɵɵtext(27, "\n");
    } if (rf & 2) {
        const _r4 = ɵngcc0.ɵɵreference(26);
        ɵngcc0.ɵɵproperty("parentControl", ctx.thisControl)("formGroup", ctx.getGroup());
        ɵngcc0.ɵɵadvance(5);
        ɵngcc0.ɵɵproperty("formControlName", ctx.config.name)("value", ctx.config.value);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("tabindex", ctx.isDisabled ? -1 : 0);
        ɵngcc0.ɵɵattribute("disabled", ctx.isDisabled ? true : null);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵtextInterpolate1("\n        ", ctx.selectedDateText, "\n        ");
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵproperty("ngIf", ctx.showClearButton);
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵclassProp("hidden", !ctx.showDatePicker);
        ɵngcc0.ɵɵproperty("ngModel", ctx.model)("ngModelOptions", ɵngcc0.ɵɵpureFunction0(18, _c4))("minDate", ctx.datepickerMinDate)("maxDate", ctx.datepickerMaxDate)("dayTemplate", _r4)("firstDayOfWeek", ctx.firstDayOfTheWeek);
        ɵngcc0.ɵɵadvance(5);
        ɵngcc0.ɵɵproperty("errorMessage", ctx.errorMessage)("insideBoxValidation", ctx.config.insideBoxValidation);
    } }, directives: function () { return [FormInputWrapperComponent, ɵngcc1.NgControlStatusGroup, ɵngcc1.FormGroupDirective, ɵngcc1.DefaultValueAccessor, ɵngcc1.NgControlStatus, ɵngcc1.FormControlName, ɵngcc5.NgbButtonLabel, ɵngcc2.NgIf, ɵngcc5.NgbDatepicker, ɵngcc1.NgModel, FormValidationMessageComponent]; }, styles: [".selected-date[_ngcontent-%COMP%] {\n                color: white;\n                background-color: #337ab7;\n            }\n            .date-picker-day-view[_ngcontent-%COMP%] {\n                text-align: center;\n                width: 2rem;\n                height: 2rem;\n                line-height: 2rem;\n                border-radius: 0.25rem;\n\n                &.outside {\n                    opacity: 0.5;\n                }\n            }\n            .fa-calendar[_ngcontent-%COMP%] {\n                margin-left: 8px;\n            }\n            .selected-date-label[_ngcontent-%COMP%] {\n                min-width: 170px;\n            }\n            .date-picker-styles[_ngcontent-%COMP%] {\n                min-width: 170px;\n            }"] });
FormDatePickerComponent.ctorParameters = () => [
    { type: Injector },
    { type: DatePipe },
    { type: DynamicFormModuleConfig }
];
FormDatePickerComponent.propDecorators = {
    datePicker: [{ type: ViewChild, args: ['datePicker', { static: false },] }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(FormDatePickerComponent, [{
        type: Component,
        args: [{
                template: "<dynamic-form-input-wrapper [parentControl]=\"thisControl\" [formGroup]=\"getGroup()\">\n    <br />\n    <!-- input element -->\n    <input type=\"date\" class=\"hidden\" [formControlName]=\"config.name\" [value]=\"config.value\" />\n    <label\n        #input\n        [tabindex]=\"isDisabled ? -1 : 0\"\n        class=\"btn-primary-inverse selected-date-label\"\n        ngbButtonLabel\n        (click)=\"toggleDatePicker()\"\n        (focus)=\"onFocus()\"\n        (blur)=\"onBlur()\"\n        [attr.disabled]=\"isDisabled ? true : null\"\n    >\n        {{ selectedDateText }}\n        <i class=\"fa fa-fw fa-calendar\"></i>\n    </label>\n    <button *ngIf=\"showClearButton\" type=\"button\" (click)=\"clear()\" class=\"btn btn-transparent\"><i class=\"fa fa-times\"></i></button>\n    <br />\n    <ngb-datepicker\n        class=\"date-picker-styles\"\n        #datePicker\n        [(ngModel)]=\"model\"\n        [ngModelOptions]=\"{ standalone: true }\"\n        #datePicker\n        [minDate]=\"datepickerMinDate\"\n        [maxDate]=\"datepickerMaxDate\"\n        [class.hidden]=\"!showDatePicker\"\n        (select)=\"dateSelected($event)\"\n        [dayTemplate]=\"customDay\"\n        [firstDayOfWeek]=\"firstDayOfTheWeek\"\n    ></ngb-datepicker>\n    <!-- validation elements -->\n    <dynamic-form-validation-message\n        [errorMessage]=\"errorMessage\"\n        [insideBoxValidation]=\"config.insideBoxValidation\"\n    ></dynamic-form-validation-message>\n</dynamic-form-input-wrapper>\n<ng-template #customDay let-date=\"date\" let-selected=\"selected\">\n    <div class=\"date-picker-day-view\" [class.selected-date]=\"selected\">\n        <span>{{ date.day }}</span>\n    </div>\n</ng-template>\n",
                styles: [`
            .selected-date {
                color: white;
                background-color: #337ab7;
            }
            .date-picker-day-view {
                text-align: center;
                width: 2rem;
                height: 2rem;
                line-height: 2rem;
                border-radius: 0.25rem;

                &.outside {
                    opacity: 0.5;
                }
            }
            .fa-calendar {
                margin-left: 8px;
            }
            .selected-date-label {
                min-width: 170px;
            }
            .date-picker-styles {
                min-width: 170px;
            }
        `]
            }]
    }], function () { return [{ type: ɵngcc0.Injector }, { type: ɵngcc2.DatePipe }, { type: DynamicFormModuleConfig }]; }, { datePicker: [{
            type: ViewChild,
            args: ['datePicker', { static: false }]
        }] }); })();

class FormTimePickerComponent extends CustomFormControlComponentBase {
    constructor(injector, moduleConfig) {
        super(injector);
        this.moduleConfig = moduleConfig;
        this.blur = new EventEmitter();
        this.focus = new EventEmitter();
    }
    get showClearButton() {
        var _a, _b;
        let shouldShowClearButton = (_a = this.config.type.timepickerOptions) === null || _a === void 0 ? void 0 : _a.showClearButton;
        if (shouldShowClearButton === undefined) {
            return (_b = this.moduleConfig.timePickerShowClearButton) !== null && _b !== void 0 ? _b : false;
        }
        else {
            return shouldShowClearButton;
        }
    }
    ngOnInit() {
        super.ngOnInit();
        this.timeControl = new FormControl(this.timeValue);
        if (this.config.value && typeof this.config.value === 'string') {
            this.setTime(this.config.value);
        }
        this.subscriptions.add(this.timeControl.valueChanges.subscribe(this.timeSelected.bind(this)));
        this.subscriptions.add(this.valueChanges.subscribe(this.setTime.bind(this)));
    }
    setTime(time) {
        if (!time) {
            this.timeControl.setValue(null);
            return;
        }
        let [hours, minutes, seconds] = time.split(':').map((item) => parseInt(item, 10));
        this.timeValue = {
            hour: hours,
            minute: minutes,
            second: seconds,
        };
        this.timeControl.setValue(this.timeValue);
        this.changeDetectorRef.detectChanges();
    }
    focusMe() {
        this.timepickerControlApi.focus();
    }
    ngAfterViewInit() {
        super.ngAfterViewInit();
        this.subscriptions.add(this.getControl().statusChanges.subscribe((status) => {
            const isDisabled = status === 'DISABLED';
            let timePicker = this.timePicker;
            timePicker.setDisabledState(isDisabled);
        }));
        if (this.isDisabled) {
            let timePicker = this.timePicker;
            timePicker.setDisabledState(true);
            this.changeDetectorRef.detectChanges();
        }
    }
    timepickerHasMeridian() {
        var _a, _b;
        return (_b = (_a = this.config.type.timepickerOptions) === null || _a === void 0 ? void 0 : _a.meridian) !== null && _b !== void 0 ? _b : false;
    }
    timepickerHasSeconds() {
        var _a, _b;
        return (_b = (_a = this.config.type.timepickerOptions) === null || _a === void 0 ? void 0 : _a.seconds) !== null && _b !== void 0 ? _b : false;
    }
    timepickerHasSpinners() {
        var _a, _b;
        return (_b = (_a = this.config.type.timepickerOptions) === null || _a === void 0 ? void 0 : _a.spinners) !== null && _b !== void 0 ? _b : false;
    }
    timeSelected(timeValue) {
        if (timeValue === '' && this.getControl() && this.getControl().value !== '') {
            this.getControl().setValue(null);
            return;
        }
        const time = timeValue ? timeValue : this.timeControl.value;
        // bypass if first time through and unset
        if (!time || !this.timeIsValid(time)) {
            return;
        }
        // patch value
        const timeAsString = `${this.padTimeWithZero(time.hour)}:${this.padTimeWithZero(time.minute)}:${this.padTimeWithZero(time.second)}`;
        if (timeAsString !== this.getControl().value) {
            this.getControl().setValue(timeAsString);
            this.getControl().markAsDirty();
            // also doing markastouched since blur is not working form timepicker
            this.getControl().markAsTouched();
        }
    }
    timeIsValid(time) {
        return ((time === null || time === void 0 ? void 0 : time.hour) || (time === null || time === void 0 ? void 0 : time.hour) === 0) && ((time === null || time === void 0 ? void 0 : time.minute) || (time === null || time === void 0 ? void 0 : time.minute) === 0) && ((time === null || time === void 0 ? void 0 : time.second) || (time === null || time === void 0 ? void 0 : time.second) === 0) ? true : false;
    }
    padTimeWithZero(number) {
        let numberAsString = number.toString();
        return numberAsString.length === 1 ? `0${numberAsString}` : numberAsString;
    }
    clear() {
        this.getControl().reset();
    }
}
FormTimePickerComponent.ɵfac = function FormTimePickerComponent_Factory(t) { return new (t || FormTimePickerComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Injector), ɵngcc0.ɵɵdirectiveInject(DynamicFormModuleConfig)); };
FormTimePickerComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: FormTimePickerComponent, selectors: [["ng-component"]], viewQuery: function FormTimePickerComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(_c5, true);
    } if (rf & 2) {
        var _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.timePicker = _t.first);
    } }, outputs: { blur: "blur", focus: "focus" }, features: [ɵngcc0.ɵɵInheritDefinitionFeature], decls: 20, vars: 11, consts: [[3, "parentControl", "formGroup"], ["type", "text", 1, "hidden", 3, "formControlName", "value"], [1, "time-input-group"], [3, "formControl", "meridian", "seconds", "spinners", "blur", "focus", "ready"], ["timePicker", ""], ["type", "button", "class", "btn btn-transparent clear-button", 3, "click", 4, "ngIf"], [3, "errorMessage", "insideBoxValidation"], ["type", "button", 1, "btn", "btn-transparent", "clear-button", 3, "click"], [1, "fa", "fa-times"]], template: function FormTimePickerComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "dynamic-form-input-wrapper", 0);
        ɵngcc0.ɵɵtext(1, "\n    ");
        ɵngcc0.ɵɵelement(2, "br");
        ɵngcc0.ɵɵtext(3, "\n    ");
        ɵngcc0.ɵɵtext(4, "\n    ");
        ɵngcc0.ɵɵelement(5, "input", 1);
        ɵngcc0.ɵɵtext(6, "\n\n    ");
        ɵngcc0.ɵɵelementStart(7, "div", 2);
        ɵngcc0.ɵɵtext(8, "\n        ");
        ɵngcc0.ɵɵelementStart(9, "mt-timepicker", 3, 4);
        ɵngcc0.ɵɵlistener("blur", function FormTimePickerComponent_Template_mt_timepicker_blur_9_listener() { return ctx.onBlur(); })("focus", function FormTimePickerComponent_Template_mt_timepicker_focus_9_listener() { return ctx.onFocus(); })("ready", function FormTimePickerComponent_Template_mt_timepicker_ready_9_listener($event) { return ctx.timepickerControlApi = $event; });
        ɵngcc0.ɵɵtext(11, "\n        ");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtext(12, "\n        ");
        ɵngcc0.ɵɵtemplate(13, FormTimePickerComponent_button_13_Template, 2, 0, "button", 5);
        ɵngcc0.ɵɵtext(14, "\n    ");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtext(15, "\n    ");
        ɵngcc0.ɵɵtext(16, "\n    ");
        ɵngcc0.ɵɵelement(17, "dynamic-form-validation-message", 6);
        ɵngcc0.ɵɵtext(18, "\n");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtext(19, "\n");
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("parentControl", ctx.thisControl)("formGroup", ctx.getGroup());
        ɵngcc0.ɵɵadvance(5);
        ɵngcc0.ɵɵproperty("formControlName", ctx.config.name)("value", ctx.config.value);
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵproperty("formControl", ctx.timeControl)("meridian", ctx.timepickerHasMeridian())("seconds", ctx.timepickerHasSeconds())("spinners", ctx.timepickerHasSpinners());
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵproperty("ngIf", ctx.showClearButton);
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵproperty("errorMessage", ctx.errorMessage)("insideBoxValidation", ctx.config.insideBoxValidation);
    } }, directives: function () { return [FormInputWrapperComponent, ɵngcc1.NgControlStatusGroup, ɵngcc1.FormGroupDirective, ɵngcc1.DefaultValueAccessor, ɵngcc1.NgControlStatus, ɵngcc1.FormControlName, ɵngcc6.TimepickerComponent, ɵngcc1.FormControlDirective, ɵngcc2.NgIf, FormValidationMessageComponent]; }, styles: [".clear-button[_ngcontent-%COMP%] {\n                margin-left: 5px;\n            }\n            .inside-box-maxlength[_ngcontent-%COMP%] {\n                position: relative !important;\n                bottom: -13px;\n                top: -13px;\n                margin-bottom: -13px;\n                right: 3px;\n                font-size: 70%;\n            }\n            .time-input-group[_ngcontent-%COMP%] {\n                display: flex;\n                flex-direction: row;\n            }"] });
FormTimePickerComponent.ctorParameters = () => [
    { type: Injector },
    { type: DynamicFormModuleConfig }
];
FormTimePickerComponent.propDecorators = {
    timePicker: [{ type: ViewChild, args: ['timePicker', { static: false },] }],
    blur: [{ type: Output }],
    focus: [{ type: Output }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(FormTimePickerComponent, [{
        type: Component,
        args: [{
                template: "<dynamic-form-input-wrapper [parentControl]=\"thisControl\" [formGroup]=\"getGroup()\">\n    <br />\n    <!-- input element -->\n    <input type=\"text\" class=\"hidden\" [formControlName]=\"config.name\" [value]=\"config.value\" />\n\n    <div class=\"time-input-group\">\n        <mt-timepicker\n            #timePicker\n            (blur)=\"onBlur()\"\n            (focus)=\"onFocus()\"\n            (ready)=\"timepickerControlApi = $event\"\n            [formControl]=\"timeControl\"\n            [meridian]=\"timepickerHasMeridian()\"\n            [seconds]=\"timepickerHasSeconds()\"\n            [spinners]=\"timepickerHasSpinners()\"\n        >\n        </mt-timepicker>\n        <button *ngIf=\"showClearButton\" type=\"button\" (click)=\"clear()\" class=\"btn btn-transparent clear-button\"><i class=\"fa fa-times\"></i></button>\n    </div>\n    <!-- validation elements -->\n    <dynamic-form-validation-message\n        [errorMessage]=\"errorMessage\"\n        [insideBoxValidation]=\"config.insideBoxValidation\"\n    ></dynamic-form-validation-message>\n</dynamic-form-input-wrapper>\n",
                styles: [`
            .clear-button {
                margin-left: 5px;
            }
            .inside-box-maxlength {
                position: relative !important;
                bottom: -13px;
                top: -13px;
                margin-bottom: -13px;
                right: 3px;
                font-size: 70%;
            }
            .time-input-group {
                display: flex;
                flex-direction: row;
            }
        `]
            }]
    }], function () { return [{ type: ɵngcc0.Injector }, { type: DynamicFormModuleConfig }]; }, { blur: [{
            type: Output
        }], focus: [{
            type: Output
        }], timePicker: [{
            type: ViewChild,
            args: ['timePicker', { static: false }]
        }] }); })();

class FormDatetimePickerComponent extends CustomFormControlComponentBase {
    constructor(injector, formBuilder, moduleConfig) {
        super(injector);
        this.formBuilder = formBuilder;
        this.moduleConfig = moduleConfig;
        this.disabled = false;
    }
    ngOnInit() {
        super.ngOnInit();
        if (this.config.value && !(this.config.value instanceof Date)) {
            this.config.value = new Date(this.config.value.toString());
        }
        this.wrapperForm = this.formBuilder.group({
            [this.config.formGroup]: this.formBuilder.group({}),
        });
        const dateVal = this.config.value || new Date();
        const timeVal = dateVal.toLocaleTimeString('default', {
            hour12: false,
        });
        this.dateField = new DynamicField({
            formGroup: this.config.formGroup,
            label: 'Date',
            name: 'Date',
            type: new DynamicFieldType({
                datepickerOptions: this.config.type.datepickerOptions,
                fieldType: DynamicFieldTypes.Input,
                inputType: InputTypes.Datepicker,
            }),
            value: dateVal,
        });
        this.timeField = new DynamicField({
            formGroup: this.config.formGroup,
            label: 'Time',
            name: 'Time',
            type: new DynamicFieldType({
                fieldType: DynamicFieldTypes.Input,
                inputType: InputTypes.Timepicker,
                timepickerOptions: this.config.type.timepickerOptions,
            }),
            value: timeVal,
        });
        this.subscriptions.add(this.getControl().statusChanges.subscribe((status) => {
            const isDisabled = status === 'DISABLED';
            if (isDisabled && !this.disabled) {
                setTimeout(() => {
                    this.wrapperForm.disable();
                }, 0);
                this.disabled = true;
            }
            else if (!isDisabled && this.disabled) {
                setTimeout(() => {
                    this.wrapperForm.enable();
                }, 0);
                this.disabled = false;
            }
        }));
    }
    overrideValueChanged() {
        // we should emit the date and time values when either control changes
        let dateValue = this.wrapperForm.get(this.config.formGroup).get('Date').value;
        let timeValue = this.wrapperForm.get(this.config.formGroup).get('Time').value;
        if (timeValue) {
            let [hours, minutes, seconds] = timeValue
                .split(':')
                // tslint:disable-next-line:radix
                .map((item) => parseInt(item));
            dateValue.setHours(hours);
            dateValue.setMinutes(minutes);
            dateValue.setSeconds(seconds);
        }
        this.getControl().patchValue(dateValue);
    }
}
FormDatetimePickerComponent.ɵfac = function FormDatetimePickerComponent_Factory(t) { return new (t || FormDatetimePickerComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Injector), ɵngcc0.ɵɵdirectiveInject(ɵngcc1.FormBuilder), ɵngcc0.ɵɵdirectiveInject(DynamicFormModuleConfig)); };
FormDatetimePickerComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: FormDatetimePickerComponent, selectors: [["ng-component"]], features: [ɵngcc0.ɵɵInheritDefinitionFeature], decls: 9, vars: 3, consts: [[3, "parentControl"], [1, "indented-date-time-picker"], [3, "form", "field", "blur", "focus", "valueChanges", 4, "ngIf"], [3, "form", "field", "blur", "focus", "valueChanges"]], template: function FormDatetimePickerComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelement(0, "dynamic-form-label", 0);
        ɵngcc0.ɵɵtext(1, "\n");
        ɵngcc0.ɵɵelementStart(2, "div", 1);
        ɵngcc0.ɵɵtext(3, "\n    ");
        ɵngcc0.ɵɵtemplate(4, FormDatetimePickerComponent_dynamic_field_4_Template, 1, 2, "dynamic-field", 2);
        ɵngcc0.ɵɵtext(5, "\n    ");
        ɵngcc0.ɵɵtemplate(6, FormDatetimePickerComponent_dynamic_field_6_Template, 1, 2, "dynamic-field", 2);
        ɵngcc0.ɵɵtext(7, "\n");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtext(8, "\n");
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("parentControl", ctx.thisControl);
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵproperty("ngIf", ctx.dateField);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", ctx.timeField);
    } }, directives: function () { return [FormLabelComponent, ɵngcc2.NgIf, DynamicFieldComponent]; }, styles: [".indented-date-time-picker[_ngcontent-%COMP%] {\n                margin-left: 15px;\n            }\n            .inside-box-maxlength[_ngcontent-%COMP%] {\n                position: relative !important;\n                bottom: -13px;\n                top: -13px;\n                margin-bottom: -13px;\n                right: 3px;\n                font-size: 70%;\n            }"] });
FormDatetimePickerComponent.ctorParameters = () => [
    { type: Injector },
    { type: FormBuilder },
    { type: DynamicFormModuleConfig }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(FormDatetimePickerComponent, [{
        type: Component,
        args: [{
                template: "<dynamic-form-label [parentControl]=\"thisControl\"></dynamic-form-label>\n<div class=\"indented-date-time-picker\">\n    <dynamic-field\n        *ngIf=\"dateField\"\n        [form]=\"wrapperForm\"\n        [field]=\"dateField\"\n        (blur)=\"onBlur()\"\n        (focus)=\"onFocus()\"\n        (valueChanges)=\"overrideValueChanged()\"\n    ></dynamic-field>\n    <dynamic-field\n        *ngIf=\"timeField\"\n        [form]=\"wrapperForm\"\n        [field]=\"timeField\"\n        (blur)=\"onBlur()\"\n        (focus)=\"onFocus()\"\n        (valueChanges)=\"overrideValueChanged()\"\n    ></dynamic-field>\n</div>\n",
                styles: [`
            .indented-date-time-picker {
                margin-left: 15px;
            }
            .inside-box-maxlength {
                position: relative !important;
                bottom: -13px;
                top: -13px;
                margin-bottom: -13px;
                right: 3px;
                font-size: 70%;
            }
        `]
            }]
    }], function () { return [{ type: ɵngcc0.Injector }, { type: ɵngcc1.FormBuilder }, { type: DynamicFormModuleConfig }]; }, null); })();

class FormColorPickerComponent extends CustomFormControlComponentBase {
    constructor(injector) {
        super(injector);
    }
    ngOnInit() {
        super.ngOnInit();
        if (this.config.type.colorpickerOptions) {
            this.position = this.config.type.colorpickerOptions.position || 'right';
            this.positionOffsetPercentage = this.config.type.colorpickerOptions.positionOffsetPercentage || 0;
        }
    }
    colorChanged(color) {
        this.getControl().setValue(color);
    }
}
FormColorPickerComponent.ɵfac = function FormColorPickerComponent_Factory(t) { return new (t || FormColorPickerComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Injector)); };
FormColorPickerComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: FormColorPickerComponent, selectors: [["ng-component"]], features: [ɵngcc0.ɵɵInheritDefinitionFeature], decls: 15, vars: 15, consts: [[3, "parentControl", "formGroup"], ["type", "text", 1, "form-control", 3, "colorPicker", "formControlName", "maxlength", "cpPosition", "cpPositionOffset", "colorPickerChange", "focus", "blur"], ["inputElement", ""], ["class", "small pull-right", 3, "visibility", "errortext", "inside-box-maxlength", 4, "ngIf"], [3, "errorMessage", "insideBoxValidation"], [1, "small", "pull-right"]], template: function FormColorPickerComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "dynamic-form-input-wrapper", 0);
        ɵngcc0.ɵɵtext(1, "\n    ");
        ɵngcc0.ɵɵtext(2, "\n    ");
        ɵngcc0.ɵɵelementStart(3, "input", 1, 2);
        ɵngcc0.ɵɵlistener("colorPickerChange", function FormColorPickerComponent_Template_input_colorPickerChange_3_listener($event) { return ctx.config.value = $event; })("focus", function FormColorPickerComponent_Template_input_focus_3_listener() { return ctx.onFocus(); })("blur", function FormColorPickerComponent_Template_input_blur_3_listener() { return ctx.onBlur(); })("colorPickerChange", function FormColorPickerComponent_Template_input_colorPickerChange_3_listener($event) { return ctx.colorChanged($event); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtext(5, "\n    ");
        ɵngcc0.ɵɵtext(6, "\n    ");
        ɵngcc0.ɵɵtemplate(7, FormColorPickerComponent_span_7_Template, 2, 7, "span", 3);
        ɵngcc0.ɵɵtext(8, "\n    ");
        ɵngcc0.ɵɵtemplate(9, FormColorPickerComponent_span_9_Template, 2, 7, "span", 3);
        ɵngcc0.ɵɵtext(10, "\n    ");
        ɵngcc0.ɵɵtext(11, "\n    ");
        ɵngcc0.ɵɵelement(12, "dynamic-form-validation-message", 4);
        ɵngcc0.ɵɵtext(13, "\n");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtext(14, "\n");
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("parentControl", ctx.thisControl)("formGroup", ctx.getGroup());
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵstyleProp("background", ctx.config.value);
        ɵngcc0.ɵɵproperty("colorPicker", ctx.config.value)("formControlName", ctx.config.name)("maxlength", ctx.getMaxLength())("cpPosition", ctx.position)("cpPositionOffset", ctx.positionOffsetPercentage);
        ɵngcc0.ɵɵattribute("placeholder", ctx.config.placeholder)("autocomplete", !ctx.config.autoCompleteEnabled ? "new-password" : null);
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.config.labelLeft && ctx.hasMaxLength());
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", ctx.config.labelLeft);
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("errorMessage", ctx.errorMessage)("insideBoxValidation", ctx.config.insideBoxValidation);
    } }, directives: function () { return [FormInputWrapperComponent, ɵngcc1.NgControlStatusGroup, ɵngcc1.FormGroupDirective, ɵngcc1.DefaultValueAccessor, ɵngcc7.ColorPickerDirective, ɵngcc1.NgControlStatus, ɵngcc1.FormControlName, ɵngcc1.MaxLengthValidator, ɵngcc2.NgIf, FormValidationMessageComponent]; }, styles: [_c2] });
FormColorPickerComponent.ctorParameters = () => [
    { type: Injector }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(FormColorPickerComponent, [{
        type: Component,
        args: [{
                template: "<dynamic-form-input-wrapper [parentControl]=\"thisControl\" [formGroup]=\"getGroup()\">\n    <!-- input element -->\n    <input\n        #inputElement\n        type=\"text\"\n        [(colorPicker)]=\"config.value\"\n        [style.background]=\"config.value\"\n        (focus)=\"onFocus()\"\n        (blur)=\"onBlur()\"\n        [attr.placeholder]=\"config.placeholder\"\n        [formControlName]=\"config.name\"\n        class=\"form-control\"\n        [maxlength]=\"getMaxLength()\"\n        (colorPickerChange)=\"colorChanged($event)\"\n        [cpPosition]=\"position\"\n        [cpPositionOffset]=\"positionOffsetPercentage\"\n        [attr.autocomplete]=\"!config.autoCompleteEnabled ? 'new-password' : null\"\n    />\n    <!-- maxlength elements -->\n    <span\n        *ngIf=\"!config.labelLeft && hasMaxLength()\"\n        [style.visibility]=\"isFocused && hasMaxLength() ? null : 'hidden'\"\n        class=\"small pull-right\"\n        [class.errortext]=\"hasError('maxlength')\"\n        [class.inside-box-maxlength]=\"config.insideBoxValidation\"\n        >{{ getMaxLengthText() }}</span\n    >\n    <span\n        *ngIf=\"config.labelLeft\"\n        [style.visibility]=\"isFocused && hasMaxLength() ? null : 'hidden'\"\n        class=\"small pull-right\"\n        [class.errortext]=\"hasError('maxlength')\"\n        [class.inside-box-maxlength]=\"config.insideBoxValidation\"\n        >{{ getMaxLengthText() }}</span\n    >\n    <!-- validation elements -->\n    <dynamic-form-validation-message\n        [errorMessage]=\"errorMessage\"\n        [insideBoxValidation]=\"config.insideBoxValidation\"\n    ></dynamic-form-validation-message>\n</dynamic-form-input-wrapper>\n",
                styles: [`
            .inside-box-maxlength {
                position: relative !important;
                bottom: -13px;
                top: -13px;
                margin-bottom: -13px;
                right: 3px;
                font-size: 70%;
            }
        `]
            }]
    }], function () { return [{ type: ɵngcc0.Injector }]; }, null); })();

class FormDateInputComponent extends CustomFormControlComponentBase {
    constructor(injector, datePipe) {
        super(injector);
        this.datePipe = datePipe;
    }
    ngOnInit() {
        super.ngOnInit();
        this.config.value = this.setValueAndDisplayValue(this.config.value);
        this.valueChanges.subscribe(this.setValueAndDisplayValue.bind(this));
    }
    setValueAndDisplayValue(value) {
        if (value) {
            value = new Date(value.toString());
            if (!isNaN(value.getTime())) {
                this.displayValue = this.datePipe.transform(value, 'yyyy-MM-dd', 'UTC');
            }
        }
        else {
            this.displayValue = null;
        }
        return value;
    }
    onBlur() {
        this.updateDateValue();
        this.blur.emit();
    }
    updateDateValue() {
        const dateControl = this.inputElement;
        const control = this.getControl();
        let valueToSet = dateControl.nativeElement.value ? new Date(dateControl.nativeElement.value) : null;
        control.patchValue(valueToSet);
        control.markAsDirty();
    }
}
FormDateInputComponent.ɵfac = function FormDateInputComponent_Factory(t) { return new (t || FormDateInputComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Injector), ɵngcc0.ɵɵdirectiveInject(ɵngcc2.DatePipe)); };
FormDateInputComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: FormDateInputComponent, selectors: [["ng-component"]], viewQuery: function FormDateInputComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(_c1, true);
    } if (rf & 2) {
        var _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.inputElement = _t.first);
    } }, features: [ɵngcc0.ɵɵInheritDefinitionFeature], decls: 13, vars: 8, consts: [[3, "parentControl", "formGroup"], ["type", "date", 1, "hidden", 3, "formControlName", "value"], ["type", "date", 1, "form-control", 3, "value", "blur", "keydown.enter"], ["input", ""], [3, "errorMessage", "insideBoxValidation"]], template: function FormDateInputComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "dynamic-form-input-wrapper", 0);
        ɵngcc0.ɵɵtext(1, "\n    ");
        ɵngcc0.ɵɵelement(2, "br");
        ɵngcc0.ɵɵtext(3, "\n    ");
        ɵngcc0.ɵɵtext(4, "\n    ");
        ɵngcc0.ɵɵelement(5, "input", 1);
        ɵngcc0.ɵɵtext(6, "\n    ");
        ɵngcc0.ɵɵelementStart(7, "input", 2, 3);
        ɵngcc0.ɵɵlistener("blur", function FormDateInputComponent_Template_input_blur_7_listener() { return ctx.onBlur(); })("keydown.enter", function FormDateInputComponent_Template_input_keydown_enter_7_listener() { return ctx.updateDateValue(); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtext(9, "\n    ");
        ɵngcc0.ɵɵelement(10, "dynamic-form-validation-message", 4);
        ɵngcc0.ɵɵtext(11, "\n");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtext(12, "\n");
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("parentControl", ctx.thisControl)("formGroup", ctx.getGroup());
        ɵngcc0.ɵɵadvance(5);
        ɵngcc0.ɵɵproperty("formControlName", ctx.config.name)("value", ctx.config.value);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("value", ctx.displayValue);
        ɵngcc0.ɵɵattribute("disabled", ctx.isDisabled ? true : null);
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("errorMessage", ctx.errorMessage)("insideBoxValidation", ctx.config.insideBoxValidation);
    } }, directives: function () { return [FormInputWrapperComponent, ɵngcc1.NgControlStatusGroup, ɵngcc1.FormGroupDirective, ɵngcc1.DefaultValueAccessor, ɵngcc1.NgControlStatus, ɵngcc1.FormControlName, FormValidationMessageComponent]; }, encapsulation: 2 });
FormDateInputComponent.ctorParameters = () => [
    { type: Injector },
    { type: DatePipe }
];
FormDateInputComponent.propDecorators = {
    inputElement: [{ type: ViewChild, args: ['input', { static: false },] }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(FormDateInputComponent, [{
        type: Component,
        args: [{
                template: "<dynamic-form-input-wrapper [parentControl]=\"thisControl\" [formGroup]=\"getGroup()\">\n    <br />\n    <!-- input element -->\n    <input type=\"date\" class=\"hidden\" [formControlName]=\"config.name\" [value]=\"config.value\" />\n    <input\n        #input\n        type=\"date\"\n        class=\"form-control\"\n        (blur)=\"onBlur()\"\n        (keydown.enter)=\"updateDateValue()\"\n        [value]=\"displayValue\"\n        [attr.disabled]=\"isDisabled ? true : null\"\n    />\n    <dynamic-form-validation-message\n        [errorMessage]=\"errorMessage\"\n        [insideBoxValidation]=\"config.insideBoxValidation\"\n    ></dynamic-form-validation-message>\n</dynamic-form-input-wrapper>\n"
            }]
    }], function () { return [{ type: ɵngcc0.Injector }, { type: ɵngcc2.DatePipe }]; }, { inputElement: [{
            type: ViewChild,
            args: ['input', { static: false }]
        }] }); })();

class FormDateTimeInputComponent extends CustomFormControlComponentBase {
    constructor(injector, datePipe) {
        super(injector);
        this.datePipe = datePipe;
    }
    ngOnInit() {
        super.ngOnInit();
        if (this.config.value) {
            this.config.value = new Date(this.config.value.toString());
            if (!isNaN(this.config.value.getTime())) {
                this.setDisplayValue(this.config.value);
            }
        }
        this.subscriptions.add(this.getControl().valueChanges.subscribe((value) => {
            this.setDisplayValue(value);
        }));
    }
    setDisplayValue(value) {
        this.displayValue = this.datePipe.transform(value, 'yyyy-MM-ddTHH:mm');
    }
    onBlur() {
        this.updateDateValue();
        this.blur.emit();
    }
    updateDateValue() {
        const dateControl = this.inputElement;
        const control = this.getControl();
        let valueToSet = dateControl.nativeElement.value ? new Date(dateControl.nativeElement.value) : null;
        control.patchValue(valueToSet);
        control.markAsDirty();
    }
}
FormDateTimeInputComponent.ɵfac = function FormDateTimeInputComponent_Factory(t) { return new (t || FormDateTimeInputComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Injector), ɵngcc0.ɵɵdirectiveInject(ɵngcc2.DatePipe)); };
FormDateTimeInputComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: FormDateTimeInputComponent, selectors: [["ng-component"]], viewQuery: function FormDateTimeInputComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(_c1, true);
    } if (rf & 2) {
        var _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.inputElement = _t.first);
    } }, features: [ɵngcc0.ɵɵInheritDefinitionFeature], decls: 13, vars: 8, consts: [[3, "parentControl", "formGroup"], ["type", "date", 1, "hidden", 3, "formControlName", "value"], ["type", "datetime-local", 1, "form-control", 3, "value", "blur", "keydown.enter"], ["input", ""], [3, "errorMessage", "insideBoxValidation"]], template: function FormDateTimeInputComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "dynamic-form-input-wrapper", 0);
        ɵngcc0.ɵɵtext(1, "\n    ");
        ɵngcc0.ɵɵelement(2, "br");
        ɵngcc0.ɵɵtext(3, "\n    ");
        ɵngcc0.ɵɵtext(4, "\n    ");
        ɵngcc0.ɵɵelement(5, "input", 1);
        ɵngcc0.ɵɵtext(6, "\n    ");
        ɵngcc0.ɵɵelementStart(7, "input", 2, 3);
        ɵngcc0.ɵɵlistener("blur", function FormDateTimeInputComponent_Template_input_blur_7_listener() { return ctx.onBlur(); })("keydown.enter", function FormDateTimeInputComponent_Template_input_keydown_enter_7_listener() { return ctx.updateDateValue(); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtext(9, "\n    ");
        ɵngcc0.ɵɵelement(10, "dynamic-form-validation-message", 4);
        ɵngcc0.ɵɵtext(11, "\n");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtext(12, "\n");
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("parentControl", ctx.thisControl)("formGroup", ctx.getGroup());
        ɵngcc0.ɵɵadvance(5);
        ɵngcc0.ɵɵproperty("formControlName", ctx.config.name)("value", ctx.config.value);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("value", ctx.displayValue);
        ɵngcc0.ɵɵattribute("disabled", ctx.isDisabled ? true : null);
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("errorMessage", ctx.errorMessage)("insideBoxValidation", ctx.config.insideBoxValidation);
    } }, directives: function () { return [FormInputWrapperComponent, ɵngcc1.NgControlStatusGroup, ɵngcc1.FormGroupDirective, ɵngcc1.DefaultValueAccessor, ɵngcc1.NgControlStatus, ɵngcc1.FormControlName, FormValidationMessageComponent]; }, encapsulation: 2 });
FormDateTimeInputComponent.ctorParameters = () => [
    { type: Injector },
    { type: DatePipe }
];
FormDateTimeInputComponent.propDecorators = {
    inputElement: [{ type: ViewChild, args: ['input', { static: false },] }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(FormDateTimeInputComponent, [{
        type: Component,
        args: [{
                template: "<dynamic-form-input-wrapper [parentControl]=\"thisControl\" [formGroup]=\"getGroup()\">\n    <br />\n    <!-- input element -->\n    <input type=\"date\" class=\"hidden\" [formControlName]=\"config.name\" [value]=\"config.value\" />\n    <input\n        #input\n        type=\"datetime-local\"\n        class=\"form-control\"\n        (blur)=\"onBlur()\"\n        (keydown.enter)=\"updateDateValue()\"\n        [value]=\"displayValue\"\n        [attr.disabled]=\"isDisabled ? true : null\"\n    />\n    <dynamic-form-validation-message\n        [errorMessage]=\"errorMessage\"\n        [insideBoxValidation]=\"config.insideBoxValidation\"\n    ></dynamic-form-validation-message>\n</dynamic-form-input-wrapper>\n"
            }]
    }], function () { return [{ type: ɵngcc0.Injector }, { type: ɵngcc2.DatePipe }]; }, { inputElement: [{
            type: ViewChild,
            args: ['input', { static: false }]
        }] }); })();

class FormTagsComponent extends CustomFormControlComponentBase {
    constructor(injector) {
        super(injector);
        this.seperator = ',';
    }
    ngOnInit() {
        super.ngOnInit();
        this.control = this.getControl();
        this.mapFormControlToArray();
    }
    mapFormControlToArray() {
        this.tagsArray = this.control.value ? this.control.value.split(this.seperator) : [];
    }
    removeTag(index) {
        if (this.control.disabled) {
            return;
        }
        this.tagsArray.splice(index, 1);
        this.control.setValue(this.tagsArray.join());
    }
}
FormTagsComponent.ɵfac = function FormTagsComponent_Factory(t) { return new (t || FormTagsComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Injector)); };
FormTagsComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: FormTagsComponent, selectors: [["ng-component"]], features: [ɵngcc0.ɵɵInheritDefinitionFeature], decls: 22, vars: 10, consts: [[3, "parentControl", "formGroup"], ["type", "text", 1, "form-control", 3, "formControlName", "value", "keyup"], ["inputElement", ""], ["class", "tag", 3, "disabled", 4, "ngFor", "ngForOf"], ["class", "small pull-right", 3, "visibility", "errortext", "inside-box-maxlength", 4, "ngIf"], [3, "errorMessage", "insideBoxValidation"], [1, "tag"], ["aria-hidden", "true", 1, "fa", "fa-xs", "fa-times", 3, "click"], [1, "small", "pull-right"]], template: function FormTagsComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "dynamic-form-input-wrapper", 0);
        ɵngcc0.ɵɵtext(1, "\n    ");
        ɵngcc0.ɵɵtext(2, "\n    ");
        ɵngcc0.ɵɵelementStart(3, "input", 1, 2);
        ɵngcc0.ɵɵlistener("keyup", function FormTagsComponent_Template_input_keyup_3_listener() { return ctx.mapFormControlToArray(); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtext(5, "\n    ");
        ɵngcc0.ɵɵelement(6, "br");
        ɵngcc0.ɵɵtext(7, "\n    ");
        ɵngcc0.ɵɵelementStart(8, "div");
        ɵngcc0.ɵɵtext(9, "\n        ");
        ɵngcc0.ɵɵtemplate(10, FormTagsComponent_span_10_Template, 4, 3, "span", 3);
        ɵngcc0.ɵɵtext(11, "\n    ");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtext(12, "\n    ");
        ɵngcc0.ɵɵtext(13, "\n    ");
        ɵngcc0.ɵɵtemplate(14, FormTagsComponent_span_14_Template, 2, 7, "span", 4);
        ɵngcc0.ɵɵtext(15, "\n    ");
        ɵngcc0.ɵɵtemplate(16, FormTagsComponent_span_16_Template, 2, 7, "span", 4);
        ɵngcc0.ɵɵtext(17, "\n    ");
        ɵngcc0.ɵɵtext(18, "\n    ");
        ɵngcc0.ɵɵelement(19, "dynamic-form-validation-message", 5);
        ɵngcc0.ɵɵtext(20, "\n");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtext(21, "\n");
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("parentControl", ctx.thisControl)("formGroup", ctx.getGroup());
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("formControlName", ctx.config.name)("value", ctx.config.value);
        ɵngcc0.ɵɵattribute("autocomplete", !ctx.config.autoCompleteEnabled ? "new-password" : null);
        ɵngcc0.ɵɵadvance(7);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.tagsArray);
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.config.labelLeft && ctx.hasMaxLength());
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", ctx.config.labelLeft);
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("errorMessage", ctx.errorMessage)("insideBoxValidation", ctx.config.insideBoxValidation);
    } }, directives: function () { return [FormInputWrapperComponent, ɵngcc1.NgControlStatusGroup, ɵngcc1.FormGroupDirective, ɵngcc1.DefaultValueAccessor, ɵngcc1.NgControlStatus, ɵngcc1.FormControlName, ɵngcc2.NgForOf, ɵngcc2.NgIf, FormValidationMessageComponent]; }, styles: [".inside-box-maxlength[_ngcontent-%COMP%] {\n                position: relative !important;\n                bottom: -13px;\n                top: -13px;\n                margin-bottom: -13px;\n                right: 3px;\n                font-size: 70%;\n            }\n\n            .tag[_ngcontent-%COMP%] {\n                margin: 5px;\n                background-color: #077aff;\n                color: white;\n                padding: 5px;\n                border-radius: 5px;\n                cursor: pointer;\n            }\n\n            .tag.disabled[_ngcontent-%COMP%] {\n                background-color: #8aa3ff;\n                cursor: default;\n            }\n\n            i[_ngcontent-%COMP%] {\n                margin-left: 5px;\n            }"] });
FormTagsComponent.ctorParameters = () => [
    { type: Injector }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(FormTagsComponent, [{
        type: Component,
        args: [{
                template: "<dynamic-form-input-wrapper [parentControl]=\"thisControl\" [formGroup]=\"getGroup()\">\n    <!-- input element -->\n    <input\n        #inputElement\n        type=\"text\"\n        [formControlName]=\"config.name\"\n        [value]=\"config.value\"\n        class=\"form-control\"\n        (keyup)=\"mapFormControlToArray()\"\n        [attr.autocomplete]=\"!config.autoCompleteEnabled ? 'new-password' : null\"\n    />\n    <br />\n    <div>\n        <span class=\"tag\" [class.disabled]=\"control.disabled\" *ngFor=\"let tag of tagsArray; let i = index\">\n            {{ tag }}\n            <i class=\"fa fa-xs fa-times\" aria-hidden=\"true\" (click)=\"removeTag(i)\"></i>\n        </span>\n    </div>\n    <!-- maxlength elements -->\n    <span\n        *ngIf=\"!config.labelLeft && hasMaxLength()\"\n        [style.visibility]=\"isFocused && hasMaxLength() ? null : 'hidden'\"\n        class=\"small pull-right\"\n        [class.errortext]=\"hasError('maxlength')\"\n        [class.inside-box-maxlength]=\"config.insideBoxValidation\"\n        >{{ getMaxLengthText() }}</span\n    >\n    <span\n        *ngIf=\"config.labelLeft\"\n        [style.visibility]=\"isFocused && hasMaxLength() ? null : 'hidden'\"\n        class=\"small pull-right\"\n        [class.errortext]=\"hasError('maxlength')\"\n        [class.inside-box-maxlength]=\"config.insideBoxValidation\"\n        >{{ getMaxLengthText() }}</span\n    >\n    <!-- validation elements -->\n    <dynamic-form-validation-message\n        [errorMessage]=\"errorMessage\"\n        [insideBoxValidation]=\"config.insideBoxValidation\"\n    ></dynamic-form-validation-message>\n</dynamic-form-input-wrapper>\n",
                styles: [`
            .inside-box-maxlength {
                position: relative !important;
                bottom: -13px;
                top: -13px;
                margin-bottom: -13px;
                right: 3px;
                font-size: 70%;
            }

            .tag {
                margin: 5px;
                background-color: #077aff;
                color: white;
                padding: 5px;
                border-radius: 5px;
                cursor: pointer;
            }

            .tag.disabled {
                background-color: #8aa3ff;
                cursor: default;
            }

            i {
                margin-left: 5px;
            }
        `]
            }]
    }], function () { return [{ type: ɵngcc0.Injector }]; }, null); })();

const defaultOptions = {
    height: 100,
    toolbar: [['bold', 'italic', 'underline', 'strike'], ['link'], ['bullet-list', 'ordered-list', 'align']],
};
class FormWYSIWYGComponent extends CustomFormControlComponentBase {
    constructor(injector) {
        super(injector);
        this.WYSIWYG_OPTIONS = defaultOptions;
    }
    ngOnInit() {
        super.ngOnInit();
        if (this.config.type.wysiwygOptions) {
            this.WYSIWYG_OPTIONS = Object.assign({}, defaultOptions, this.config.type.wysiwygOptions);
        }
    }
    focusMe() {
        if (this.wysiwygApi) {
            this.wysiwygApi.focus();
        }
    }
}
FormWYSIWYGComponent.ɵfac = function FormWYSIWYGComponent_Factory(t) { return new (t || FormWYSIWYGComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Injector)); };
FormWYSIWYGComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: FormWYSIWYGComponent, selectors: [["ng-component"]], features: [ɵngcc0.ɵɵInheritDefinitionFeature], decls: 15, vars: 10, consts: [[3, "parentControl", "formGroup"], [3, "controlName", "parentForm", "config", "disabled", "blur", "focus", "ready"], ["inputElement", ""], ["class", "small pull-right", 3, "visibility", "errortext", "inside-box-maxlength", 4, "ngIf"], [3, "errorMessage", "insideBoxValidation"], [1, "small", "pull-right"]], template: function FormWYSIWYGComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "dynamic-form-input-wrapper", 0);
        ɵngcc0.ɵɵtext(1, "\n    ");
        ɵngcc0.ɵɵtext(2, "\n    ");
        ɵngcc0.ɵɵelementStart(3, "mt-wysiwyg", 1, 2);
        ɵngcc0.ɵɵlistener("blur", function FormWYSIWYGComponent_Template_mt_wysiwyg_blur_3_listener() { return ctx.onBlur(); })("focus", function FormWYSIWYGComponent_Template_mt_wysiwyg_focus_3_listener() { return ctx.onFocus(); })("ready", function FormWYSIWYGComponent_Template_mt_wysiwyg_ready_3_listener($event) { return ctx.wysiwygApi = $event; });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtext(5, "\n    ");
        ɵngcc0.ɵɵtext(6, "\n    ");
        ɵngcc0.ɵɵtemplate(7, FormWYSIWYGComponent_span_7_Template, 2, 7, "span", 3);
        ɵngcc0.ɵɵtext(8, "\n    ");
        ɵngcc0.ɵɵtemplate(9, FormWYSIWYGComponent_span_9_Template, 2, 7, "span", 3);
        ɵngcc0.ɵɵtext(10, "\n    ");
        ɵngcc0.ɵɵtext(11, "\n    ");
        ɵngcc0.ɵɵelement(12, "dynamic-form-validation-message", 4);
        ɵngcc0.ɵɵtext(13, "\n");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtext(14, "\n");
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("parentControl", ctx.thisControl)("formGroup", ctx.getGroup());
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("controlName", ctx.config.name)("parentForm", ctx.getGroup())("config", ctx.WYSIWYG_OPTIONS)("disabled", ctx.isDisabled);
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.config.labelLeft && ctx.hasMaxLength());
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", ctx.config.labelLeft);
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("errorMessage", ctx.errorMessage)("insideBoxValidation", ctx.config.insideBoxValidation);
    } }, directives: function () { return [FormInputWrapperComponent, ɵngcc1.NgControlStatusGroup, ɵngcc1.FormGroupDirective, ɵngcc8.ɵa, ɵngcc2.NgIf, FormValidationMessageComponent]; }, styles: [_c2] });
FormWYSIWYGComponent.ctorParameters = () => [
    { type: Injector }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(FormWYSIWYGComponent, [{
        type: Component,
        args: [{
                template: "<dynamic-form-input-wrapper [parentControl]=\"thisControl\" [formGroup]=\"getGroup()\">\n    <!-- input element -->\n    <mt-wysiwyg\n        #inputElement\n        [controlName]=\"config.name\"\n        [parentForm]=\"getGroup()\"\n        [config]=\"WYSIWYG_OPTIONS\"\n        [disabled]=\"isDisabled\"\n        (blur)=\"onBlur()\"\n        (focus)=\"onFocus()\"\n        (ready)=\"wysiwygApi = $event\"\n    ></mt-wysiwyg>\n    <!-- maxlength elements -->\n    <span\n        *ngIf=\"!config.labelLeft && hasMaxLength()\"\n        [style.visibility]=\"isFocused && hasMaxLength() ? null : 'hidden'\"\n        class=\"small pull-right\"\n        [class.errortext]=\"hasError('maxlength')\"\n        [class.inside-box-maxlength]=\"config.insideBoxValidation\"\n        >{{ getMaxLengthText() }}</span\n    >\n    <span\n        *ngIf=\"config.labelLeft\"\n        [style.visibility]=\"isFocused && hasMaxLength() ? null : 'hidden'\"\n        class=\"small pull-right\"\n        [class.errortext]=\"hasError('maxlength')\"\n        [class.inside-box-maxlength]=\"config.insideBoxValidation\"\n        >{{ getMaxLengthText() }}</span\n    >\n    <!-- validation elements -->\n    <dynamic-form-validation-message\n        [errorMessage]=\"errorMessage\"\n        [insideBoxValidation]=\"config.insideBoxValidation\"\n    ></dynamic-form-validation-message>\n</dynamic-form-input-wrapper>\n",
                styles: [`
            .inside-box-maxlength {
                position: relative !important;
                bottom: -13px;
                top: -13px;
                margin-bottom: -13px;
                right: 3px;
                font-size: 70%;
            }
        `]
            }]
    }], function () { return [{ type: ɵngcc0.Injector }]; }, null); })();

class FormSelectBaseWithNullableOption extends CustomFormControlComponentBase {
    constructor(injector) {
        super(injector);
    }
    ngOnInit() {
        super.ngOnInit();
        if (this.showNullableOption()) {
            let nullableOption = {
                Id: null,
            };
            switch (this.config.type.inputType) {
                case SelectInputTypes.Dropdown:
                case SelectInputTypes.MultiselectDropdown:
                case SelectInputTypes.OldStyleMultiselectDropdown:
                    nullableOption.Name = '';
                    this.addNullableOption(nullableOption);
                    break;
                case SelectInputTypes.RadioButtonList:
                case SelectInputTypes.OldStyleRadioButtonList:
                    nullableOption.Name = 'No Selection';
                    this.addNullableOption(nullableOption);
                    break;
                case SelectInputTypes.TypeAhead:
                default:
                    break;
            }
        }
    }
    addNullableOption(nullableOption) {
        this.config.options.unshift(nullableOption);
    }
    showNullableOption() {
        return this.config.options && !this.config.validators.required && this.config.type.allowNullableOption;
    }
}
FormSelectBaseWithNullableOption.ɵfac = function FormSelectBaseWithNullableOption_Factory(t) { ɵngcc0.ɵɵinvalidFactory(); };
FormSelectBaseWithNullableOption.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: FormSelectBaseWithNullableOption, features: [ɵngcc0.ɵɵInheritDefinitionFeature] });


class FormDropdownComponent extends FormSelectBaseWithNullableOption {
    constructor(injector) {
        super(injector);
    }
}
FormDropdownComponent.ɵfac = function FormDropdownComponent_Factory(t) { return new (t || FormDropdownComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Injector)); };
FormDropdownComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: FormDropdownComponent, selectors: [["ng-component"]], features: [ɵngcc0.ɵɵInheritDefinitionFeature], decls: 9, vars: 6, consts: [[3, "parentControl", "formGroup"], [1, "form-control", 3, "formControlName", "blur", "focus"], ["inputElement", ""], [3, "ngValue", 4, "ngFor", "ngForOf"], [3, "ngValue"]], template: function FormDropdownComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "dynamic-form-select-wrapper", 0);
        ɵngcc0.ɵɵtext(1, "\n    ");
        ɵngcc0.ɵɵelementStart(2, "select", 1, 2);
        ɵngcc0.ɵɵlistener("blur", function FormDropdownComponent_Template_select_blur_2_listener() { return ctx.onBlur(); })("focus", function FormDropdownComponent_Template_select_focus_2_listener() { return ctx.onFocus(); });
        ɵngcc0.ɵɵtext(4, "\n        ");
        ɵngcc0.ɵɵtemplate(5, FormDropdownComponent_option_5_Template, 2, 2, "option", 3);
        ɵngcc0.ɵɵtext(6, "\n    ");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtext(7, "\n");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtext(8, "\n");
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("parentControl", ctx.thisControl)("formGroup", ctx.getGroup());
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵclassProp("disabled", ctx.isDisabled);
        ɵngcc0.ɵɵproperty("formControlName", ctx.config.name);
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.config.options);
    } }, directives: function () { return [FormSelectWrapperComponent, ɵngcc1.NgControlStatusGroup, ɵngcc1.FormGroupDirective, ɵngcc1.SelectControlValueAccessor, ɵngcc1.NgControlStatus, ɵngcc1.FormControlName, ɵngcc2.NgForOf, ɵngcc1.NgSelectOption, ɵngcc1.ɵangular_packages_forms_forms_x]; }, styles: [_c2] });
FormDropdownComponent.ctorParameters = () => [
    { type: Injector }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(FormDropdownComponent, [{
        type: Component,
        args: [{
                template: "<dynamic-form-select-wrapper [parentControl]=\"thisControl\" [formGroup]=\"getGroup()\">\n    <select #inputElement class=\"form-control\" [class.disabled]=\"isDisabled\" (blur)=\"onBlur()\" (focus)=\"onFocus()\" [formControlName]=\"config.name\">\n        <option *ngFor=\"let option of config.options\" [ngValue]=\"option.Id\">\n            {{ option.Name }}\n        </option>\n    </select>\n</dynamic-form-select-wrapper>\n",
                styles: [`
            .inside-box-maxlength {
                position: relative !important;
                bottom: -13px;
                top: -13px;
                margin-bottom: -13px;
                right: 3px;
                font-size: 70%;
            }
        `]
            }]
    }], function () { return [{ type: ɵngcc0.Injector }]; }, null); })();

class FormMultiSelectDropdownComponent extends FormSelectBaseWithNullableOption {
    constructor(injector) {
        super(injector);
    }
    ngOnInit() {
        super.ngOnInit();
        const valueIds = this.config.value || [];
        this.multiselectItems = this.config.options.map((option) => new MultiselectItem(option, (valueIds === null || valueIds === void 0 ? void 0 : valueIds.length) && valueIds.indexOf(option.Id) >= 0 ? true : false));
        this.subscriptions.add(this.getControl().valueChanges.subscribe((value) => {
            const valueIds = value || [];
            this.multiselectItems.forEach((item) => (item.Selected = valueIds.some((id) => item.Item.Id === id)));
        }));
    }
    multiSelectSelectionChanged(event) {
        const selectedIds = event.selectedItems.map((item) => item.Id);
        this.getControl().patchValue(selectedIds.length ? selectedIds : null);
        this.getControl().markAsDirty();
    }
    getNoItemsErrorMessage() {
        return `no ${pluralize(this.config.label.toLowerCase())} available`;
    }
}
FormMultiSelectDropdownComponent.ɵfac = function FormMultiSelectDropdownComponent_Factory(t) { return new (t || FormMultiSelectDropdownComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Injector)); };
FormMultiSelectDropdownComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: FormMultiSelectDropdownComponent, selectors: [["ng-component"]], features: [ɵngcc0.ɵɵInheritDefinitionFeature], decls: 15, vars: 12, consts: [[3, "parentControl", "formGroup"], ["multiple", "", 1, "hidden", 3, "formControlName", "value"], ["inputElement", ""], [3, "items", "placeholder", "filterMode", "maxToShowInSelectedText", "showSelectAllButtons", "autoClose", "disabled", "onSelectionChanged", "blur", "focus"], [3, "errortext", 4, "ngIf"]], template: function FormMultiSelectDropdownComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "dynamic-form-select-wrapper", 0);
        ɵngcc0.ɵɵtext(1, "\n    ");
        ɵngcc0.ɵɵelementStart(2, "select", 1, 2);
        ɵngcc0.ɵɵtext(4, " ");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtext(5, "\n    ");
        ɵngcc0.ɵɵelementStart(6, "div");
        ɵngcc0.ɵɵtext(7, "\n        ");
        ɵngcc0.ɵɵelementStart(8, "multiselect", 3);
        ɵngcc0.ɵɵlistener("onSelectionChanged", function FormMultiSelectDropdownComponent_Template_multiselect_onSelectionChanged_8_listener($event) { return ctx.multiSelectSelectionChanged($event); })("blur", function FormMultiSelectDropdownComponent_Template_multiselect_blur_8_listener() { return ctx.onBlur(); })("focus", function FormMultiSelectDropdownComponent_Template_multiselect_focus_8_listener() { return ctx.onFocus(); });
        ɵngcc0.ɵɵtext(9, "\n        ");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtext(10, "\n    ");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtext(11, "\n    ");
        ɵngcc0.ɵɵtemplate(12, FormMultiSelectDropdownComponent_em_12_Template, 2, 3, "em", 4);
        ɵngcc0.ɵɵtext(13, "\n");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtext(14, "\n");
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("parentControl", ctx.thisControl)("formGroup", ctx.getGroup());
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("formControlName", ctx.config.name)("value", ctx.config.value);
        ɵngcc0.ɵɵadvance(6);
        ɵngcc0.ɵɵproperty("items", ctx.multiselectItems)("placeholder", ctx.config.placeholder)("filterMode", false)("maxToShowInSelectedText", ctx.config.type.maxToShowInSelectedText)("showSelectAllButtons", ctx.config.type.showSelectAllButtons !== undefined ? ctx.config.type.showSelectAllButtons : false)("autoClose", ctx.config.type.multiselectAutoClose)("disabled", ctx.isDisabled);
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵproperty("ngIf", ctx.config.options.length == 0);
    } }, directives: function () { return [FormSelectWrapperComponent, ɵngcc1.NgControlStatusGroup, ɵngcc1.FormGroupDirective, ɵngcc1.SelectMultipleControlValueAccessor, ɵngcc1.NgControlStatus, ɵngcc1.FormControlName, ɵngcc9.MultiselectComponent, ɵngcc2.NgIf]; }, styles: [_c2] });
FormMultiSelectDropdownComponent.ctorParameters = () => [
    { type: Injector }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(FormMultiSelectDropdownComponent, [{
        type: Component,
        args: [{
                template: "<dynamic-form-select-wrapper [parentControl]=\"thisControl\" [formGroup]=\"getGroup()\">\n    <select #inputElement multiple [formControlName]=\"config.name\" [value]=\"config.value\" class=\"hidden\"> </select>\n    <div>\n        <multiselect\n            [items]=\"multiselectItems\"\n            [placeholder]=\"config.placeholder\"\n            [filterMode]=\"false\"\n            (onSelectionChanged)=\"multiSelectSelectionChanged($event)\"\n            [maxToShowInSelectedText]=\"config.type.maxToShowInSelectedText\"\n            [showSelectAllButtons]=\"config.type.showSelectAllButtons !== undefined ? config.type.showSelectAllButtons : false\"\n            [autoClose]=\"config.type.multiselectAutoClose\"\n            [disabled]=\"isDisabled\"\n            (blur)=\"onBlur()\"\n            (focus)=\"onFocus()\"\n        >\n        </multiselect>\n    </div>\n    <em [class.errortext]=\"hasError()\" *ngIf=\"config.options.length == 0\">{{ getNoItemsErrorMessage() }}</em>\n</dynamic-form-select-wrapper>\n",
                styles: [`
            .inside-box-maxlength {
                position: relative !important;
                bottom: -13px;
                top: -13px;
                margin-bottom: -13px;
                right: 3px;
                font-size: 70%;
            }
        `]
            }]
    }], function () { return [{ type: ɵngcc0.Injector }]; }, null); })();

class FormOldStyleMultiSelectDropdownComponent extends FormSelectBaseWithNullableOption {
    constructor(injector) {
        super(injector);
    }
}
FormOldStyleMultiSelectDropdownComponent.ɵfac = function FormOldStyleMultiSelectDropdownComponent_Factory(t) { return new (t || FormOldStyleMultiSelectDropdownComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Injector)); };
FormOldStyleMultiSelectDropdownComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: FormOldStyleMultiSelectDropdownComponent, selectors: [["ng-component"]], features: [ɵngcc0.ɵɵInheritDefinitionFeature], decls: 9, vars: 6, consts: [[3, "parentControl", "formGroup"], ["multiple", "", 1, "form-control", 3, "formControlName", "blur", "focus"], ["input", ""], [3, "ngValue", 4, "ngFor", "ngForOf"], [3, "ngValue"]], template: function FormOldStyleMultiSelectDropdownComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "dynamic-form-select-wrapper", 0);
        ɵngcc0.ɵɵtext(1, "\n    ");
        ɵngcc0.ɵɵelementStart(2, "select", 1, 2);
        ɵngcc0.ɵɵlistener("blur", function FormOldStyleMultiSelectDropdownComponent_Template_select_blur_2_listener() { return ctx.onBlur(); })("focus", function FormOldStyleMultiSelectDropdownComponent_Template_select_focus_2_listener() { return ctx.onFocus(); });
        ɵngcc0.ɵɵtext(4, "\n        ");
        ɵngcc0.ɵɵtemplate(5, FormOldStyleMultiSelectDropdownComponent_option_5_Template, 2, 2, "option", 3);
        ɵngcc0.ɵɵtext(6, "\n    ");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtext(7, "\n");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtext(8, "\n");
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("parentControl", ctx.thisControl)("formGroup", ctx.getGroup());
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵclassProp("disabled", ctx.isDisabled);
        ɵngcc0.ɵɵproperty("formControlName", ctx.config.name);
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.config.options);
    } }, directives: function () { return [FormSelectWrapperComponent, ɵngcc1.NgControlStatusGroup, ɵngcc1.FormGroupDirective, ɵngcc1.SelectMultipleControlValueAccessor, ɵngcc1.NgControlStatus, ɵngcc1.FormControlName, ɵngcc2.NgForOf, ɵngcc1.NgSelectOption, ɵngcc1.ɵangular_packages_forms_forms_x]; }, styles: [_c2] });
FormOldStyleMultiSelectDropdownComponent.ctorParameters = () => [
    { type: Injector }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(FormOldStyleMultiSelectDropdownComponent, [{
        type: Component,
        args: [{
                template: "<dynamic-form-select-wrapper [parentControl]=\"thisControl\" [formGroup]=\"getGroup()\">\n    <select #input multiple [formControlName]=\"config.name\" class=\"form-control\" [class.disabled]=\"isDisabled\" (blur)=\"onBlur()\" (focus)=\"onFocus()\">\n        <option *ngFor=\"let option of config.options\" [ngValue]=\"option.Id\">\n            {{ option.Name }}\n        </option>\n    </select>\n</dynamic-form-select-wrapper>\n",
                styles: [`
            .inside-box-maxlength {
                position: relative !important;
                bottom: -13px;
                top: -13px;
                margin-bottom: -13px;
                right: 3px;
                font-size: 70%;
            }
        `]
            }]
    }], function () { return [{ type: ɵngcc0.Injector }]; }, null); })();

class FormRadioButtonListComponent extends FormSelectBaseWithNullableOption {
    constructor(injector) {
        super(injector);
    }
    getNoItemsErrorMessage() {
        return `no ${pluralize(this.config.label.toLowerCase())} available`;
    }
}
FormRadioButtonListComponent.ɵfac = function FormRadioButtonListComponent_Factory(t) { return new (t || FormRadioButtonListComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Injector)); };
FormRadioButtonListComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: FormRadioButtonListComponent, selectors: [["ng-component"]], features: [ɵngcc0.ɵɵInheritDefinitionFeature], decls: 11, vars: 9, consts: [[3, "parentControl", "formGroup"], ["ngbRadioGroup", "", 1, "btn-group", "btn-group-toggle", 3, "formControlName", "blur", "focus"], ["inputElement", ""], ["ngbButtonLabel", "", "class", "btn-primary-inverse", 3, "disabled", 4, "ngFor", "ngForOf"], [3, "errortext", 4, "ngIf"], ["ngbButtonLabel", "", 1, "btn-primary-inverse"], ["ngbButton", "", "type", "radio", 3, "value", "blur", "focus"]], template: function FormRadioButtonListComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "dynamic-form-select-wrapper", 0);
        ɵngcc0.ɵɵtext(1, "\n    ");
        ɵngcc0.ɵɵelementStart(2, "div", 1, 2);
        ɵngcc0.ɵɵlistener("blur", function FormRadioButtonListComponent_Template_div_blur_2_listener() { return ctx.onBlur(); })("focus", function FormRadioButtonListComponent_Template_div_focus_2_listener() { return ctx.onFocus(); });
        ɵngcc0.ɵɵtext(4, "\n        ");
        ɵngcc0.ɵɵtemplate(5, FormRadioButtonListComponent_label_5_Template, 4, 5, "label", 3);
        ɵngcc0.ɵɵtext(6, "\n    ");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtext(7, "\n    ");
        ɵngcc0.ɵɵtemplate(8, FormRadioButtonListComponent_em_8_Template, 2, 3, "em", 4);
        ɵngcc0.ɵɵtext(9, "\n");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtext(10, "\n");
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("parentControl", ctx.thisControl)("formGroup", ctx.getGroup());
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵclassProp("hidden", ctx.config.options.length === 0)("disabled", ctx.isDisabled);
        ɵngcc0.ɵɵproperty("formControlName", ctx.config.name);
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.config.options);
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("ngIf", ctx.config.options.length == 0);
    } }, directives: function () { return [FormSelectWrapperComponent, ɵngcc1.NgControlStatusGroup, ɵngcc1.FormGroupDirective, ɵngcc5.NgbRadioGroup, ɵngcc1.NgControlStatus, ɵngcc1.FormControlName, ɵngcc2.NgForOf, ɵngcc2.NgIf, ɵngcc5.NgbButtonLabel, ɵngcc5.NgbRadio]; }, styles: [_c2] });
FormRadioButtonListComponent.ctorParameters = () => [
    { type: Injector }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(FormRadioButtonListComponent, [{
        type: Component,
        args: [{
                template: "<dynamic-form-select-wrapper [parentControl]=\"thisControl\" [formGroup]=\"getGroup()\">\n    <div\n        #inputElement\n        class=\"btn-group btn-group-toggle\"\n        [class.hidden]=\"config.options.length === 0\"\n        ngbRadioGroup\n        [formControlName]=\"config.name\"\n        [class.disabled]=\"isDisabled\"\n        (blur)=\"onBlur()\"\n        (focus)=\"onFocus()\"\n    >\n        <label\n            ngbButtonLabel\n            *ngFor=\"let option of config.options\"\n            class=\"btn-primary-inverse\"\n            [attr.disabled]=\"isDisabled ? 'disabled' : null\"\n            [class.disabled]=\"isDisabled\"\n        >\n            <input ngbButton type=\"radio\" (blur)=\"onBlur()\" (focus)=\"onFocus()\" [value]=\"option.Id\" />\n            {{ option.Name }}\n        </label>\n    </div>\n    <em [class.errortext]=\"hasError()\" *ngIf=\"config.options.length == 0\">{{ getNoItemsErrorMessage() }}</em>\n</dynamic-form-select-wrapper>\n",
                styles: [`
            .inside-box-maxlength {
                position: relative !important;
                bottom: -13px;
                top: -13px;
                margin-bottom: -13px;
                right: 3px;
                font-size: 70%;
            }
        `]
            }]
    }], function () { return [{ type: ɵngcc0.Injector }]; }, null); })();

class FormOldStyleRadioButtonListComponent extends FormSelectBaseWithNullableOption {
    constructor(injector) {
        super(injector);
    }
    labelClicked(option) {
        let control = this.getControl();
        if (control.enabled) {
            control.patchValue(option.Id);
            control.markAsDirty();
            control.markAsTouched();
        }
    }
}
FormOldStyleRadioButtonListComponent.ɵfac = function FormOldStyleRadioButtonListComponent_Factory(t) { return new (t || FormOldStyleRadioButtonListComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Injector)); };
FormOldStyleRadioButtonListComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: FormOldStyleRadioButtonListComponent, selectors: [["ng-component"]], features: [ɵngcc0.ɵɵInheritDefinitionFeature], decls: 12, vars: 8, consts: [[3, "parentControl", "formGroup"], [4, "ngFor", "ngForOf"], ["class", "small pull-right", 3, "visibility", 4, "ngIf"], [3, "errorMessage", "insideBoxValidation"], ["type", "radio", 3, "formControlName", "value", "blur", "focus"], ["input", ""], [3, "click"], [1, "small", "pull-right"]], template: function FormOldStyleRadioButtonListComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "dynamic-form-select-wrapper", 0);
        ɵngcc0.ɵɵtext(1, "\n    ");
        ɵngcc0.ɵɵelementStart(2, "div");
        ɵngcc0.ɵɵtext(3, "\n        ");
        ɵngcc0.ɵɵtemplate(4, FormOldStyleRadioButtonListComponent_div_4_Template, 8, 3, "div", 1);
        ɵngcc0.ɵɵtext(5, "\n        ");
        ɵngcc0.ɵɵtemplate(6, FormOldStyleRadioButtonListComponent_span_6_Template, 2, 2, "span", 2);
        ɵngcc0.ɵɵtext(7, "\n        ");
        ɵngcc0.ɵɵelement(8, "dynamic-form-validation-message", 3);
        ɵngcc0.ɵɵtext(9, "\n    ");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtext(10, "\n");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtext(11, "\n");
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("parentControl", ctx.thisControl)("formGroup", ctx.getGroup());
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵclassProp("disabled", ctx.isDisabled);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.config.options);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", ctx.config.labelLeft && !ctx.config.insideBoxValidation);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("errorMessage", ctx.errorMessage)("insideBoxValidation", ctx.config.insideBoxValidation);
    } }, directives: function () { return [FormSelectWrapperComponent, ɵngcc1.NgControlStatusGroup, ɵngcc1.FormGroupDirective, ɵngcc2.NgForOf, ɵngcc2.NgIf, FormValidationMessageComponent, ɵngcc1.RadioControlValueAccessor, ɵngcc1.DefaultValueAccessor, ɵngcc1.NgControlStatus, ɵngcc1.FormControlName]; }, styles: [_c2] });
FormOldStyleRadioButtonListComponent.ctorParameters = () => [
    { type: Injector }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(FormOldStyleRadioButtonListComponent, [{
        type: Component,
        args: [{
                template: "<dynamic-form-select-wrapper [parentControl]=\"thisControl\" [formGroup]=\"getGroup()\">\n    <div [class.disabled]=\"isDisabled\">\n        <div *ngFor=\"let option of config.options\">\n            <input #input type=\"radio\" (blur)=\"onBlur()\" (focus)=\"onFocus()\" [formControlName]=\"config.name\" [value]=\"option.Id\" />\n            <span (click)=\"labelClicked(option)\"> {{ option.Name }}</span>\n        </div>\n        <span *ngIf=\"config.labelLeft && !config.insideBoxValidation\" [style.visibility]=\"'hidden'\" class=\"small pull-right\">spacer</span>\n        <dynamic-form-validation-message\n            [errorMessage]=\"errorMessage\"\n            [insideBoxValidation]=\"config.insideBoxValidation\"\n        ></dynamic-form-validation-message>\n    </div>\n</dynamic-form-select-wrapper>\n",
                styles: [`
            .inside-box-maxlength {
                position: relative !important;
                bottom: -13px;
                top: -13px;
                margin-bottom: -13px;
                right: 3px;
                font-size: 70%;
            }
        `]
            }]
    }], function () { return [{ type: ɵngcc0.Injector }]; }, null); })();

class DynamicFieldDirective {
    constructor(resolver, container, moduleConfig) {
        this.resolver = resolver;
        this.container = container;
        this.moduleConfig = moduleConfig;
        this.blur = new EventEmitter();
        this.focus = new EventEmitter();
        this.valueChanges = new EventEmitter();
        this.subscriptions = new Subscription();
    }
    ngOnInit() {
        var _a, _b, _c;
        const component = this.getComponent(this.config, this.moduleConfig);
        const factory = this.resolver.resolveComponentFactory(component);
        this.component = this.container.createComponent(factory);
        this.component.instance.config = this.config;
        this.component.instance.parentGroup = this.group;
        // wiring up the events that can be passed through
        const instance = this.component.instance;
        if ((_a = instance.blur) === null || _a === void 0 ? void 0 : _a.subscribe) {
            this.subscriptions.add(instance.blur.subscribe(() => {
                this.blur.emit();
            }));
        }
        if ((_b = instance.focus) === null || _b === void 0 ? void 0 : _b.subscribe) {
            this.subscriptions.add(instance.focus.subscribe(() => {
                this.focus.emit();
            }));
        }
        if ((_c = instance.valueChanges) === null || _c === void 0 ? void 0 : _c.subscribe) {
            this.subscriptions.add(instance.valueChanges.subscribe((value) => {
                this.valueChanges.emit(value);
            }));
        }
    }
    ngOnDestroy() {
        this.subscriptions.unsubscribe();
    }
    /**
     * Determines which form-element component to resolve based on the
     * config input
     */
    getComponent(dynamicField, config) {
        var _a, _b;
        // check for custom component designated in the DynamicField
        if (dynamicField.component) {
            return dynamicField.component;
        }
        // check for module config custom component function
        if (config === null || config === void 0 ? void 0 : config.customFormComponentFunction) {
            const customFormComponent = config.customFormComponentFunction(dynamicField);
            if (customFormComponent) {
                return customFormComponent;
            }
        }
        // else get via our standard control mapping
        const fieldType = dynamicField.type.fieldType;
        if (fieldType === DynamicFieldTypes.Checkbox) {
            return FormCheckBoxComponent;
        }
        if (fieldType === DynamicFieldTypes.Input) {
            const inputType = dynamicField.type.inputType;
            switch (inputType) {
                case InputTypes.Textbox:
                    return FormTextboxComponent;
                case InputTypes.Textarea:
                    return FormTextareaComponent;
                case InputTypes.Phone:
                    return FormPhoneComponent;
                case InputTypes.Datepicker:
                    return FormDatePickerComponent;
                case InputTypes.Timepicker:
                    return FormTimePickerComponent;
                case InputTypes.DateTimepicker:
                    return FormDatetimePickerComponent;
                case InputTypes.Colorpicker:
                    return FormColorPickerComponent;
                case InputTypes.DateInput:
                    return FormDateInputComponent;
                case InputTypes.DateTimeInput:
                    return FormDateTimeInputComponent;
                case InputTypes.Tags:
                    return FormTagsComponent;
                case InputTypes.WYSIWYG:
                    return FormWYSIWYGComponent;
                default:
                    return FormTextboxComponent;
            }
        }
        if (fieldType === DynamicFieldTypes.Numeric) {
            return FormNumericComponent;
        }
        if (fieldType === DynamicFieldTypes.Password) {
            return FormPasswordComponent;
        }
        if (fieldType === DynamicFieldTypes.Select) {
            const selectType = dynamicField.type.inputType;
            switch (selectType) {
                case SelectInputTypes.Dropdown:
                    return FormDropdownComponent;
                case SelectInputTypes.MultiselectDropdown:
                    return FormMultiSelectDropdownComponent;
                case SelectInputTypes.RadioButtonList:
                    return FormRadioButtonListComponent;
                case SelectInputTypes.OldStyleRadioButtonList:
                    return FormOldStyleRadioButtonListComponent;
                case SelectInputTypes.OldStyleMultiselectDropdown:
                    return FormOldStyleMultiSelectDropdownComponent;
                case SelectInputTypes.TypeAhead:
                    return FormTypeAheadComponent;
                default:
                    if (((_b = (_a = dynamicField.options) === null || _a === void 0 ? void 0 : _a.length) !== null && _b !== void 0 ? _b : 0) <= 6) {
                        return FormRadioButtonListComponent;
                    }
                    return FormDropdownComponent;
            }
        }
        if (fieldType === DynamicFieldTypes.MtAddress) {
            return FormMtAddressComponent;
        }
    }
}
DynamicFieldDirective.ɵfac = function DynamicFieldDirective_Factory(t) { return new (t || DynamicFieldDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ComponentFactoryResolver), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ViewContainerRef), ɵngcc0.ɵɵdirectiveInject(DynamicFormModuleConfig)); };
DynamicFieldDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: DynamicFieldDirective, selectors: [["", "appDynamicField", ""]], inputs: { config: "config", group: "group" }, outputs: { blur: "blur", focus: "focus", valueChanges: "valueChanges" } });
DynamicFieldDirective.ctorParameters = () => [
    { type: ComponentFactoryResolver },
    { type: ViewContainerRef },
    { type: DynamicFormModuleConfig }
];
DynamicFieldDirective.propDecorators = {
    config: [{ type: Input }],
    group: [{ type: Input }],
    blur: [{ type: Output }],
    focus: [{ type: Output }],
    valueChanges: [{ type: Output }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DynamicFieldDirective, [{
        type: Directive,
        args: [{
                selector: '[appDynamicField]'
            }]
    }], function () { return [{ type: ɵngcc0.ComponentFactoryResolver }, { type: ɵngcc0.ViewContainerRef }, { type: DynamicFormModuleConfig }]; }, { blur: [{
            type: Output
        }], focus: [{
            type: Output
        }], valueChanges: [{
            type: Output
        }], config: [{
            type: Input
        }], group: [{
            type: Input
        }] }); })();

class DynamicFieldComponent {
    constructor(fb, claimsService) {
        this.fb = fb;
        this.claimsService = claimsService;
        this.overrideForm = false;
        this.removeControlOnDestroy = true;
        this.blur = new EventEmitter();
        this.focus = new EventEmitter();
        this.valueChanges = new EventEmitter();
        this.controlCreated = new EventEmitter();
        this.showControl = true;
    }
    ngOnInit() {
        if (!this.field.shouldCreateControl(this.claimsService)) {
            this.showControl = false;
            return;
        }
        if (typeof this.form === 'undefined') {
            this.overrideForm = true;
            this.form = this.fb.group({});
        }
        if (this.overrideForm) {
            this.field.formGroup = null;
        }
        let currentGroup = this.field.formGroup ? this.form.get(this.field.formGroup) : this.form;
        if (!currentGroup) {
            this.formNotFoundError();
        }
        if (currentGroup.get(this.field.name)) {
            currentGroup.setControl(this.field.name, this.field.createControl(this.fb, this.claimsService));
        }
        else {
            currentGroup.addControl(this.field.name, this.field.createControl(this.fb, this.claimsService));
        }
        const control = currentGroup.get(this.field.name);
        this.controlCreated.emit(control);
    }
    ngOnDestroy() {
        if (this.removeControlOnDestroy) {
            let currentGroup = this.field.formGroup ? this.form.get(this.field.formGroup) : this.form;
            if (currentGroup) {
                currentGroup.removeControl(this.field.name);
            }
        }
    }
    formNotFoundError() {
        this.showControl = false;
        let errorMessage = `
    Error in DynamicFieldComponent:  Form Not Found
    this may happen if the FormGroup on the field is not present on the passed in form.
    field[name] = '${this.field.name}'
    field[formGroup] = '${this.field.formGroup}'
    `;
        throw errorMessage;
    }
}
DynamicFieldComponent.ɵfac = function DynamicFieldComponent_Factory(t) { return new (t || DynamicFieldComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc1.FormBuilder), ɵngcc0.ɵɵdirectiveInject(ɵngcc10.ClaimsService)); };
DynamicFieldComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DynamicFieldComponent, selectors: [["dynamic-field"]], inputs: { overrideForm: "overrideForm", removeControlOnDestroy: "removeControlOnDestroy", form: "form", field: "field" }, outputs: { blur: "blur", focus: "focus", valueChanges: "valueChanges", controlCreated: "controlCreated" }, decls: 2, vars: 1, consts: [["appDynamicField", "", 3, "config", "group", "blur", "focus", "valueChanges", 4, "ngIf"], ["appDynamicField", "", 3, "config", "group", "blur", "focus", "valueChanges"]], template: function DynamicFieldComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtext(0, " ");
        ɵngcc0.ɵɵtemplate(1, DynamicFieldComponent_div_1_Template, 1, 2, "div", 0);
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.showControl);
    } }, directives: [ɵngcc2.NgIf, DynamicFieldDirective], encapsulation: 2 });
DynamicFieldComponent.ctorParameters = () => [
    { type: FormBuilder },
    { type: ClaimsService }
];
DynamicFieldComponent.propDecorators = {
    field: [{ type: Input }],
    form: [{ type: Input }],
    overrideForm: [{ type: Input }],
    removeControlOnDestroy: [{ type: Input }],
    blur: [{ type: Output }],
    focus: [{ type: Output }],
    valueChanges: [{ type: Output }],
    controlCreated: [{ type: Output }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DynamicFieldComponent, [{
        type: Component,
        args: [{
                selector: 'dynamic-field',
                template: ` <div
        *ngIf="showControl"
        appDynamicField
        [config]="field"
        [group]="form"
        (blur)="blur.emit()"
        (focus)="focus.emit()"
        (valueChanges)="valueChanges.emit($event)"
    ></div>`
            }]
    }], function () { return [{ type: ɵngcc1.FormBuilder }, { type: ɵngcc10.ClaimsService }]; }, { overrideForm: [{
            type: Input
        }], removeControlOnDestroy: [{
            type: Input
        }], blur: [{
            type: Output
        }], focus: [{
            type: Output
        }], valueChanges: [{
            type: Output
        }], controlCreated: [{
            type: Output
        }], form: [{
            type: Input
        }], field: [{
            type: Input
        }] }); })();

class DynamicFormComponent {
    constructor(fb, claimsService) {
        this.fb = fb;
        this.claimsService = claimsService;
        this.config = [];
        this.removeControlsOnDestroy = true;
        this.submitted = new EventEmitter();
        this.formCreated = new EventEmitter();
    }
    ngOnInit() {
        this.form = this.createGroup();
        this.formCreated.emit(this.form);
    }
    ngOnDestroy() {
        if (this.removeControlsOnDestroy) {
            const group = !this.form ? this.fb.group({}) : this.form;
            this.config.forEach((control) => {
                let currentGroup = control.formGroup ? group.get(control.formGroup) : group;
                currentGroup.removeControl(control.name);
            });
        }
    }
    createGroup() {
        const group = !this.form ? this.fb.group({}) : this.form;
        let formGroups = Array.from(new Set(this.config.map((control) => control.formGroup)));
        formGroups.forEach((fg) => {
            const exists = group.get(fg);
            if (!exists) {
                group.addControl(fg, this.fb.group({}));
            }
        });
        this.config.forEach((control) => {
            if (control.shouldCreateControl(this.claimsService)) {
                let currentGroup = control.formGroup ? group.get(control.formGroup) : group;
                currentGroup.addControl(control.name, control.createControl(this.fb, this.claimsService));
            }
        });
        return group;
    }
    getFormGroup(field) {
        return field.formGroup ? this.form.get(field.formGroup) : this.form;
    }
    ngAfterContentInit() {
        const temp = this.form.value;
        for (const field in temp) {
            if (!temp[field]) {
                temp[field] = '';
            }
        }
        this.form.patchValue(temp);
    }
}
DynamicFormComponent.ɵfac = function DynamicFormComponent_Factory(t) { return new (t || DynamicFormComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc1.FormBuilder), ɵngcc0.ɵɵdirectiveInject(ɵngcc10.ClaimsService)); };
DynamicFormComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DynamicFormComponent, selectors: [["app-dynamic-form"]], inputs: { config: "config", removeControlsOnDestroy: "removeControlsOnDestroy", form: "form" }, outputs: { submitted: "submitted", formCreated: "formCreated" }, ngContentSelectors: _c6, decls: 5, vars: 2, consts: [["novalidate", "", 3, "formGroup", "ngSubmit"], [4, "ngFor", "ngForOf"], ["appDynamicField", "", 3, "config", "group", 4, "ngIf"], ["appDynamicField", "", 3, "config", "group"]], template: function DynamicFormComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵelementStart(0, "form", 0);
        ɵngcc0.ɵɵlistener("ngSubmit", function DynamicFormComponent_Template_form_ngSubmit_0_listener() { return ctx.submitted.emit(ctx.form); });
        ɵngcc0.ɵɵtext(1, "\n    ");
        ɵngcc0.ɵɵtemplate(2, DynamicFormComponent_ng_container_2_Template, 6, 1, "ng-container", 1);
        ɵngcc0.ɵɵtext(3, "\n");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtext(4, "\n");
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("formGroup", ctx.form);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.config);
    } }, directives: [ɵngcc1.ɵangular_packages_forms_forms_y, ɵngcc1.NgControlStatusGroup, ɵngcc1.FormGroupDirective, ɵngcc2.NgForOf, ɵngcc2.NgIf, DynamicFieldDirective], encapsulation: 2 });
DynamicFormComponent.ctorParameters = () => [
    { type: FormBuilder },
    { type: ClaimsService }
];
DynamicFormComponent.propDecorators = {
    config: [{ type: Input }],
    form: [{ type: Input }],
    removeControlsOnDestroy: [{ type: Input }],
    submitted: [{ type: Output }],
    formCreated: [{ type: Output }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DynamicFormComponent, [{
        type: Component,
        args: [{
                selector: 'app-dynamic-form',
                template: "<form novalidate [formGroup]=\"form\" (ngSubmit)=\"submitted.emit(form)\">\n    <ng-container *ngFor=\"let field of config\">\n        <ng-container *ngIf=\"field.shouldCreateControl(claimsService)\" appDynamicField [config]=\"field\" [group]=\"form\"></ng-container>\n        <ng-content [formGroup]=\"group\"></ng-content>\n    </ng-container>\n</form>\n"
            }]
    }], function () { return [{ type: ɵngcc1.FormBuilder }, { type: ɵngcc10.ClaimsService }]; }, { config: [{
            type: Input
        }], removeControlsOnDestroy: [{
            type: Input
        }], submitted: [{
            type: Output
        }], formCreated: [{
            type: Output
        }], form: [{
            type: Input
        }] }); })();

class DynamicViewComponent {
    constructor(currencyPipe, datePipe, sanitizer, moduleConfig) {
        this.currencyPipe = currencyPipe;
        this.datePipe = datePipe;
        this.sanitizer = sanitizer;
        this.moduleConfig = moduleConfig;
        this.config = [];
    }
    getValue(field) {
        var _a;
        if ((_a = this.moduleConfig) === null || _a === void 0 ? void 0 : _a.customFormComponentDisplayValueFunction) {
            const customFormComponentValueFunction = this.moduleConfig.customFormComponentDisplayValueFunction(field);
            if (customFormComponentValueFunction) {
                return customFormComponentValueFunction;
            }
        }
        if (!field || (!field.value && field.value !== 0 && field.type.fieldType !== DynamicFieldTypes.Checkbox)) {
            return '';
        }
        if (field.valueHtml != null) {
            return this.sanitizer.bypassSecurityTrustHtml(field.valueHtml);
        }
        if (field.type.fieldType === DynamicFieldTypes.Numeric && field.type.inputType === NumericInputTypes.Currency) {
            return this.currencyPipe.transform(field.value);
        }
        if (field.type.fieldType === DynamicFieldTypes.Input &&
            (field.type.inputType === InputTypes.Datepicker || field.type.inputType === InputTypes.DateTimeInput)) {
            return this.datePipe.transform(field.value);
        }
        if (field.type.fieldType === DynamicFieldTypes.Input && field.type.inputType === InputTypes.Phone) {
            return formatPhone(field.value);
        }
        if (field.type.fieldType === DynamicFieldTypes.Checkbox) {
            return field.value ? 'Yes' : 'No';
        }
        if (field.type.fieldType === DynamicFieldTypes.Input && field.type.inputType === InputTypes.DateInput) {
            return this.datePipe.transform(field.value, 'mediumDate', 'UTC');
        }
        return field.value.toString();
    }
}
DynamicViewComponent.ɵfac = function DynamicViewComponent_Factory(t) { return new (t || DynamicViewComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc2.CurrencyPipe), ɵngcc0.ɵɵdirectiveInject(ɵngcc2.DatePipe), ɵngcc0.ɵɵdirectiveInject(ɵngcc11.DomSanitizer), ɵngcc0.ɵɵdirectiveInject(DynamicFormModuleConfig)); };
DynamicViewComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DynamicViewComponent, selectors: [["app-dynamic-view"]], inputs: { config: "config" }, ngContentSelectors: _c6, decls: 2, vars: 1, consts: [[4, "ngFor", "ngForOf"], [1, "display-padded"], [3, "innerHtml"]], template: function DynamicViewComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵtemplate(0, DynamicViewComponent_ng_container_0_Template, 12, 2, "ng-container", 0);
        ɵngcc0.ɵɵtext(1, "\n");
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngForOf", ctx.config);
    } }, directives: [ɵngcc2.NgForOf], encapsulation: 2 });
DynamicViewComponent.ctorParameters = () => [
    { type: CurrencyPipe },
    { type: DatePipe },
    { type: DomSanitizer },
    { type: DynamicFormModuleConfig }
];
DynamicViewComponent.propDecorators = {
    config: [{ type: Input }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DynamicViewComponent, [{
        type: Component,
        args: [{
                selector: 'app-dynamic-view',
                template: "<ng-container *ngFor=\"let field of config\">\n    <div class=\"display-padded\">\n        <b>{{ field.label }}:</b>\n        <span [innerHtml]=\"getValue(field)\"></span>\n    </div>\n    <ng-content [formGroup]=\"group\"></ng-content>\n</ng-container>\n"
            }]
    }], function () { return [{ type: ɵngcc2.CurrencyPipe }, { type: ɵngcc2.DatePipe }, { type: ɵngcc11.DomSanitizer }, { type: DynamicFormModuleConfig }]; }, { config: [{
            type: Input
        }] }); })();

class FormInputWrapperComponent {
    constructor() { }
    get config() {
        return this.parentControl.config;
    }
    get hasError() {
        return this.parentControl.hasError();
    }
}
FormInputWrapperComponent.ɵfac = function FormInputWrapperComponent_Factory(t) { return new (t || FormInputWrapperComponent)(); };
FormInputWrapperComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: FormInputWrapperComponent, selectors: [["dynamic-form-input-wrapper"]], inputs: { parentControl: "parentControl" }, ngContentSelectors: _c6, decls: 10, vars: 10, consts: [[1, "dynamic-field", "form-input"], [3, "parentControl"], [3, "ngClass"]], template: function FormInputWrapperComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵtext(1, "\n    ");
        ɵngcc0.ɵɵelement(2, "dynamic-form-label", 1);
        ɵngcc0.ɵɵtext(3, "\n    ");
        ɵngcc0.ɵɵelementStart(4, "span", 2);
        ɵngcc0.ɵɵtext(5, "\n        ");
        ɵngcc0.ɵɵprojection(6);
        ɵngcc0.ɵɵtext(7, "\n    ");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtext(8, "\n");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtext(9, "\n");
    } if (rf & 2) {
        ɵngcc0.ɵɵclassProp("has-error", ctx.hasError)("space-for-validation", !ctx.config.insideBoxValidation && !ctx.config.labelLeft)("form-horizontal", ctx.config.labelLeft)("form-group", ctx.config.labelLeft);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("parentControl", ctx.parentControl);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngClass", ctx.config.labelLeft ? "col-sm-" + ctx.config.controlCols : null);
    } }, directives: function () { return [FormLabelComponent, ɵngcc2.NgClass]; }, styles: [_c7] });
FormInputWrapperComponent.ctorParameters = () => [];
FormInputWrapperComponent.propDecorators = {
    parentControl: [{ type: Input }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(FormInputWrapperComponent, [{
        type: Component,
        args: [{
                selector: 'dynamic-form-input-wrapper',
                template: "<div\n    class=\"dynamic-field form-input\"\n    [class.has-error]=\"hasError\"\n    [class.space-for-validation]=\"!config.insideBoxValidation && !config.labelLeft\"\n    [class.form-horizontal]=\"config.labelLeft\"\n    [class.form-group]=\"config.labelLeft\"\n>\n    <dynamic-form-label [parentControl]=\"parentControl\"></dynamic-form-label>\n    <span [ngClass]=\"config.labelLeft ? 'col-sm-' + config.controlCols : null\">\n        <ng-content></ng-content>\n    </span>\n</div>\n",
                styles: [`
            .space-for-validation {
                margin-bottom: 15px;
            }
        `]
            }]
    }], function () { return []; }, { parentControl: [{
            type: Input
        }] }); })();

class FormLabelComponent {
    constructor() { }
    get config() {
        return this.parentControl.config;
    }
    get showRequired() {
        return this.parentControl.showRequired();
    }
    get showOptional() {
        return this.parentControl.showOptional();
    }
}
FormLabelComponent.ɵfac = function FormLabelComponent_Factory(t) { return new (t || FormLabelComponent)(); };
FormLabelComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: FormLabelComponent, selectors: [["dynamic-form-label"]], inputs: { parentControl: "parentControl" }, decls: 9, vars: 5, consts: [[1, "control-label", 3, "hidden", "ngClass"], [1, "dynamic-field-label", 3, "innerHTML"], ["class", "errortext", 4, "ngIf"], ["class", "small text-muted", 4, "ngIf"], [1, "errortext"], [1, "small", "text-muted"]], template: function FormLabelComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "span", 0);
        ɵngcc0.ɵɵtext(1, "\n    ");
        ɵngcc0.ɵɵelement(2, "span", 1);
        ɵngcc0.ɵɵtext(3, "\n    ");
        ɵngcc0.ɵɵtemplate(4, FormLabelComponent_span_4_Template, 2, 0, "span", 2);
        ɵngcc0.ɵɵtext(5, "\n    ");
        ɵngcc0.ɵɵtemplate(6, FormLabelComponent_span_6_Template, 5, 0, "span", 3);
        ɵngcc0.ɵɵtext(7, "\n");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtext(8, "\n");
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("hidden", ctx.config.labelHidden)("ngClass", ctx.config.labelLeft ? "col-sm-" + ctx.config.labelCols : null);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("innerHTML", ctx.config.labelHtml, ɵngcc0.ɵɵsanitizeHtml);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", ctx.showRequired);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", ctx.showOptional);
    } }, directives: [ɵngcc2.NgClass, ɵngcc2.NgIf], encapsulation: 2 });
FormLabelComponent.ctorParameters = () => [];
FormLabelComponent.propDecorators = {
    parentControl: [{ type: Input }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(FormLabelComponent, [{
        type: Component,
        args: [{
                selector: 'dynamic-form-label',
                template: "<span class=\"control-label\" [hidden]=\"config.labelHidden\" [ngClass]=\"config.labelLeft ? 'col-sm-' + config.labelCols : null\">\n    <span class=\"dynamic-field-label\" [innerHTML]=\"config.labelHtml\"></span>\n    <span *ngIf=\"showRequired\" class=\"errortext\"> *</span>\n    <span *ngIf=\"showOptional\" class=\"small text-muted\">\n        <em>optional</em>\n    </span>\n</span>\n"
            }]
    }], function () { return []; }, { parentControl: [{
            type: Input
        }] }); })();

class FormSelectWrapperComponent {
    constructor() { }
    get config() {
        return this.parentControl.config;
    }
    get hasError() {
        return this.parentControl.hasError();
    }
}
FormSelectWrapperComponent.ɵfac = function FormSelectWrapperComponent_Factory(t) { return new (t || FormSelectWrapperComponent)(); };
FormSelectWrapperComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: FormSelectWrapperComponent, selectors: [["dynamic-form-select-wrapper"]], inputs: { parentControl: "parentControl" }, ngContentSelectors: _c6, decls: 10, vars: 10, consts: [[1, "dynamic-field", "form-select"], [3, "parentControl"], [3, "ngClass"]], template: function FormSelectWrapperComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵtext(1, "\n    ");
        ɵngcc0.ɵɵelement(2, "dynamic-form-label", 1);
        ɵngcc0.ɵɵtext(3, "\n    ");
        ɵngcc0.ɵɵelementStart(4, "span", 2);
        ɵngcc0.ɵɵtext(5, "\n        ");
        ɵngcc0.ɵɵprojection(6);
        ɵngcc0.ɵɵtext(7, "\n    ");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtext(8, "\n");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtext(9, "\n");
    } if (rf & 2) {
        ɵngcc0.ɵɵclassProp("has-error", ctx.hasError)("space-for-validation", !ctx.config.insideBoxValidation && !ctx.config.labelLeft)("form-horizontal", ctx.config.labelLeft)("form-group", ctx.config.labelLeft);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("parentControl", ctx.parentControl);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngClass", ctx.config.labelLeft ? "col-sm-" + ctx.config.controlCols : null);
    } }, directives: [FormLabelComponent, ɵngcc2.NgClass], styles: [_c7] });
FormSelectWrapperComponent.ctorParameters = () => [];
FormSelectWrapperComponent.propDecorators = {
    parentControl: [{ type: Input }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(FormSelectWrapperComponent, [{
        type: Component,
        args: [{
                selector: 'dynamic-form-select-wrapper',
                template: "<div\n    class=\"dynamic-field form-select\"\n    [class.has-error]=\"hasError\"\n    [class.space-for-validation]=\"!config.insideBoxValidation && !config.labelLeft\"\n    [class.form-horizontal]=\"config.labelLeft\"\n    [class.form-group]=\"config.labelLeft\"\n>\n    <dynamic-form-label [parentControl]=\"parentControl\"></dynamic-form-label>\n    <span [ngClass]=\"config.labelLeft ? 'col-sm-' + config.controlCols : null\">\n        <ng-content></ng-content>\n    </span>\n</div>\n",
                styles: [`
            .space-for-validation {
                margin-bottom: 15px;
            }
        `]
            }]
    }], function () { return []; }, { parentControl: [{
            type: Input
        }] }); })();

class FormValidationMessageComponent {
}
FormValidationMessageComponent.ɵfac = function FormValidationMessageComponent_Factory(t) { return new (t || FormValidationMessageComponent)(); };
FormValidationMessageComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: FormValidationMessageComponent, selectors: [["dynamic-form-validation-message"]], inputs: { errorMessage: "errorMessage", insideBoxValidation: "insideBoxValidation" }, decls: 2, vars: 1, consts: [["class", "small errortext", 3, "position", "inside-box-validation", "innerHtml", 4, "ngIf"], [1, "small", "errortext", 3, "innerHtml"]], template: function FormValidationMessageComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, FormValidationMessageComponent_div_0_Template, 1, 5, "div", 0);
        ɵngcc0.ɵɵtext(1, "\n");
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ctx.errorMessage);
    } }, directives: [ɵngcc2.NgIf], styles: [".inside-box-validation[_ngcontent-%COMP%] {\n                position: relative !important;\n                top: -35px;\n                bottom: -35px;\n                margin-bottom: -35px;\n                right: 3px;\n                float: right;\n                font-size: 70%;\n            }"] });
FormValidationMessageComponent.propDecorators = {
    errorMessage: [{ type: Input }],
    insideBoxValidation: [{ type: Input }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(FormValidationMessageComponent, [{
        type: Component,
        args: [{
                selector: 'dynamic-form-validation-message',
                template: "<div\n    *ngIf=\"errorMessage\"\n    class=\"small errortext\"\n    [style.position]=\"'absolute'\"\n    [class.inside-box-validation]=\"insideBoxValidation\"\n    [innerHtml]=\"errorMessage\"\n></div>\n",
                styles: [`
            .inside-box-validation {
                position: relative !important;
                top: -35px;
                bottom: -35px;
                margin-bottom: -35px;
                right: 3px;
                float: right;
                font-size: 70%;
            }
        `]
            }]
    }], null, { errorMessage: [{
            type: Input
        }], insideBoxValidation: [{
            type: Input
        }] }); })();

/**
 * email validator that returns valid when the value is empty
 * @param control
 */
function emailEmptyAcceptedValidator(control) {
    if (!control.value) {
        return null;
    }
    return Validators.email(control);
}

class AddressDynamicFields {
    constructor(address, states, countries, formGroup = 'Address') {
        this.formGroup = formGroup;
        this.Address1 = this.getDynamicFieldAddress1(address);
        this.Address2 = this.getDynamicFieldAddress2(address);
        this.City = this.getDynamicFieldCity(address);
        this.InternationalCity = this.getDynamicFieldCity(address, false);
        this.Province = this.getDynamicFieldProvince(address);
        this.Zip = this.getDynamicFieldZip(address);
        this.InternationalZip = this.getDynamicFieldZip(address, false);
        this.State = this.getDynamicFieldState(address, states);
        this.Country = this.getDynamicFieldCountry(address, countries);
    }
    getDynamicFieldAddress1(value, required = true, maxLength = 50) {
        return new DynamicField({
            formGroup: this.formGroup,
            label: 'Address 1',
            name: 'Address1',
            type: new DynamicFieldType({ fieldType: DynamicFieldTypes.Input }),
            validation: required ? [Validators.required, Validators.maxLength(maxLength)] : [Validators.maxLength(maxLength)],
            validators: required ? { required: true, maxlength: maxLength } : { maxlength: maxLength },
            value: value.Address1,
        });
    }
    getDynamicFieldAddress2(value, required = false, maxLength = 50) {
        return new DynamicField({
            formGroup: this.formGroup,
            label: 'Address 2',
            name: 'Address2',
            type: new DynamicFieldType({ fieldType: DynamicFieldTypes.Input }),
            validation: required ? [Validators.required, Validators.maxLength(maxLength)] : [Validators.maxLength(maxLength)],
            validators: required ? { required: true, maxlength: maxLength } : { maxlength: maxLength },
            value: value.Address2,
        });
    }
    getDynamicFieldCity(value, required = true, maxLength = 50) {
        return new DynamicField({
            formGroup: this.formGroup,
            label: 'City',
            name: 'City',
            type: new DynamicFieldType({ fieldType: DynamicFieldTypes.Input }),
            validation: required ? [Validators.required, Validators.maxLength(maxLength)] : [Validators.maxLength(maxLength)],
            validators: required ? { required: true, maxlength: maxLength } : { maxlength: maxLength },
            value: value.City,
        });
    }
    getDynamicFieldZip(value, required = true, maxLength = 10) {
        return new DynamicField({
            formGroup: this.formGroup,
            label: 'Zip',
            name: 'Zip',
            type: new DynamicFieldType({ fieldType: DynamicFieldTypes.Input }),
            validation: required ? [Validators.required, Validators.maxLength(maxLength)] : [Validators.maxLength(maxLength)],
            validators: required ? { required: true, maxlength: maxLength } : { maxlength: maxLength },
            value: value.Zip,
        });
    }
    getDynamicFieldProvince(value, required = false, maxLength = 50) {
        return new DynamicField({
            formGroup: this.formGroup,
            label: 'Province',
            name: 'Province',
            type: new DynamicFieldType({ fieldType: DynamicFieldTypes.Input }),
            validation: required ? [Validators.required, Validators.maxLength(maxLength)] : [Validators.maxLength(maxLength)],
            validators: required ? { required: true, maxlength: maxLength } : { maxlength: maxLength },
            value: value.Province,
        });
    }
    getDynamicFieldState(value, states) {
        return new DynamicField({
            formGroup: this.formGroup,
            label: 'State',
            name: 'StateCode',
            options: states,
            type: new DynamicFieldType({ fieldType: DynamicFieldTypes.Select, inputType: SelectInputTypes.Dropdown }),
            validation: [Validators.required],
            validators: { required: true },
            value: value.StateCode,
        });
    }
    getDynamicFieldCountry(value, countries) {
        return new DynamicField({
            formGroup: this.formGroup,
            label: 'Country',
            name: 'CountryCode',
            options: countries,
            type: new DynamicFieldType({ fieldType: DynamicFieldTypes.Select, inputType: SelectInputTypes.Dropdown }),
            validation: [Validators.required],
            validators: { required: true },
            value: value.CountryCode,
        });
    }
}

class MtAddressComponent {
    constructor(injector, changeDetectorRef) {
        this.injector = injector;
        this.changeDetectorRef = changeDetectorRef;
        /**
         * boolean to toggle the primary checkbox
         */
        this.showIsPrimary = true;
        /**
         * allow international addresses
         */
        this.allowInternationalAddresses = false;
        this.states = [];
        this.countries = [];
        this._addressIsInternational = false;
    }
    get addressIsInternational() {
        return this._addressIsInternational;
    }
    set addressIsInternational(value) {
        this._addressIsInternational = value;
        this.changeDetectorRef.detectChanges();
    }
    ngOnInit() {
        const config = this.injector.get(DynamicFormModuleConfig);
        const commonServiceInjectorToken = config.commonService;
        this.commonService = this.injector.get(commonServiceInjectorToken);
        forkJoin([this.commonService.getStates(), this.commonService.getCountries()]).subscribe((answers) => {
            const [states, countries] = answers;
            this.states = states.map((state) => ({ Id: state.StateCode, Name: state.Name }));
            this.countries = countries.map((country) => ({ Id: country.CountryCode, Name: country.Name }));
            this.loadForm();
        });
    }
    loadForm() {
        if (!this.parentForm) {
            this.parentForm = new FormGroup({});
        }
        if (this.addressContainer.Address.Id) {
            this.parentForm.addControl('Id', new FormControl(this.addressContainer.Address.Id));
        }
        if (this.addressContainer.AddressId) {
            this.parentForm.addControl('AddressId', new FormControl(this.addressContainer.AddressId));
        }
        if (this.showIsPrimary) {
            this.parentForm.addControl('IsPrimary', new FormControl(this.addressContainer.IsPrimary ? true : false));
        }
        this.parentForm.addControl('CountryCode', new FormControl(this.addressContainer.Address.CountryCode, Validators.required));
        this.fields = new AddressDynamicFields(this.addressContainer.Address, this.states, this.countries);
        this.addressIsInternational = this.addressContainer.Address.CountryCode !== 'US';
    }
    onCountryChange(countryCode) {
        this.addressIsInternational = countryCode !== 'US';
    }
}
MtAddressComponent.ɵfac = function MtAddressComponent_Factory(t) { return new (t || MtAddressComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Injector), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef)); };
MtAddressComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: MtAddressComponent, selectors: [["mt-address"]], inputs: { showIsPrimary: "showIsPrimary", allowInternationalAddresses: "allowInternationalAddresses", parentForm: "parentForm", addressContainer: "addressContainer" }, decls: 3, vars: 1, consts: [[3, "formGroup", 4, "ngIf"], [3, "formGroup"], [3, "field", "form", "overrideForm", "removeControlOnDestroy", "valueChanges", 4, "ngIf"], [3, "field", "form", "overrideForm"], [3, "field", "form", "overrideForm", 4, "ngIf"], [3, "marginBottom", 4, "ngIf"], [3, "field", "form", "overrideForm", "removeControlOnDestroy", "valueChanges"], ["type", "checkbox", "formControlName", "IsPrimary"]], template: function MtAddressComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtext(0, "\n        ");
        ɵngcc0.ɵɵtemplate(1, MtAddressComponent_div_1_Template, 22, 15, "div", 0);
        ɵngcc0.ɵɵtext(2, "\n    ");
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.fields);
    } }, directives: [ɵngcc2.NgIf, ɵngcc1.NgControlStatusGroup, ɵngcc1.FormGroupDirective, DynamicFieldComponent, ɵngcc1.CheckboxControlValueAccessor, ɵngcc1.NgControlStatus, ɵngcc1.FormControlName], encapsulation: 2 });
MtAddressComponent.ctorParameters = () => [
    { type: Injector },
    { type: ChangeDetectorRef }
];
MtAddressComponent.propDecorators = {
    addressContainer: [{ type: Input }],
    parentForm: [{ type: Input }],
    showIsPrimary: [{ type: Input }],
    allowInternationalAddresses: [{ type: Input }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(MtAddressComponent, [{
        type: Component,
        args: [{
                selector: 'mt-address',
                template: `
        <div *ngIf="fields" [formGroup]="parentForm">
            <dynamic-field
                *ngIf="allowInternationalAddresses"
                [field]="fields.Country"
                [form]="parentForm"
                [overrideForm]="true"
                [removeControlOnDestroy]="false"
                (valueChanges)="onCountryChange($event)"
            ></dynamic-field>
            <dynamic-field [field]="fields.Address1" [form]="parentForm" [overrideForm]="true"></dynamic-field>
            <dynamic-field [field]="fields.Address2" [form]="parentForm" [overrideForm]="true"></dynamic-field>
            <dynamic-field *ngIf="!addressIsInternational" [field]="fields.City" [form]="parentForm" [overrideForm]="true"></dynamic-field>
            <dynamic-field
                *ngIf="addressIsInternational"
                [field]="fields.InternationalCity"
                [form]="parentForm"
                [overrideForm]="true"
            ></dynamic-field>
            <dynamic-field *ngIf="!addressIsInternational" [field]="fields.State" [form]="parentForm" [overrideForm]="true"></dynamic-field>
            <dynamic-field *ngIf="addressIsInternational" [field]="fields.Province" [form]="parentForm" [overrideForm]="true"></dynamic-field>
            <dynamic-field *ngIf="!addressIsInternational" [field]="fields.Zip" [form]="parentForm" [overrideForm]="true"></dynamic-field>
            <dynamic-field *ngIf="addressIsInternational" [field]="fields.InternationalZip" [form]="parentForm" [overrideForm]="true"></dynamic-field>
            <div *ngIf="showIsPrimary" [style.marginBottom.px]="15">
                <input type="checkbox" formControlName="IsPrimary" />
                <label>Primary Address</label>
            </div>
        </div>
    `
            }]
    }], function () { return [{ type: ɵngcc0.Injector }, { type: ɵngcc0.ChangeDetectorRef }]; }, { showIsPrimary: [{
            type: Input
        }], allowInternationalAddresses: [{
            type: Input
        }], parentForm: [{
            type: Input
        }], addressContainer: [{
            type: Input
        }] }); })();

class PhoneMaskDirective {
    constructor(elementRef) {
        this.elementRef = elementRef;
        this.el = this.elementRef.nativeElement;
    }
    ngOnInit() {
        this.el.value = formatPhone(this.el.value);
    }
    onInput(value) {
        this.el.value = formatPhone(value.replace(/\D/g, ''));
    }
}
PhoneMaskDirective.ɵfac = function PhoneMaskDirective_Factory(t) { return new (t || PhoneMaskDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef)); };
PhoneMaskDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: PhoneMaskDirective, selectors: [["", "phoneMask", ""]], hostBindings: function PhoneMaskDirective_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("input", function PhoneMaskDirective_input_HostBindingHandler($event) { return ctx.onInput($event.target.value); });
    } } });
PhoneMaskDirective.ctorParameters = () => [
    { type: ElementRef }
];
PhoneMaskDirective.propDecorators = {
    onInput: [{ type: HostListener, args: ['input', ['$event.target.value'],] }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(PhoneMaskDirective, [{
        type: Directive,
        args: [{
                selector: '[phoneMask]'
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }]; }, { onInput: [{
            type: HostListener,
            args: ['input', ['$event.target.value']]
        }] }); })();

// since we are overriding the _initObservables, needed to rewrite
// the methods code it already had, which included setting the
// EventEmitters for valueChanges and statusChanges
AbstractControl.prototype._initObservables = function () {
    this.valueChanges = new EventEmitter();
    this.statusChanges = new EventEmitter();
    this.mtExternalFocusEvent = new EventEmitter();
    this.mtSetRequiredEvent = new EventEmitter();
};
/**
 * The MtFocus event requires the element that you are trying to focus is visible
 * and added to the form.  You may need to put this on a setTimeout and play with
 * the duration if you are calling this when the page is loaded
 */
AbstractControl.prototype.mtFocus = function () {
    this.mtExternalFocusEvent.emit();
};
AbstractControl.prototype.mtSetRequired = function (required) {
    this.mtSetRequiredEvent.emit(required);
};
// *********************************************************
// * END extension of FormControl
// *********************************************************
class DynamicFormModule {
}
DynamicFormModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: DynamicFormModule });
DynamicFormModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function DynamicFormModule_Factory(t) { return new (t || DynamicFormModule)(); }, imports: [[
            CommonModule,
            NumericControlModule,
            TimepickerControlModule,
            ReactiveFormsModule,
            FormsModule,
            NgbModule,
            MultiselectControlModule,
            TypeAheadModule,
            MtColorPickerControlModule,
            WysiwygModule,
        ], ReactiveFormsModule,
        FormsModule,
        NumericControlModule] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(DynamicFormModule, { declarations: function () { return [DynamicFieldDirective, DynamicFormComponent, FormCheckBoxComponent, FormPasswordComponent, FormNumericComponent, DynamicViewComponent, FormMtAddressComponent, DynamicFieldComponent, MtAddressComponent, PhoneMaskDirective, FormTextboxComponent, FormWYSIWYGComponent, FormLabelComponent, FormInputWrapperComponent, FormSelectWrapperComponent, FormTypeAheadComponent, FormPhoneComponent, FormTextareaComponent, FormDatePickerComponent, FormTimePickerComponent, FormDatetimePickerComponent, FormColorPickerComponent, FormDateInputComponent, FormDateTimeInputComponent, FormTagsComponent, FormDropdownComponent, FormMultiSelectDropdownComponent, FormOldStyleMultiSelectDropdownComponent, FormRadioButtonListComponent, FormOldStyleRadioButtonListComponent, FormValidationMessageComponent]; }, imports: function () { return [CommonModule,
        NumericControlModule,
        TimepickerControlModule,
        ReactiveFormsModule,
        FormsModule,
        NgbModule,
        MultiselectControlModule,
        TypeAheadModule,
        MtColorPickerControlModule,
        WysiwygModule]; }, exports: function () { return [DynamicFormComponent, DynamicViewComponent, ReactiveFormsModule,
        FormsModule,
        NumericControlModule, DynamicFieldComponent, MtAddressComponent, FormLabelComponent, FormInputWrapperComponent, FormSelectWrapperComponent, FormValidationMessageComponent]; } }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DynamicFormModule, [{
        type: NgModule,
        args: [{
                declarations: [
                    DynamicFieldDirective,
                    DynamicFormComponent,
                    FormCheckBoxComponent,
                    FormPasswordComponent,
                    FormNumericComponent,
                    DynamicViewComponent,
                    FormMtAddressComponent,
                    DynamicFieldComponent,
                    MtAddressComponent,
                    PhoneMaskDirective,
                    FormTextboxComponent,
                    FormWYSIWYGComponent,
                    FormLabelComponent,
                    FormInputWrapperComponent,
                    FormSelectWrapperComponent,
                    FormTypeAheadComponent,
                    FormPhoneComponent,
                    FormTextareaComponent,
                    FormDatePickerComponent,
                    FormTimePickerComponent,
                    FormDatetimePickerComponent,
                    FormColorPickerComponent,
                    FormDateInputComponent,
                    FormDateTimeInputComponent,
                    FormTagsComponent,
                    FormDropdownComponent,
                    FormMultiSelectDropdownComponent,
                    FormOldStyleMultiSelectDropdownComponent,
                    FormRadioButtonListComponent,
                    FormOldStyleRadioButtonListComponent,
                    FormValidationMessageComponent,
                ],
                entryComponents: [
                    FormCheckBoxComponent,
                    FormPasswordComponent,
                    FormNumericComponent,
                    FormMtAddressComponent,
                    FormTextboxComponent,
                    FormWYSIWYGComponent,
                    FormLabelComponent,
                    FormInputWrapperComponent,
                    FormSelectWrapperComponent,
                    FormTypeAheadComponent,
                    FormPhoneComponent,
                    FormTextareaComponent,
                    FormDatePickerComponent,
                    FormTimePickerComponent,
                    FormDatetimePickerComponent,
                    FormColorPickerComponent,
                    FormDateInputComponent,
                    FormDateTimeInputComponent,
                    FormTagsComponent,
                    FormDropdownComponent,
                    FormMultiSelectDropdownComponent,
                    FormOldStyleMultiSelectDropdownComponent,
                    FormRadioButtonListComponent,
                    FormOldStyleRadioButtonListComponent,
                    FormValidationMessageComponent,
                ],
                exports: [
                    DynamicFormComponent,
                    DynamicViewComponent,
                    ReactiveFormsModule,
                    FormsModule,
                    NumericControlModule,
                    DynamicFieldComponent,
                    MtAddressComponent,
                    FormLabelComponent,
                    FormInputWrapperComponent,
                    FormSelectWrapperComponent,
                    FormValidationMessageComponent,
                ],
                imports: [
                    CommonModule,
                    NumericControlModule,
                    TimepickerControlModule,
                    ReactiveFormsModule,
                    FormsModule,
                    NgbModule,
                    MultiselectControlModule,
                    TypeAheadModule,
                    MtColorPickerControlModule,
                    WysiwygModule,
                ]
            }]
    }], null, null); })();

/**
 * Generated bundle index. Do not edit.
 */

export { AddressDynamicFields, CustomFormControlComponentBase, CustomFormValidation, DatepickerDateOptionItem, DynamicConfig, DynamicControls, DynamicField, DynamicFieldComponent, DynamicFieldDirective, DynamicFieldType, DynamicFieldTypes, DynamicFormComponent, DynamicFormModule, DynamicLabel, DynamicViewComponent, FormCheckBoxComponent, FormColorPickerComponent, FormDateInputComponent, FormDatePickerComponent, FormDateTimeInputComponent, FormDatetimePickerComponent, FormDropdownComponent, FormElementsBase, FormInputWrapperComponent, FormLabelComponent, FormMtAddressComponent, FormMultiSelectDropdownComponent, FormNumericComponent, FormOldStyleMultiSelectDropdownComponent, FormOldStyleRadioButtonListComponent, FormPasswordComponent, FormPhoneComponent, FormRadioButtonListComponent, FormSelectBaseWithNullableOption, FormSelectWrapperComponent, FormTagsComponent, FormTextareaComponent, FormTextboxComponent, FormTimePickerComponent, FormTypeAheadComponent, FormValidationMessageComponent, FormWYSIWYGComponent, InputTypes, LabelPosition, LabelPositions, MtAddressComponent, NumericInputTypes, SelectInputTypes, emailEmptyAcceptedValidator, getControlFromFormGroup, getGroupFromConfig, isString, noZeroRequiredValidator, DynamicFormModuleConfig as ɵa, PhoneMaskDirective as ɵc };

//# sourceMappingURL=mt-ng2-dynamic-form.js.map